var _patternDesignWidget = _patternDesignWidget || {}; // Not working with "let"
window.pd = _patternDesignWidget; // For backward compatibility
_patternDesignWidget.accessToken = '1946-91433194989103-7856398271-0650f7384af19d8382f88d9d58b8412a244a964d1757b2fc4a940bffbbd10d8d';
// when you need to add content to the widget (as the button above) use this function which is invoked when the widget is ready
_patternDesignWidget.touchFriendlySliders = true; // recommended for better slider behavior on mobile
//_patternDesignWidget.useAvailableJQueryInstance = true; // Have the widget use the jQuery instance that already exists on the page
_patternDesignWidget.showScaleSlider = false; //show the slider which is provided by the widget for changing the scale

//The minimum and maximum values for the slider can be set via
_patternDesignWidget.scaleMin = 30;
_patternDesignWidget.scaleMax = 200;

let patternDesignApiUrl = 'https://apitest.patterndesigns.com/api/rest/1.0/1955-91433194989103-7851790263-65d7dfa538d67a991da2fcdcd93bfaa555535ccd3d3de1ff5f73a446cc86a850/';
let vectEezyApiKey = 'ckqqJXkU3ze6PbS6eSHU7fTr';

defaultUnlimited3DApiCdn = 'https://distcdn.unlimited3d.com/pres/v/3.0.28/unlimited3d.min.js';

// Set JSON Cookies
$.cookie.raw = true;
$.cookie.json = true;

// Set Dropzone auto discover to false
Dropzone.autoDiscover = false;

const version = '1.0.7';

let App = {

    product_id: null,
    customer: {},
    selected_part: null,
    selected_layer: null,
    data: {},
    available_parts: [],
    layers: {},
    model: null,
    product_schema: null,
    product_options: null,
    configurator_options: [],
    product_material_color: null,
    product_config: null,
    product_pair_parts: null,
    pair_side: 'right',
    thumb: null,
    preview_ready: false,
    preview_failed: false,
    thumb_width: 600,
    thumb_height: 600,
    image_bytes_limit: 15 * 1024 * 1024,
    scale_factor: {
        image: 2,
        bg_image: 1,
        bg_pattern: 1,
        text: 1
    },
    selected_pattern: null,
    check_leave: false,
    has_configurator: false,
    parts_slider: null,
    default_transition: null,
    prev_bg: null,

    loadUnlimited3D: function (callback) {

        let cdn_url = typeof model_data != 'undefined' && model_data.options && model_data.options.cdn
            ? model_data.options.cdn
            : defaultUnlimited3DApiCdn;

        if (!cdn_url) {
            console.error('App.loadUnlimited3D: No CDN URL found in model_data.options.cdn');
            return;
        }

        if (typeof Unlimited3D != 'undefined') {
            callback();
            return;
        }

        let script = document.createElement('script');
        script.src = cdn_url;
        script.onload = function () {
            console.log('Unlimited3D loaded from: ' + cdn_url);
            callback();
        };
        script.onerror = function () {
            console.error('App.loadUnlimited3D: Failed to load script from: ' + cdn_url);
        };
        document.head.appendChild(script);
    },

    init: function () {

        let self = this;

        App.has_configurator = $('#product_customizer').length;

        if (App.has_configurator) {
            App.textLayer.textFonts.init();
        }

        App.product_id = $('body').data('product_id') !== '' ? $('body').data('product_id') : null;
        App.customer = $('body').data('customer_id') !== '' ?
            {
                id: $('body').data('customer_id'),
                email: $('body').data('customer_email'),
                first_name: $('body').data('customer_first_name'),
                last_name: $('body').data('customer_last_name'),
            } :
            {};

        if (typeof model_data != 'undefined') {

            //let mobile_device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

            App.product_schema = model_data['schema'];
            App.product_options = typeof model_data['mobile_options'] != 'undefined' ?
                model_data['mobile_options'] :
                model_data['options'];
            App.product_material_color = model_data['base_material_color'];
            App.product_pair_parts = typeof model_data['pair_parts'] != 'undefined' ? model_data['pair_parts'] : null;
            App.combined_part_id = model_data['combined_part_id'] || null;
            App.uv_size_px  = model_data['uv_size_px'] || 1024;
            App.default_transition  = model_data['default_transition'] || null;

            console.log('Model distID: ' + App.product_options.distID);

            console.log('App.product_schema: ', App.product_schema);
            console.log('self.product_options: ', self.product_options);

            App.configurator_options['onLoadingChanged'] = function (loading) {
                // console.log('Loading ' + loading.progress + '%');
            };
            App.configurator_options['onPointerClick'] = function (objectsClicked) {
                App.modelActions.onPointerClick(objectsClicked);
            };

            App.configurator_options['onPointerMove'] = function (e) {
                const combined_part = App.combined_part_id;

                const items = e?.filter(d => d.type === "part" && d.shortName === combined_part);

                const item = items.pop();
                if (!item) return;

                const uv = self.extractUV(item.uv);
                if (!uv) return;

                App.modelActions.onPointerMove(uv);
            };

            App.configurator_options['onTrigger'] = function (trigger) {
                const combined_part = App.combined_part_id;
                const item = trigger.data?.filter(d => d.type === "part" && d.shortName === combined_part).pop();

                if (trigger.type === "PointerUp") {
                    console.log('[POINTER] PointerUp');

                    App.modelActions.onPointerUp();
                }
                if (!item) return;

                const uv = self.extractUV(item.uv);

                if (!uv) return;

                if (trigger.type === "PointerDown") {
                    App.modelActions.onPointerDown(uv);
                }
            }

            if ($('#sw_model_preview').length && !open_configurator) {
                const previewOptions = {
                    ...App.product_options,
                    containerID: 'container3d_preview',
                    onLoadingChanged: (loading) => {
                        if (loading.loadedAssets === loading.totalAssets) {
                            setTimeout(function() {
                                console.log('Remove d-none from #overlay_3d_preview');
                                $('#overlay_3d_preview').show();
                            }, 500);
                        }
                    }
                };
                console.log(' ------- previewOptions: ', previewOptions);

                Unlimited3D.init(previewOptions , {}, function (e) {

                    if (e) {
                        console.log('Preview Unlimited3D.init ERROR: ', e);
                        App.preview_failed = true;
                        App.design.showThumbInPdp(); // fallback to thumbnail
                        $('.js-sw-show-config').removeClass('disabled');
                        return;
                    }

                    App.applyPredefinedConfig();

                    App.preview_ready = true;

                    if (!$.isEmptyObject(App.layers)) {
                        App.loadModelConfiguration();
                    }

                    $('.js-sw-show-config').removeClass('disabled');
                });
            } else {
                $('.js-sw-show-config').removeClass('disabled');
            }
        }

        // Init Design functionality
        App.design.init();

        $(document).on('touchstart click', '#container3d_replace', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('#overlay_3d').addClass('d-none');
        });

        $(document).on('touchstart click', '#overlay_3d', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('#overlay_3d').addClass('d-none');
        });

        $(document).on('touchstart click', '#container3d_preview', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $('#overlay_3d_preview').hide();
        });

        $(document).on('touchstart click', '#overlay_3d_preview', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $('#overlay_3d_preview').hide();
        });

        // Show config on BTN click
        $(document).on('click', '.js-sw-show-config', function () {

            App.showLoading();

            // If we have model schema and options
            if (typeof model_data != 'undefined') {
                App.initConfigurator();
            }
            else {
                App.hideLoading();
                alert('Product model schema is not defined!');
            }
        });

        // Hide config on BTN click
        $(document).on('click', '.js-sw-hide-config', function () {
            App.showLoading();

            App.editingLineKey = null;

            let product_url = App.removeUrlParameter(location.href, ['edit', 'line', 'design_id', 'order_id', 'type']);

            if (product_url !== location.href) {
                window.location.href = product_url;
            }
            else {
                App.check_leave = false;
                App.hideConfigurator();
            }
        });

        if (!open_configurator) {
            App.hideLoading();
        }

        App.initModalActions();
    },

    initActions: function () {

        let self = this;

        // Unlimited3D.init() may fire its ready callback more than once
        // (e.g. on asset re-load when opening a saved/artist design).
        // Without this guard every $(document).on(...) handler below and
        // every layer init runs twice.
        if (App.actions_initialized) {
            console.log('App.initActions already ran - skipping');

            // initActions() ends with hideLoading() - still needed here,
            // otherwise the loading overlay stays up on the repeat callback
            App.hideLoading();
            return;
        }
        App.actions_initialized = true;

        let is_high_top = $('body').hasClass('page--timeless-high-top');

        window.onbeforeunload = function () {

            if (App.has_configurator && App.check_leave && $('#product_customizer').hasClass('active')) {
                return "Changes that you made to this model will be lost!";
            } else {
                return;
            }
        };

        // Get 3D model data
        //App.get3dData();

        self.parts_slider = new Swiper('.js-parts-swiper', {
            slidesPerView: 'auto',
            freeMode: true,
            spaceBetween: 0,
            watchOverflow: true,
            navigation: {
                nextEl: ".js-parts-swiper-next",
                prevEl: ".js-parts-swiper-prev",
            }
        });

        // Apply designer/artist config
        App.applyPredefinedConfig();

        // Load Local Storage configuration
        // App.loadConfigFromLocalStorage();

        // Get available parts from product Schema
        App.getAvailableParts();

        // Show available and hide not available tabs based on product Schema
        App.showAvailableTabs();

        // Set file limit string
        let size_limit = parseFloat(App.image_bytes_limit / (1024*1024)).toFixed(2);
        $('.js-max-file-size').text(size_limit+'MB');

        // Init Image Layer functionality
        App.imageLayer.init();

        // Init Background Layer functionality
        App.backgroundLayer.init();

        // Init Text Layer functionality
        App.textLayer.init();

        // Show customise shoe modal
        if (!sessionStorage.getItem('customise_shoe_modal_shown') && is_high_top) {
            $('#sw_product_config_modal_customise_shoe').modal('show');
        }

        $(document).on('click', '.js-sw-add-to-cart', function() {
            App.check_leave = false;

            self.addToCartAndSaveThumbnail();
        });

        // Select part and hide layers on tab change
        $('#components .nav-link').on('shown.bs.tab', function (event) {

            let tab = $(event.target).attr('id');
            let part = self.getPartFromTab(tab);

            if (part) {
                App.setSelectedLayer(null);
                $('.action-container').addClass('d-none');
                $('#components').removeClass('d-none');
                App.toggleCustomizerButtons(0);
                App.selectPart(part);
            }
        });

        App.setAvailableLayersByPart();

        // Select All Over part
        $('.sw-parts-nav .nav-link').first().tab('show');

        // Close desktop dropdowns on link click
        $(document).on('click', '.sw-desktop-dropdown .js-sw-select-size, .sw-desktop-dropdown .js-sw-select-tab', function () {
            $(this).closest('.btn-group').find('.sw-desktop-dropdown').removeClass('show');
            $(this).closest('.btn-group').find('.sw-desktop-dropdown-toggle').removeClass('show').attr('aria-expanded', false);
        });

        $(document).on('click', '.js-sw-select-tab', function () {
            let tab_id = $(this).data('tab');
            let tab = $('#' + tab_id);

            if (tab.length) {
                tab.tab('show');
            }
        });

        // Show add background container
        $(document).on('click', '.js-sw-edit-layers', function (event) {
            $('#components .tab-pane.active').find('.js-sw-layers').addClass('show-on-mobile');
        });

        // Close action container and show components
        $(document).on('click', '.js-sw-close-edit-layers', function (event) {

            console.log('js-sw-close-edit-layers clicked');

            $(this).closest('.js-sw-layers').removeClass('show-on-mobile');
        });

        // Show add bg color container
        $(document).on('click', '.add-bg-color', function (event) {

            let bg_color = App.product_material_color;
            let bg_all_over = false;

            App.toggleCustomizerButtons(1);

            if (App.layers[App.selected_part]) {

                let part_config = App.layers[App.selected_part];
                let config = part_config['bg'];

                console.log('config: ', config);

                if (typeof config != 'undefined') {
                    if (config.type === 'color') {
                        bg_color = config.data;
                        bg_all_over = !!config.all_over;
                    }
                }
            }

            $('.action-container').addClass('d-none');
            $('#add_bg_color').removeClass('d-none');

            App.storePartsBG();

            App.backgroundLayer.updateBgColorForm(bg_color, bg_all_over);
        });

        // Show add bg image container
        $(document).on('click', '.add-bg-image', function (event) {

            let bg_schema = App.product_schema[App.selected_part].bg;
            let bg_image_config = bg_schema;
            let bg_all_over = false;

            App.toggleCustomizerButtons(1);

            if (App.layers[App.selected_part]) {

                let part_config = App.layers[App.selected_part];
                let config = part_config['bg'];

                console.log('config: ', config);

                if (typeof config != 'undefined' && config.type === 'image') {
                    bg_image_config = config.data;
                    bg_all_over = !!config.all_over;
                }
            }

            App.backgroundLayer.updateBgImgForm(bg_image_config, bg_all_over);

            App.storePartsBG();

            $('.action-container').addClass('d-none');
            $('#add_bg_image').removeClass('d-none');
        });

        // Show add bg pattern container
        $(document).on('click', '.add-bg-pattern', function (event) {

            let bg_schema = App.product_schema[App.selected_part].bg;

            App.updateSelectedPattern();

            if (App.selected_pattern) {
                $('#sw_product_config_modal_pattern').modal('show');
            }
            else {
                $('#pattern_design_modal').modal('show');
            }

            App.storePartsBG();
        });

        // Show add layer container
        $(document).on('click', '.add-layer', function (event) {
            $('.action-container').addClass('d-none');
            $('#add_layer').removeClass('d-none');
        });

        // Show add image container
        $(document).on('click', '.add-image', function (event) {
            App.toggleCustomizerButtons(1);

            if (App.selected_part && App.product_schema[App.selected_part].img) {

                let index = self.getNextLayerIndex('img');

                $('#img_form').data('index', index);

                // Default параметри от панела (обект, не масив)
                let image_schema = App.product_schema[App.selected_part].img;

                console.log('index: ', index);
                console.log('image_schema: ', image_schema);

                if (image_schema) {
                    App.imageLayer.updateImgForm(image_schema);
                }

                $('.action-container').addClass('d-none');
                $('#add_image').removeClass('d-none');

            } else {
                alert('This part has no Image Layer');
            }
        });

        $(document).on('click', '.add-vecteezy', function (event) {

            App.toggleCustomizerButtons(1);

            if (App.selected_part && App.product_schema[App.selected_part].img) {

                $('#sw_vecteezy_modal').modal('show');

                let image_schema = App.product_schema[App.selected_part].img;

                if (typeof image_schema != 'undefined') {
                    App.imageLayer.updateImgForm(image_schema);
                }

                $('.action-container').addClass('d-none');
                $('#add_image').removeClass('d-none');

            } else {
                alert('This part has no Image Layer');
            }
        });

        $(document).on('click', '.add-ai-image', function (event) {

            App.toggleCustomizerButtons(1);

            if (App.selected_part && App.product_schema[App.selected_part].img) {

                $('#sw_ai_modal').modal('show');
            } else {
                alert('This part has no Image Layer');
            }
        });

        // Show add text container
        $(document).on('click', '.add-text', function (event) {

            App.toggleCustomizerButtons(1);

            if (App.selected_part && App.product_schema[App.selected_part].text) {

                let index = self.getNextLayerIndex('text');

                let text_schema = App.product_schema[App.selected_part].text;

                $('#text_form').data('index', index);

                $('.action-container').addClass('d-none');
                $('#add_text').removeClass('d-none');

                if (text_schema) {
                    App.textLayer.updateTextForm(text_schema);
                }
            } else {
                alert('This part has no text layer');
            }
        });

        // Close action container and show components
        $(document).on('click', '.js-close-action', function (event) {

            let action = $(this).attr('data-action') || null;

            console.log(' --- Close BTN Action:' , action);

            if (action) {
                switch (action) {
                    case 'show-part':
                        App.setSelectedLayer(null);

                        if (!$('#add_text').hasClass('d-none') && !$('#text').val().trim()) {
                            const text_index = $('#text_form').data('index') || 0;
                            const combined_id = App.combined_part_id;
                            if (combined_id && App.layers[combined_id]?.text?.[text_index] !== undefined) {
                                App.deleteLayerConfig(combined_id, 'text', null, text_index);
                                App.removeLayerFrom3d(combined_id, 'text', null, text_index);
                                App.updateProductConfig(App.layers);
                            }
                        }
                        break;

                    case 'reset-prev-bgs':
                        App.setSelectedLayer(null);
                        break;

                    case 'delete-bg-color':
                        App.deleteLayer(App.selected_part, 'bg', 'color', null);
                        break;

                    default:
                        console.log('Not supported close button Action: ', action);
                }
            }

            const tab_id = App.product_schema[App.selected_part]?.tab;
            const $tab = $('#' + tab_id);

            if ($tab.hasClass('active')) {
                $('.action-container').addClass('d-none');
                $('#components').removeClass('d-none');
                App.toggleCustomizerButtons(0);
                App.updateHasLayers();
            } else {
                $tab.tab('show'); // → shown.bs.tab → selectPart → updateHasLayers
            }
        });

        // Click on the edit layer button
        $(document).on('click', '.edit-layer', function () {

            let action_container_id = $(this).data('action');
            let type = $(this).data('type');
            let part = $(this).data('part');
            let part_config = App.layers[part];
            let part_schema = App.product_schema[part];

            App.toggleCustomizerButtons(1);

            App.storePartsBG();

            switch (type) {
                case 'img':

                    console.log('Case = "img"');

                    const imgIndex = $(this).data('index') || 0;
                    const imgConfig =  App.layers[App.combined_part_id]?.img?.[imgIndex];

                    App.setSelectedLayer({
                        type:  'img',
                        index: imgIndex,
                        data:  imgConfig
                    });

                    $('#img_form').data('index', imgIndex);


                    if (typeof imgConfig != 'undefined') {
                        App.imageLayer.updateImgForm(imgConfig);
                    } else {
                        console.log('No config found for part ' + part + ' and type ' + type);
                    }

                    $('.action-container').addClass('d-none');
                    $('#' + action_container_id).removeClass('d-none');
                    break;

                case 'text':

                    console.log('Case = "text"');

                    const textIndex = $(this).data('index') || 0;
                    const textConfig = App.layers[App.combined_part_id]?.text?.[textIndex];

                    console.log('TEXT INDEX: ', textIndex);

                    App.setSelectedLayer({
                        type:  'text',
                        index: textIndex,
                        data:  textConfig
                    });

                    $('#text_form').data('index', textIndex);

                    console.log('text_config: ', textConfig);

                    $('.action-container').addClass('d-none');
                    $('#' + action_container_id).removeClass('d-none');

                    if (typeof textConfig != 'undefined') {
                        App.textLayer.updateTextForm(textConfig);
                    }
                    break;
                case 'bg':

                    console.log('Case = "bg"');

                    App.setSelectedLayer({
                        type:  'bg',
                        index: null,
                        data:  App.layers[App.selected_part]?.bg?.data
                    });

                    let bg_config = part_config['bg'];

                    console.log('bg_config: ', bg_config);

                    $('.action-container').addClass('d-none');
                    $('#' + action_container_id).removeClass('d-none');

                    if (typeof bg_config != 'undefined') {
                        if (bg_config.type === 'image') {
                            App.backgroundLayer.updateBgImgForm(bg_config.data, bg_config.all_over);
                        } else if (bg_config.type === 'pattern') {
                            App.backgroundLayer.updateBgPatternForm(bg_config.data, bg_config.all_over);
                        } else {
                            App.backgroundLayer.updateBgColorForm(bg_config.data, bg_config.all_over);
                        }
                    } else {
                        console.log('No config found for part ' + part + ' and type ' + type);
                    }
                    break;
                default:
                    console.log('Not supported Edit action: ', action_container_id);
            }
        });

        // Click on the delete layer button
        $(document).on('click', '.delete-layer', function () {

            let part_name = $(this).data('part');
            let layer_type = $(this).data('type');
            let bg_type = typeof $(this).data('bg_type') != 'undefined' ? $(this).data('bg_type') : null;
            let index = $(this).data('index') || 0;

            console.log('part_name: ', part_name);
            console.log('layer_type: ', layer_type);
            console.log('bg_type: ', bg_type);
            console.log('index: ' + index);

            App.deleteLayer(part_name, layer_type, bg_type, index);
        });

        // Init switch functionality
        App.switchShoes.init();

        // Pattern designs selection changed
        _patternDesignWidget.designSelectionChanged = function () {
            console.log('PATTERN DESIGN - designSelectionChanged');
            console.log('design: ', _patternDesignWidget.selectedDesign);

            if (!$.isEmptyObject(_patternDesignWidget.selectedDesign)) {
                $('.js-select-pattern').removeAttr('disabled');
            }
            else {
                $('.js-select-pattern').attr('disabled', 'disabled');
            }
        }

        // Pattern designs scale updated
        _patternDesignWidget.scaleUpdated = function (scale, stop) {
            /* react to scale change, stop is a boolean value whether the user stopped dragging */

            console.log('PATTERN DESIGN - scaleUpdated');
            console.log('Scale: ' + scale + ' ; stop: ' + stop);
        };

        App.hideLoading();
    },

    setAvailableLayersByPart: function() {

        let self = this;

        console.log('App.setAvailableLayersByPart called!');

        $.each(App.product_schema, function (part_name, part_schema) {

            if (!part_schema || !part_schema.tab) return;

            let tab = part_schema.tab;
            let tab_content_id = tab.replace('-tab', '');

            console.log('part_schema: ', part_schema);
            console.log('tab_content_id: ', tab_content_id);

            if (typeof part_schema != 'undefined') {
                let no_image_layer = !part_schema['img'];
                $(`#${tab_content_id} .js-sw-layers-list .add-image`).toggleClass('disabled', no_image_layer);

                let no_text_layer = !part_schema['text'];
                $(`#${tab_content_id} .js-sw-layers-list .add-text`).toggleClass('disabled', no_text_layer);

                let only_bg_layers = !part_schema['img'] && !part_schema['text'];
                $(`#${tab_content_id} .js-sw-layers-list`).toggleClass('only-bg-layers', only_bg_layers);

                console.log('no_image_layer: ', no_image_layer);
                console.log('no_text_layer: ', no_text_layer);
                console.log('only_bg_layers: ', only_bg_layers);
            }
        });
    },



    initModalActions: function() {

        let self = this;

        console.log('App.initModalActions called');

        // PDP Modals
        let sizes_modal = $('#sw_product_config_modal_sizes');
        let parts_modal = $('#sw_product_config_modal_parts');
        let pattern_modal = $('#sw_product_config_modal_pattern');
        let confirm_modal = $('#sw_product_config_modal_close');
        let image_settings_modal = $('#sw_product_config_modal_image_settings');
        let check_left_shoe_modal = $('#sw_product_config_modal_check_left');

        $('.modal').on('show.bs.modal', function() {
            $('.modal.show').modal('hide');
        });

        App.addProductSizes();

        if (parts_modal.length) {

            $(document).on('click', '#sw_product_config_modal_parts .js-sw-select-tab', function () {
                parts_modal.modal('hide')
            });

            $(document).on('click', '.js-sw-select-tab', function () {
                $('.js-sw-selected-area').text($(this).text());

                $(this).closest('ul').find('a').removeClass('active');
                $(this).addClass('active');
            });

            $(document).on('click', '.sw-parts-nav .nav-link', function () {
                let parts_container = $('.sw-parts-list');

                parts_container.find('a').removeClass('active');
                parts_container.find('a[data-tab="' + $(this).attr('id') + '"]').addClass('active');

                $('.js-sw-selected-area').text($(this).text());
            });
        }

        if (sizes_modal.length) {

            // Set initial size
            let selected_size = $('.product-page--blocks .radios--input[name*="size"]:checked');

            $('.js-sw-selected-size').text(selected_size.val());
            $('.sw-size-options').find('a[data-size="' + selected_size.val() + '"]').addClass('active');

            $('#sw_product_config_modal_sizes .radios--input[value="' + selected_size.val() +'"]').prop('checked', true);

            // Set size from modal into product
            $(document).on('click', '.js-sw-select-size', function () {

                $(this).closest('ul').find('a').removeClass('active');
                $(this).addClass('active');

                // Set size in product
                $('.product-page--right-column .radios--input[value="' + $(this).data('size') + '"]').prop('checked', true).trigger('change');

                // Set size in configurator
                $('.js-sw-selected-size').text($(this).data('size'));

                sizes_modal.modal('hide');
            });

            // Set size from product into modal
            $(document).on('change', '.product-page--blocks .radios--input[name*="size"]', function () {

                // Set size in configurator
                $('.js-sw-selected-size').text($(this).val());

                let sizes_container = $('.sw-size-options');

                // Set size in modal
                sizes_container.find('a').removeClass('active');
                sizes_container.find('a[data-size="' + $(this).val() + '"]').addClass('active');

                let is_previously_shown = $.cookie('sw_size_chart_shown') || false;

                if ($('#sw_size_chart_modal').length && !is_previously_shown) {
                    $('#sw_size_chart_modal').modal('show');
                    $.cookie('sw_size_chart_shown', true, {path: '/', expires: 10 * 365});
                }

            });
        }

        if (pattern_modal.length) {

            // Apply pattern
            $(document).on('click', '#sw_product_config_modal_pattern .js-apply-bg-pattern', function () {

                console.log('Apply pattern clicked');

                console.log('SELECTED PATTERN: ', App.selected_pattern);

                if (App.selected_pattern && typeof App.selected_pattern.imageUrl != 'undefined') {

                    let img_url = App.selected_pattern.imageUrl;

                    $('#background_pattern img').attr('src', img_url);
                    $('#bg_pat_preview').attr('src', img_url);

                    $('#add_bg_pattern').addClass('has-selection');

                    $('#background_pattern img').one('load', function() {
                        let ratio = ($(this).height() / $(this).width()).toFixed(6);
                        App.backgroundLayer.bg_pattern_ratio = ratio;

                        console.log('BG Pattern Ratio calculated: ', ratio);

                        $('#scale_bg_pattern_y').val(($('#scale_bg_pattern_x').val()*ratio).toFixed(6));

                        App.backgroundLayer.addOrUpdateBgImages('pattern', img_url);
                    });
                }

                $('.action-container').addClass('d-none');
                $('#add_bg_pattern').removeClass('d-none');

                pattern_modal.modal('hide');
            });

            // Remove pattern
            $(document).on('click', '#sw_product_config_modal_pattern .js-remove-bg-pattern', function () {

                console.log('Remove pattern clicked');

                // Remove previously used pattern from all panels where it's applied
                $.each(App.layers, function(part_name, part_data) {
                    if (part_data.bg && part_data.bg.type === 'pattern') {
                        App.deleteLayer(part_name, 'bg', 'pattern', null);
                    }
                });

                pattern_modal.modal('hide');

                $('#pattern_design_modal').modal('show');
            });
        }

        if (confirm_modal.length) {

            $('#sw_product_config_modal_close').on('shown.bs.modal', function() {
                App.check_leave = false;

                if (App.editingLineKey) {
                    $('.js-sw-save-exit-design').addClass('d-none');
                    $('.js-sw-update-cart-design').removeClass('d-none');
                } else {
                    $('.js-sw-save-exit-design').removeClass('d-none');
                    $('.js-sw-update-cart-design').addClass('d-none');
                }
            });

            $(document).on('click', '.js-sw-save-exit-design', function() {

                App.check_leave = false;

                App.showLoading();

                App.design.save(true);
            });

            $(document).on('click', '.js-sw-update-cart-design', function() {

                App.check_leave = false;

                App.addToCartAndSaveThumbnail();
            });
        }

        if (image_settings_modal.length) {

            $('#sw_product_config_modal_image_settings').on('show.bs.modal', function(event) {
                let button = $(event.relatedTarget);
                let form = button.data('form');

                console.log('event: ', event);
                console.log('button: ', button);
                console.log('button.length: ', button.length);
                console.log('form: ', form);
                console.log('form.length: ', form.length);

                $(this).find('.js-sw-add-image-layer').data('form_id', form);
            });

            $('#sw_product_config_modal_image_settings').on('hide.bs.modal', function(event) {
                $(this).find('.js-sw-add-image-layer').data('form_id', 0);
                $(this).find('#flip_on_left_false').prop('checked', true);
            });

            $(document).on('click', '.js-sw-add-image-layer', function(event) {

                let form_id = $(this).data('form_id');
                let form = $(form_id);
                let flip_option_val = $('#flip_on_left_true').prop('checked');

                console.log('flip_option_val: ', flip_option_val);

                if (form.length) {

                    let file_input = form.find('input[type="file"]');
                    let option_input = form.find('input[name="flip_on_left"]');

                    console.log('file_input: ', file_input);
                    console.log(option_input);

                    // Opend file selector
                    file_input.click();

                    // Set flip option
                    option_input.prop('checked', flip_option_val);
                }

                image_settings_modal.modal('hide');
            });
        }

        if (check_left_shoe_modal.length) {
            $(document).on('click', '.js-sw-show-left-shoe', function(event) {
                App.switchShoes.showLeftRightShoe('left');

            });
        }
    },

    addProductSizes: function() {

        let self = this;

        console.log('App.addProductSizes called');

        let size_options = $('.product-page--blocks .radios--input[name*="size"]');
        let sizes_modal = $('#sw_product_config_modal_sizes');

        if (sizes_modal.length) {
            $.each(size_options, function(key, option) {

                let id = $(option).attr('id');
                let value = $(option).val();
                let css_class = $(option).attr('data-empty') ? ' disabled' : '';
                let size = '<li><a href="javascript:;" data-option_id="' + id + '" data-size="' + value + '" class="js-sw-select-size' + css_class + '">' + value.replace('Children ', 'C') + '</a></li>'

                sizes_modal.find('.sw-size-options').append(size);

                $('#product_customizer .sw-size-options').append(size);
            });
        }
    },

    showConfigurator: function () {
        $('html').addClass('configurator-opened');
        $('#product_customizer').addClass('active');
        if (this.parts_slider) {
            this.parts_slider.update();
        }
    },

    hideConfigurator: function () {
        $('html').removeClass('configurator-opened');
        $('#product_customizer').removeClass('active');
    },

    showLoading: function () {

        console.log('App.showLoading');

        let modals = $('.modal.show');

        if (modals.length) {
            modals.modal('hide');
        }

        $('#loadingContent').removeClass('d-none');
        $('body').css('overflow', 'hidden');
    },

    hideLoading: function () {

        console.log('App.hideLoading');

        $('#loadingContent').addClass('d-none');

        if ($('html').hasClass('configurator-opened')) {
            console.log('Remove overflow property!');
            $('body').css('overflow', '');
        } else if ($('body').hasClass('modal-open')) {
            $('body').css('overflow', 'hidden');
        }
        else {
            $('body').css('overflow', 'unset');
        }
    },

    // Update App.selected_layer and reflect the layer type on the 3D info overlay
    setSelectedLayer: function (layer) {

        App.selected_layer = layer;

        $('.info-3d').attr('data-layer_type', layer ? layer.type : '');
    },

    switchShoes: {

        // Init shoe switching
        init: function () {

            let self = this;

            console.log('App.switchShoes.init called! Pairs: ', App.product_pair_parts);

            if (App.product_pair_parts) {

                // Show left/right buttons
                $('.switch-shoes').removeClass('d-none');

                $(document).on('click', '.js-show-pair-item', function () {

                    $('.js-show-pair-item').removeClass('active');
                    $(this).addClass('active');

                    let item_side = $(this).data('side');
                    self.showLeftRightShoe(item_side);
                });
            }
        },

        // Show left or right shoe
        showLeftRightShoe: function (side) {

            console.log('showLeftRightShoe called for side: ', side);

            App.showLoading();

            let right_part = App.product_pair_parts.right;
            let left_part = App.product_pair_parts.left;

            $('.sw-model-container .js-show-pair-item').removeClass('active');
            $('.sw-model-container .js-show-pair-item.show-' + side).addClass('active');

            let hide_part = side === 'left' ? right_part : left_part;
            let show_part = side === 'left' ? left_part : right_part;

            // Set current shoe side variable
            App.pair_side = side;

            Unlimited3D.hideParts({parts: [hide_part]}, function (error, resp) {
                if (error) {
                    console.log('App.switchShoes.showLeftRightShoe hideParts error: ', error);
                } else {
                    console.log('App.switchShoes.showLeftRightShoe hideParts SUCCESS');

                    Unlimited3D.showParts({partObjects: [{parts: [show_part]}]}, function (error, resp) {
                        if (error) {
                            console.log('showLeftRightShoe showParts error: ', error);
                        } else {
                            console.log('App.switchShoes.showLeftRightShoe showParts SUCCESS');

                            App.updateLayersFlip();
                            App.rotateToPart(App.selected_part);
                        }

                        App.hideLoading();
                    });
                }
            });
        },

    },

    // Show only available tabs
    showAvailableTabs: function () {

        console.log('App.showAvailableTabs called');

        let self = this;
        let available_tabs = self.getAvailableTabs();
        let all_navs = $('.sw-config-container .nav .nav-link');

        $.each(all_navs, function () {

            let tab_id = $(this).attr('id');

            if (available_tabs.length && $.inArray(tab_id, available_tabs) === -1) {

                let nav_item = $(this).closest('.nav-item');
                let initial_nav_link = $('.js-sw-parts-list .js-sw-select-tab[data-tab="' + tab_id + '"]').closest('li');

                if (initial_nav_link.length) {
                    initial_nav_link.remove();
                }

                if (nav_item.length) {
                    nav_item.remove();
                }
            }
        });

        if (self.parts_slider) {
            this.parts_slider.update();
        }
    },

    // Update layers flip option
    updateLayersFlip: function () {

        console.log('App.updateLayersFlip called!');

        $.each(App.layers, function (part_name, part_data) {

            if (typeof part_data['img'] != 'undefined' && part_data['img']) {

                $.each(part_data['img'], function (index, img_data) {

                    if (img_data && typeof img_data.flip_on_left != 'undefined') {

                        let flip = App.pair_side === 'left' && img_data.flip_on_left ? true : false;
                        let overlay = App.product_schema[part_name].overlay;
                        let image = App.product_schema[part_name].img[index];

                        //console.log('FLIP IMAGE: ', flip);

                        if (typeof image != 'undefined') {

                            Unlimited3D.updateOverlay({
                                overlay: overlay,
                                overlayEntry: image.name,
                                options: {
                                    flipH: flip
                                }
                            }, function (error) {
                                console.log('App.updateLayersFlip IMAGE updateOverlay ', error ? error : 'SUCCESS');
                            });
                        }
                    }
                });
            }

            if (typeof part_data['text'] != 'undefined' && part_data['text']) {

                $.each(part_data['text'], function (index, text_data) {

                    if (text_data && typeof text_data.flip_on_left != 'undefined') {

                        let flip = App.pair_side === 'left' && text_data.flip_on_left ? true : false;
                        let overlay = App.product_schema[part_name].overlay;
                        let text_schema = App.product_schema[part_name].text;
                        let text_entry = Array.isArray(text_schema) ? text_schema[index] : text_schema;

                        //console.log('FLIP TEXT: ', flip);

                        if (typeof text_entry != 'undefined') {

                            Unlimited3D.updateOverlay({
                                overlay: overlay,
                                overlayEntry: text_entry.name,
                                options: {
                                    flipH: flip
                                }
                            }, function (error, response) {
                                console.log('App.updateLayersFlip TEXT updateOverlay ', error ? error : 'SUCCESS');
                            });
                        }
                    }
                });
            }

            if (part_data['bg'] && typeof part_data['bg'] != 'undefined' && part_data['bg'] && typeof part_data['bg']['data'] != 'undefined') {

                let bg_data = part_data['bg']['data'];

                if (typeof bg_data.flip_on_left != 'undefined') {

                    let flip = App.pair_side === 'left' && bg_data.flip_on_left ? true : false;
                    let overlay = App.product_schema[part_name].overlay;
                    let bg = App.product_schema[part_name].bg;

                    console.log('FLIP BG: ', bg);

                    if (!bg) return;

                    Unlimited3D.updateOverlay({
                        overlay: overlay,
                        overlayEntry: bg.name,
                        options: {
                            flipH: flip
                        }
                    }, function (error, response) {
                        console.log('App.updateLayersFlip TEXT updateOverlay ', error ? error : 'SUCCESS');
                    });
                }
            }
        });
    },

    // Apply Artist/Designer config
    applyPredefinedConfig: function () {

        console.log('applyPredefinedConfig called!');

        // Retrieve the object from storage
        let self = this;

        if (typeof model_config != 'undefined' && model_config) {
            App.layers = model_config;
        }
        else {
            App.layers = App.layers || {};
            $('.js-preview-loading').addClass('d-none');
        }
    },

    // Save product config in Local Storage
    saveConfigInLocalStorage: function () {

        console.log('saveConfigInLocalStorage: ', App.layers);

        let size = new TextEncoder().encode(JSON.stringify(App.layers)).length;
        let size_kb = size / 1024;
        console.log('layers size in KB: ' + size_kb + 'kb');

        localStorage.setItem('sw_product_config', JSON.stringify(App.layers));
    },

    // Set model data from Local Storage
    loadConfigFromLocalStorage: function () {

        console.log('loadConfigFromLocalStorage called!');

        // Retrieve the object from storage
        let self = this;
        let stored_data = localStorage.getItem('sw_product_config');

        if (stored_data) {
            let stored_data_json = JSON.parse(stored_data);

            console.log('stored_data_json: ', stored_data_json);

            App.layers = stored_data_json;
        }
    },

    // Update 3d model
    loadModelConfiguration: function () {

        console.log('App.loadModelConfiguration');

        if (!$.isEmptyObject(App.layers)) {

            App.updateProductConfig(App.layers);

            console.log('App.product_schema: ', App.product_schema);

            $.each(App.layers, function (part_name, part_data) {

                console.log('update part: ', part_name);
                console.log('App.product_schema[part_name]: ', App.product_schema[part_name]);

                if (typeof part_data['bg'] != 'undefined') {

                    let bg_data = part_data['bg'];

                    console.log('bg_data: ', bg_data);

                    if (bg_data.type === 'color') {

                        let materials = App.product_schema[part_name].materials;

                        console.log('materials: ', materials);

                        if (typeof materials != 'undefined' && materials) {

                            $.each(materials, function (key, material) {

                                Unlimited3D.changeMaterialColor({
                                    material: material,
                                    color: bg_data.data
                                }, function (error) {
                                    if (error) {
                                        console.log('changeMaterialColor ERROR: ', error);
                                    } else {
                                        App.showLayer(part_name, 'bg', bg_data, null);
                                    }
                                });
                            });
                        }

                    } else {

                        let overlay = App.product_schema[part_name].overlay;
                        let image = App.product_schema[part_name].bg;

                        console.log('Overlay: ', overlay);
                        console.log('Image: ', image);
                        console.log('bg_data.data: ', bg_data.data);

                        if (typeof image != 'undefined' && image) {

                            Unlimited3D.updateOverlay({
                                overlay: overlay,
                                overlayEntry: image.name,
                                options: bg_data.data
                            }, function (error, response) {
                                if (error) {
                                    console.log('loadModelConfiguration BG IMAGE updateOverlay ERROR: ', error);
                                } else {
                                    App.showLayer(part_name, 'bg', bg_data, null);

                                    if (bg_data.type === 'pattern') {
                                        App.selected_pattern = bg_data.data;
                                    }
                                }
                            });
                        }

                    }
                }

                if (typeof part_data['img'] != 'undefined' && part_data['img']) {

                    $.each(part_data['img'], function (index, img_data) {

                        if (img_data) {

                            console.log('Index: ', index);
                            console.log('Image data: ', img_data);

                            let overlay = App.product_schema[part_name].overlay;
                            let image = App.product_schema[part_name].img[index];

                            console.log('Image: ', image);

                            if (typeof image != 'undefined') {

                                Unlimited3D.updateOverlay({
                                    overlay: overlay,
                                    overlayEntry: image.name,
                                    options: img_data
                                }, function (error) {
                                    if (error) {
                                        console.log('loadModelConfiguration IMAGE updateOverlay ERROR: ', error);
                                    } else {
                                        App.showLayer(part_name, 'img', img_data, index, img_data.panel);
                                    }
                                });
                            }
                        }
                    });
                }

                if (typeof part_data['text'] != 'undefined' && part_data['text']) {

                    $.each(part_data['text'], function (index, text_data) {

                        if (text_data) {

                            let overlay = App.product_schema[part_name].overlay;
                            let text_schema = App.product_schema[part_name].text;
                            let text_entry = Array.isArray(text_schema) ? text_schema[index] : text_schema;

                            if (typeof text_entry != 'undefined' && text_entry) {

                                Unlimited3D.updateOverlay({
                                    overlay: overlay,
                                    overlayEntry: text_entry.name,
                                    options: text_data
                                }, function (error, response) {
                                    if (error) {
                                        console.log('loadModelConfiguration TEXT updateOverlay ERROR: ', error);
                                    } else {
                                        App.showLayer(part_name, 'text', text_data, index, text_data.panel);
                                    }
                                });
                            }
                        }
                    });
                }

            });

            // Restore the "All over" checkbox if any part's bg layer was saved as all-over
            const has_all_over = Object.values(App.layers).some(function(part_data) {
                return part_data && part_data.bg && part_data.bg.all_over === true;
            });
            $('.js-bg-all-over').prop('checked', has_all_over);

            if (App.has_configurator) {
                App.updateLayersFlip();
            }
            else {
                $('.js-preview-loading').addClass('d-none');
            }
        }
    },

    // Get available parts
    getAvailableParts: function () {

        let self = this;
        let parts = [];

        // If schema has loaded
        if (!$.isEmptyObject(App.product_schema)) {

            // All part short_names
            parts = $.map(App.product_schema, function (element, index) {
                return index
            });

            // Exclude part "combined"
            parts = $.grep(parts, function (value) {
                return value !== 'combined';
            });
        }

        console.log('Available parts: ', parts);

        App.available_parts = parts;
    },


    // Get first available clicked part
    getAvailableClickedPart: function (clicked_parts) {

        console.log('App.getAvailableClickedPart called for objdect: ', clicked_parts);

        if (!$.isEmptyObject(clicked_parts)) {

            let part = null;

            $.each(clicked_parts, function (key, part_object) {
                if ($.inArray(part_object.shortName, App.available_parts) !== -1) {

                    part = part_object.shortName;
                    return part;
                }
            });

            return part;
        }
    },

    // Select 3D model part
    selectPart: function (part) {

        console.log('App.selectPart called for part: ', part);

        let self = this;

        App.selected_part = part;

        App.updateHasLayers();

        App.rotateToPart(part, true);
    },

    updateHasLayers: function () {
        console.log('App.updateHasLayers called for part: ', App.selected_part);

        const combined_id = App.combined_part_id;
        const part = App.selected_part;
        const layers = App.layers || {};
        const combined_layers = combined_id ? layers[combined_id] : null;
        const part_config = layers[part];

        // Check if all image slots in the combined schema are taken
        const combined_schema = combined_id ? App.product_schema[combined_id] : null;
        const max_img_slots  = Array.isArray(combined_schema?.img)  ? combined_schema.img.length  : 0;
        const max_text_slots = Array.isArray(combined_schema?.text) ? combined_schema.text.length : 0;
        const used_img_slots  = Array.isArray(combined_layers?.img)  ? combined_layers.img.length  : 0;
        const used_text_slots = Array.isArray(combined_layers?.text) ? combined_layers.text.length : 0;

        $('#components').toggleClass('img-slots-full',  max_img_slots  > 0 && used_img_slots  >= max_img_slots);
        $('#components').toggleClass('text-slots-full', max_text_slots > 0 && used_text_slots >= max_text_slots);

        // Намери img и text леъри, принадлежащи на текущия панел
        const matching_img  = [];
        const matching_text = [];

        if (combined_layers) {
            if (Array.isArray(combined_layers.img)) {
                combined_layers.img.forEach(function(layer, index) {
                    if (layer && layer.panel === part) matching_img.push({ layer, index });
                });
            }
            if (Array.isArray(combined_layers.text)) {
                combined_layers.text.forEach(function(layer, index) {
                    if (layer && layer.panel === part) matching_text.push({ layer, index });
                });
            }
        }

        // bg остава на ниво панел (не е в combined)
        let has_bg_layer   = !!(part_config && part_config.bg && typeof part_config.bg === 'object' && Object.keys(part_config.bg).length > 0);
        let has_img_layer  = matching_img.length > 0;
        let has_text_layer = matching_text.length > 0;

        if (has_bg_layer || has_img_layer || has_text_layer) {
            $('#components').removeClass('no-layers');
            $('#components').toggleClass('has-bg-layer',   has_bg_layer);
            $('#components').toggleClass('has-img-layer',  has_img_layer);
            $('#components').toggleClass('has-text-layer', has_text_layer);
        } else {
            $('#components').addClass('no-layers');
            $('#components').removeClass('has-bg-layer has-img-layer has-text-layer');
            $('.js-sw-layers').removeClass('show-on-mobile');
        }

        // Покажи леърите в таба на избрания панел
        if (App.product_schema[part] && App.product_schema[part].tab) {
            const tab_content_id = App.product_schema[part].tab.replace('-tab', '');
            $('#' + tab_content_id + ' .sw-layers .js-sw-layers-list .js-image-layer .sw-img-layer').remove();
            $('#' + tab_content_id + ' .sw-layers .js-sw-layers-list .js-text-layer .sw-text-layer').remove();

            matching_img.forEach(function({ layer, index }) {
                App.showLayer(combined_id, 'img', layer, index, part, true);
            });
            matching_text.forEach(function({ layer, index }) {
                App.showLayer(combined_id, 'text', layer, index, part, true);
            });
        }
    },

    rotateToPart(selected_part, highlight) {

        console.log('App.rotateToPart called for part: ', selected_part);

        let part = selected_part || null;
        let highlight_part = highlight || false;

        // Transition
        if (part &&
            typeof App.product_schema[part].transition !== 'undefined' &&
            typeof App.product_schema[part].transition[App.pair_side] != 'undefined') {

            let transition = App.product_schema[part].transition[App.pair_side];

            console.log('Transition: ', transition);

            Unlimited3D.activateTransition({
                transition: transition,
                duration: 400
            }, function (error, response) {
                if (error) {
                    console.log('App.rotateToPart Unlimited3D.activateTransition error: ', error);
                } else {
                    if (highlight_part) {
                        // Highlight part/s
                        let parts = [part];

                        if (typeof App.product_pair_parts != 'undefined' && typeof App.product_pair_parts[App.pair_side] != 'undefined') {

                            let main_part_name = App.product_pair_parts[App.pair_side];
                            let pair_side_parts = [];

                            $.each(parts, function (key, part) {
                                pair_side_parts.push(main_part_name + ':' + part);
                            })

                            parts = pair_side_parts;
                        }

                        console.log('Parts for pair side: ', parts);

                        // Highlight part
                        Unlimited3D.activateDecorationOnParts({
                            parts: parts,
                            decoration: 'Highlight'
                        }, function () {
                            Unlimited3D.deactivateDecorationFromParts({
                                parts: parts,
                                decoration: 'Highlight'
                            });
                        });
                    }
                }
            });
        }
    },

    // Show layer in tab
    showLayer: function (part_key, type, data, index, tab_part_key, skip_update) {

        let self = this;

        if (!App.has_configurator) {
            return false;
        }

        console.log('App.showLayer method called wit part_key: ' + part_key + ' type: ' + type + ' index: ' + index);
        console.log('data: ', data);

        if (typeof App.product_schema[part_key] != 'undefined') {

            const schema_key = tab_part_key || part_key;
            let tab = App.product_schema[schema_key].tab;
            let tab_content_id = tab.replace('-tab', '');
            let layers = $('#' + tab_content_id + ' .sw-layers .js-sw-layers-list');
            let layers_mobile = $('#' + tab_content_id + ' .sw-mobile-layers');
            let current_layer = layers.find('.sw-' + type + '-layer');
            let current_mobile_layer = layers_mobile.find('.sw-m-' + type);
            let desktop_header = $('#' + tab_content_id + ' .action-content .sw-layers .sw-layer-header');
            let desktop_text_btn = $('#' + tab_content_id + ' .action-content .sw-layers .sw-text-layer');
            let mobile_add_btn = $('#' + tab_content_id + ' .action-content .sw-mobile-layers .js-sw-add-layers');
            let mobile_text_btn = $('#' + tab_content_id + ' .action-content .sw-mobile-layers .js-sw-m-text');

            if (type === 'img' || type === 'text') {
                current_layer = layers.find('.sw-' + type + '-layer[data-index="' + index + '"]');
                current_mobile_layer = layers_mobile.find('.sw-m-' + type + '[data-index="' + index + '"]');
            }

            // Remove layer if already exists
            if (current_layer.length) {
                current_layer.remove();
            }

            if (current_mobile_layer.length) {
                current_mobile_layer.remove();
            }

            let new_layer = $('<div></div>').append($('#layer_templates .sw-layers .sw-' + type + '-layer').clone());
            let new_layer_mobile = $('<div></div>').append($('#layer_templates .sw-mobile-layers .sw-m-' + type).clone());
            let edit_link = new_layer.find('.sw-layer-actions .edit-layer');
            let delete_link = new_layer.find('.sw-layer-actions .delete-layer');
            let mobile_edit_link = new_layer_mobile.find('.sw-m-actions .edit-layer');
            let mobile_delete_link = new_layer_mobile.find('.sw-m-actions .delete-layer');

            // Set edit and delete links data attributes
            edit_link.attr('data-part', part_key);
            delete_link.attr('data-part', part_key);
            mobile_edit_link.attr('data-part', part_key);
            mobile_delete_link.attr('data-part', part_key);

            switch (type) {

                case 'bg':
                    let edit_action = 'add_bg_' + data.type;
                    let icon = '';
                    let mobile_icon = '';
                    let text = new_layer.find('.sw-layer-text');
                    let mobile_text = new_layer_mobile.find('.sw-m-text-container');
                    let bg_image_container = new_layer.find('.sw-layer-icon .js-bg-layer-image');
                    let bg_color_container = new_layer.find('.sw-layer-icon .js-bg-layer-color');
                    let bg_mobile_image_container = new_layer_mobile.find('.sw-m-icon .js-m-bg-layer-img');
                    let bg_mobile_color_container = new_layer_mobile.find('.sw-m-icon .js-m-bg-layer-color');

                    // Set bg layer text field - Pattern, Image or Color
                    text.text(_t[data.type]);
                    mobile_text.text(_t[data.type]);

                    // Set edit and delete link data attributes
                    edit_link.attr('data-action', edit_action);
                    delete_link.attr('data-bg_type', data.type);
                    mobile_edit_link.attr('data-action', edit_action);
                    mobile_delete_link.attr('data-bg_type', data.type);

                    if (data.type === 'color') {

                        // Remove image icon desktop
                        bg_image_container.remove();

                        // Set color icon desktop
                        icon = bg_color_container;
                        icon.css('background-color', data.data);

                        // Remove image icon mobile
                        bg_mobile_image_container.remove();

                        // Set color icon mobile
                        mobile_icon = bg_mobile_color_container;
                        mobile_icon.css('background-color', data.data);
                    } else {

                        // Remove color icon desktop
                        bg_color_container.remove();

                        // Set image icon desktop
                        icon = bg_image_container;
                        icon.attr('src', data.data.imageUrl);

                        // Remove color icon mobile
                        bg_mobile_color_container.remove();

                        // Set image icon mobile
                        mobile_icon = bg_mobile_image_container;
                        mobile_icon.attr('src', data.data.imageUrl);
                    }

                    // Show background button desktop - as last item
                    //$('#' + tab_content_id + ' .action-content .sw-layers').append(new_layer.html());


                    // Show background button mobile - as last item
                    $('#' + tab_content_id + ' .action-content .sw-mobile-layers').append(new_layer_mobile.html());

                    $('#' + tab_content_id + ' .action-content .sw-layers .js-sw-layers-list .js-bg-layer').append(new_layer.html());
                    break;

                case 'img':

                    let img_icon = '';
                    let img_mobile_icon = '';

                    // Set image icon desktop
                    img_icon = new_layer.find('.sw-layer-icon .js-layer-image');
                    img_icon.attr('src', data.imageUrl);

                    // Set image icon mobile
                    img_mobile_icon = new_layer_mobile.find('.sw-m-icon .js-m-layer-image');
                    img_mobile_icon.attr('src', data.imageUrl);

                    // Update data-index on the layer container itself
                    new_layer.find('.sw-img-layer').attr('data-index', index);

                    // Set data-part + data-index on the icon edit link (thumbnail click)
                    let icon_edit_link = new_layer.find('.sw-layer-icon .edit-layer');
                    icon_edit_link.attr('data-part', part_key).attr('data-index', index);

                    // Set data-index on the hidden layer-actions links too
                    edit_link.attr('data-index', index);
                    delete_link.attr('data-index', index);

                    // // Show image button desktop - after text or after header
                    // if (desktop_text_btn.length) {
                    //     desktop_text_btn.after(new_layer.html())
                    // }
                    // else {
                    //     desktop_header.after(new_layer.html());
                    // }

                    // Show image button mobile - after text or after add layer button
                    if (mobile_text_btn.length) {
                        mobile_text_btn.after(new_layer_mobile.html());
                    }
                    else {
                        mobile_add_btn.after(new_layer_mobile.html());
                    }

                    $('#' + tab_content_id + ' .action-content .sw-layers .js-sw-layers-list .js-image-layer').append(new_layer.html());

                    break;

                case 'text':
                    new_layer.find('.sw-text-layer').attr('data-index', index);
                    new_layer.find('.sw-layer-text a').text(data.text);

                    new_layer.find('.sw-layer-text .edit-layer')
                        .attr('data-part', part_key)
                        .attr('data-index', index);

                    edit_link.attr('data-index', index);
                    delete_link.attr('data-index', index);
                    mobile_edit_link.attr('data-index', index);
                    mobile_delete_link.attr('data-index', index);

                    // Show text button desktop - after layers header
                    //desktop_header.after(new_layer.html());

                    // Show text button mobile - after add layer button
                    mobile_add_btn.after(new_layer_mobile.html());

                    $('#' + tab_content_id + ' .action-content .sw-layers .js-sw-layers-list .js-text-layer').append(new_layer.html());
                    break;

                default:
                    console.log('Not supported type: ', type);
            }

            if (!skip_update) {
                App.updateHasLayers();
            }
        }
    },

    saveLayer: function (part_key, type, data, index) {

        console.log('Save Layer for part_key: ' + part_key + ' with type: ' + type + ' with index: ' + index + ' with data: ', data);

        let self = this;
        let layer_type = type === 'bg_color' ? 'bg' : type;

        // Add empty part object to config if missing
        if (typeof App.layers[part_key] == 'undefined') {
            App.layers[part_key] = {};
        }

        // Add empty image array to config if missing
        if ((type === 'img' || type === 'text') && typeof App.layers[part_key][layer_type] == 'undefined') {
            App.layers[part_key][layer_type] = [];
        }

        console.log('App.layers[part_key][layer_type]: ', App.layers[part_key][layer_type]);

        // Image layer
        if (type === 'img' || type === 'text') {

            // Update image config
            if (typeof App.layers[part_key][layer_type][index] != 'undefined') {
                App.layers[part_key][layer_type][index] = Object.assign(App.layers[part_key][layer_type][index], data);
            }
            // Add a new image/text config to the array
            else {
                index = App.layers[part_key][layer_type].length; // capture index before push
                App.layers[part_key][layer_type].push(data);
                App.setLayerPanel(layer_type, index);
            }
        }
        // BG layer
        else {
            // Set layer data
            App.layers[part_key][layer_type] = data;
            App.setSelectedLayer(data.data ? { type: 'bg', index: null, data: data.data } : null);
        }

        const tab_part_key = (part_key === App.combined_part_id) ? App.selected_part : null;
        App.showLayer(part_key, layer_type, data, index, tab_part_key);

        //App.saveConfigInLocalStorage();

        App.updateProductConfig(App.layers);
        App.updateLayersFlip();
    },

    updateLayer: function (part_key, type, data, index) {

        console.log('Update Layer for part_key: ' + part_key + ' with type: ' + type + ' with data: ', data);

        let self = this;
        let layer_type = type === 'bg_color' ? 'bg' : type;

        if (typeof App.layers[part_key] != 'undefined') {

            console.log('App.layers[part_key][layer_type]: ', App.layers[part_key][layer_type]);

            if (type === 'img' || type === 'text') {
                if (typeof App.layers[part_key][layer_type] != 'undefined' &&
                    typeof App.layers[part_key][layer_type][index] != 'undefined') {
                    App.layers[part_key][layer_type][index] = Object.assign(App.layers[part_key][layer_type][index], data);
                }
            } else {
                App.layers[part_key][layer_type] = data;
            }

            //App.saveConfigInLocalStorage();

            App.updateProductConfig(App.layers);
            App.updateLayersFlip();
        }
    },

    // Delete the selected layer
    deleteLayer: function (part_key, layer_type, bg_type, index) {

        let self = this;

        console.log('[deleteLayer] for part_key: ' + part_key + ' with layer_type: ' + layer_type + ' with bg_type: ' + bg_type + ' with index: ' + index);

        if (layer_type === 'bg') {
            App.backgroundLayer.resetAllOverCheckbox();
        }

        if (layer_type === 'img' || layer_type === 'text') {
            const combined_id = App.combined_part_id || part_key;
            App.deleteLayerConfig(combined_id, layer_type, bg_type, index);
            App.removeLayerFrom3d(combined_id, layer_type, bg_type, index);
            App.deleteLayerFromDom(App.selected_part, layer_type, index);

            // Избраният слой сочи към вече невалиден индекс
            App.setSelectedLayer(null);
        }
        else {
            App.removeLayerFrom3d(part_key, layer_type, bg_type, index);
            App.deleteLayerConfig(part_key, layer_type, bg_type, index);
            App.deleteLayerFromDom(part_key, layer_type, index);
        }

        App.updateProductConfig(App.layers);
    },

    // За bg: изчиства слоя от 3D.
    // За img/text: пре-прилага целия набор слоеве, защото слот N в
    // product_schema отговаря на индекс N в App.layers — след преиндексиране
    // (напр. изтриване) всички слотове трябва да се презапишат, а
    // освободените да се изчистят. Извиква се СЛЕД deleteLayerConfig.
    removeLayerFrom3d: function (part_key, layer_type, bg_type, index) {

        console.log('App.removeLayerFrom3d called for part: ', part_key + ' layer_type: ' + layer_type + ' bg_type: ' + bg_type + ' index: ' + index );

        switch (layer_type) {
            case 'bg':
                let was_all_over = !!(App.layers[part_key] && App.layers[part_key].bg && App.layers[part_key].bg.all_over);

                if (bg_type && bg_type === 'color') {
                    App.backgroundLayer.deleteBgColorFrom3d(part_key, was_all_over);
                } else {
                    App.backgroundLayer.deleteBgImageFrom3d(part_key, was_all_over);
                }
                break;
            case 'img':
            case 'text':
                const schema = App.product_schema[part_key];

                if (typeof schema == 'undefined') break;

                const overlay = schema.overlay;
                const slots = Array.isArray(schema[layer_type])
                    ? schema[layer_type]
                    : (schema[layer_type] ? [schema[layer_type]] : []);
                const layers = (App.layers[part_key] && Array.isArray(App.layers[part_key][layer_type]))
                    ? App.layers[part_key][layer_type]
                    : [];

                if (!overlay || !slots.length) break;

                $.each(slots, function (slot_index, slot) {

                    if (!slot || !slot.name) return;

                    const layer_data = layers[slot_index] || null;

                    if (layer_data) {
                        Unlimited3D.updateOverlay({
                            overlay: overlay,
                            overlayEntry: slot.name,
                            options: {
                                ...layer_data,
                                flipH: App.pair_side === 'left' && !!layer_data.flip_on_left
                            }
                        }, function (error) {
                            if (error) console.log('App.removeLayerFrom3d updateOverlay ERROR: ', error);
                        });
                    }
                    else if (layer_type === 'img') {
                        App.imageLayer.deleteImageFrom3d(part_key, slot_index);
                    }
                    else {
                        App.textLayer.deleteTextFrom3d(part_key, slot_index);
                    }
                });
                break;
            default:
                console.log('Not supported layer type: ', layer_type);
        }
    },

    deleteLayerConfig: function (part_key, layer_type, bg_type, index) {

        console.log('App.deleteLayerConfig called for part: ', part_key);

        if (typeof App.layers[part_key] != 'undefined') {

            if (layer_type === 'img' || layer_type === 'text') {
                let array = App.layers[part_key][layer_type];
                array.splice(index, 1);
                if (!array.length) {
                    delete App.layers[part_key][layer_type];
                } else {
                    App.layers[part_key][layer_type] = array;
                }
            } else {
                delete App.layers[part_key][layer_type];
            }

            if ($.isEmptyObject(App.layers[part_key])) {
                delete App.layers[part_key];
            }

            if (layer_type === 'bg' && bg_type === 'pattern') {
                App.updateSelectedPattern();
            }
        }
    },

    deleteLayerFromDom: function (part_key, layer_type, index, close_panel = true) {

        console.log('App.deleteLayerFromDom called for part: ', part_key);

        let part = App.product_schema[part_key];

        // Remove layer data from tab content
        if (typeof part != 'undefined') {

            let tab_content_id = part.tab.replace('-tab', '');
            let tab_content = $('#' + tab_content_id);

            console.log('tab_content: ', tab_content);
            console.log('layer_type: ', layer_type);
            console.log('index: ', index);

            if (tab_content.length) {

                let layers = $('#' + tab_content_id + ' .sw-layers .js-sw-layers-list');
                let layers_mobile = $('#' + tab_content_id + ' .sw-mobile-layers');

                switch (layer_type) {
                    case 'bg':
                        layers.find('.sw-bg-layer').remove();
                        layers_mobile.find('.js-sw-m-bg').remove();
                        break;
                    case 'img':
                        layers.find('.sw-img-layer').remove();
                        layers_mobile.find('.js-sw-m-img').remove();
                        break;
                    case 'text':
                        layers.find('.sw-text-layer').remove();
                        layers_mobile.find('.js-sw-m-text').remove();
                        break;
                    default:
                        console.log('Not supported type: ', layer_type)
                }

                App.updateHasLayers();

                if (close_panel) {
                    $('.action-container').addClass('d-none');
                    $('#components').removeClass('d-none');
                }
            }
        }
    },

    // Update product config line_item property in Shopify PDP
    updateProductConfig: function (config) {

        console.log('App.updateProductConfig called with config: ', config);

        if (App.has_configurator) {
            App.check_leave = true;
        }

        $('#config').val(JSON.stringify(config));
    },

    // Get part from given tab in schema
    getPartFromTab: function (tab) {

        let selected_part = null;

        $.each(App.product_schema, function (key, part) {
            if (part.tab === tab) {
                selected_part = key;
                return false;
            }
        });

        return selected_part;
    },

    // Get part by given overlay from product schema
    getPartFromOverlay: function (overlay) {

        let selected_part = null;

        $.each(App.product_schema, function (key, part) {
            if (part.overlay === overlay) {
                selected_part = key;
                return false;
            }
        });

        return selected_part;
    },

    // Get available tabs from product schema
    getAvailableTabs: function () {

        console.log('App.getAvailableTabs called');

        let self = this;
        let available_tabs = [];

        if (!$.isEmptyObject(App.product_schema)) {
            available_tabs = Object.values(App.product_schema)
                .filter(part => !part.hidden && part.tab != null)
                .map(data => data.tab);
        }

        console.log('Available tabs: ', available_tabs);

        return available_tabs;
    },

    updateSelectedPattern: function () {

        let pattern = null;

        console.log('App.updateSelectedPattern called');

        if (!$.isEmptyObject(App.layers)) {
            $.each(App.layers, function (part, layer) {
                if (typeof layer.bg != 'undefined' && layer.bg.type === 'pattern') {
                    pattern = layer.bg.data;
                    return false;
                }
            });
        }

        console.log('Selected PATTERN: ', pattern);

        if ($('#sw_product_config_modal_pattern').length && pattern !== null ) {
            $('#sw_product_config_modal_pattern .js-apply-bg-pattern img').attr('src', pattern.imageUrl);
        }

        App.selected_pattern = pattern;
    },

    // Get the next layer index by type
    getNextLayerIndex: function (layer_type = 'img') {
        let index = 0;
        const combined_id = App.combined_part_id;
        const combined_data = combined_id ? App.layers[combined_id] : null;

        if (combined_data && typeof combined_data[layer_type] != 'undefined') {
            index = combined_data[layer_type].length;
        }

        console.log('Next index: ', index);
        return index;
    },

    setSelectedPattern: function(options) {

        let self = this;

        console.log('App.setSelectedPattern called with options: ', options);

        App.selected_pattern = options;

    },

    backgroundLayer: {
        layer_type: 'bg',
        bg_color_picker: null,
        bg_color_throttle_timer: null,
        bg_image_form: '#bg_img_form',
        bg_img_padding_slider: '#bg_img_padding_slider',
        bg_img_padding_handle: '#bg_img_padding_slider .js-padding-handle',
        bg_img_ratio: 1,
        bg_pattern_form: '#bg_pattern_form',
        bg_pattern_ratio: 1,
        prev_color: '',
        slider_throttle_timer: null,
        slider_throttle_last: 0,
        SLIDER_THROTTLE_MS: 100,
        bgImageDropzone: {

            dropzoneId: '#dropzone_bg_image',

            previewTemplate: '<div class="dropzone-item d-none">' +
                '               <div class="dropzone-file">' +
                '                   <div class="part-image bg-secondary">' +
                '                       <img src="" />' +
                '                   </div>' +
                '                   <div class="dropzone-filename" title="file name">' +
                '                       <span class="js-dz-name"></span>' +
                '                       <strong>(<span class="js-dz-size"></span>)</strong>' +
                '                   </div>' +
                '               </div>' +
                '               <div class="dropzone-toolbar">' +
                '                    <span class="dropzone-delete js-dz-remove" >' +
                '                       <i class="fa fa-trash text-danger"></i>' +
                '                    </span>' +
                '               </div>' +
                '           </div>',

            init: function() {

                let self = this;

                console.log('App.backgroundLayer.bgImageDropzone.init called');

                let dropzone_id = self.dropzoneId;
                let size_limit = parseFloat(App.image_bytes_limit / (1024*1024)).toFixed(2);

                let dropzone_ajax_url = '/a/spirit-bo/designs/image/chunk';

                let img_dropzone_options = {
                    url: dropzone_ajax_url,
                    headers: { "Accept": "application/json" },
                    maxFilesize: size_limit,
                    method: 'post',
                    chunking: true,
                    chunkSize: 1 * 1000 * 1000,
                    retryChunks: true,
                    retryChunksLimit: 3,
                    parallelUploads: 1,
                    paramName: 'image',
                    autoProcessQueue: false,
                    acceptedFiles: 'image/jpeg,image/jpg,image/png,image/gif,image/webp',
                    previewTemplate: self.previewTemplate,
                    previewsContainer: dropzone_id + ' .dropzone-items',
                    addedfiles: function () {
                        // $('#sw_product_config_modal_bg_flip').modal('show');
                        this.processQueue();
                    },
                    uploadprogress: function(file, progress, bytesSent) {
                        let progress_int = parseInt(progress);
                        $(dropzone_id + ' .dropzone-progress .progress-bar').css('width', progress_int + '%').text(progress_int + '%');
                    },
                    success: function (file, response) {

                        console.log(' --- DROPZONE file: ', file);
                        console.log(' --- DROPZONE response: ', response.image.url);

                        $(dropzone_id + ' .dropzone-progress').addClass('d-none');

                        img_dropzone.removeFile(file);

                        if (response.errors) {

                            console.log('ERRORS: ', response.errors);

                            if ($.isArray(response.errors)) {
                                let errors_text = 'Errors in request \n' + response.errors.join('\n');
                                alert(errors_text);
                            }
                        }
                        else {

                            let file_url = response.image.url;

                            $('#add_bg_image').addClass('has-selection');

                            $('#background_image img').attr('src', file_url);
                            $('#bg_img_preview').attr('src', file_url);

                            $('#background_image img').one('load', function() {

                                console.log('BG Image has loaded');

                                App.backgroundLayer.showBgImgMobileLayerTab('position');

                                self.updateDzItem(file_url);

                                App.backgroundLayer.addOrUpdateBgImages('image', file_url);
                            });
                        }
                    },
                    error: function(file, message) {

                        console.log('  ---  DROPZONE error message: ', message);

                        let error_container = $(App.backgroundLayer.bg_image_form + ' .js-dz-error');

                        console.log('error_container: ', error_container);

                        if (typeof message === 'string') {

                            console.log('Message is string!');

                            error_container.text(message).removeClass('d-none');
                        }

                        if (typeof message.message != 'undefined') {
                            error_container.text(message.message).removeClass('d-none');
                        }

                        if (typeof message.error != 'undefined') {
                            error_container.text(message.error).removeClass('d-none');
                        }

                        if (typeof message.errors != 'undefined' && $.isArray(message.errors)) {
                            let errors_text = 'Errors in request <br>' + message.errors.join('<br>');
                            error_container.html(errors_text).removeClass('d-none');
                        }
                    }
                };

                console.log('img_dropzone_options: ', img_dropzone_options);

                let img_dropzone = new Dropzone(dropzone_id, img_dropzone_options);

                img_dropzone.on('addedfiles', function (file, xhr, formData) {

                    console.log('Added files event');

                    $(dropzone_id + ' .dropzone-progress .progress-bar').css('width', 0);
                });

                img_dropzone.on('sending', function (file, xhr, formData) {
                    $(App.backgroundLayer.bg_image_form + ' .js-dz-error').text('').addClass('d-none');
                    $(dropzone_id + ' .dropzone-progress').removeClass('d-none');
                });

                $(document).on('click', '.js-sw-dropzone-flip-bg', function () {

                    let flip_input = $(this).closest('.modal').find('input[type="radio"]:checked').val();

                    if (flip_input === '1') {

                        $('#bg_flip').prop('checked', true);
                    } else {

                        $('#bg_flip').prop('checked', false);
                    }

                    img_dropzone.processQueue();
                });
            },

            updateDzItem: function(file_url) {

                let self = this;

                console.log('App.backgroundLayer.bgImageDropzone.removeFile called');

                let dropzone_id = self.dropzoneId;
                let image_container = $('#background_image img')

                image_container.attr('src', file_url);
                $('#bg_img_preview').attr('src', file_url);

                let ratio = image_container.height() / image_container.width();
                App.backgroundLayer.bg_img_ratio = ratio;

                console.log('BG IMG Ratio calculated: ', ratio);

                $('#scale_bg_y').val(($('#scale_bg_x').val())*ratio);
            },

            showDropzoneImageLayer: function(data) {

                let self = this;

                console.log('App.backgroundLayer.bgImageDropzone.showDropzoneImageLayer called');
                console.log('Data: ', data);

                let dropzone_id = self.dropzoneId;

                $(dropzone_id + ' .dropzone-item').remove();

                if (data && typeof data.imageUrl != 'undefined' && !/patterndesigns/i.test(data.imageUrl)) {

                    $('#add_bg_image').addClass('has-selection');

                    let file_url = data.imageUrl || '';

                    $('#background_image img').attr('src', file_url);
                    $('#bg_img_preview').attr('src', file_url);

                    $('#background_image img').one('load', function() {

                        console.log('BG Image has loaded');

                        App.backgroundLayer.showBgImgMobileLayerTab('position');

                        self.updateDzItem(file_url);
                    });
                }
                else {

                    $('#add_bg_image').removeClass('has-selection');

                    //App.backgroundLayer.updateBgImageCanvas(null);

                    App.backgroundLayer.showBgImgMobileLayerTab('file');
                }
            }
        },

        // Background layer init
        init: function () {

            let self = this;

            console.log('App.backgroundLayer.init called');

            self.bgImageDropzone.init();

            if (!self.bg_color_picker) {

                self.bg_color_picker = Pickr.create({
                    default: App.product_material_color,
                    el: '.js-bg-color-picker',
                    useAsButton: true,
                    appClass: 'sw-picker-element',
                    inline: true,
                    showAlways: true,
                    theme: 'monolith', // or 'monolith', or 'nano'
                    components: {

                        // Main components
                        preview: true,
                        hue: true,

                        // Input / output Options
                        interaction: {
                            input: true
                        }
                    }
                });
            }

            self.bg_color_picker.on('change', (color, source, instance) => {
                let selected_color = color.toHEXA().toString();
                clearTimeout(self.bg_color_throttle_timer);
                self.bg_color_throttle_timer = setTimeout(function() {
                    self.updateBgColorIn3d(selected_color);
                }, 50);
            });

            self.bg_color_picker.on('changestop', (source, instance) => {
                //console.log('Event: "changestop"', source, instance);
                let selected_color = instance.getColor().toHEXA().toString();

                $('#bg_color').val(selected_color);
                self.changeBgColor(selected_color);
            });

            self.bg_color_picker.on('swatchselect', (source, instance) => {
                //console.log('Event: "changestop"', source, instance);
                let selected_color = instance.getColor().toHEXA().toString();

                $('#bg_color').val(selected_color);
                self.changeBgColor(selected_color);
            });

            $(document).on('focus click', '#add_bg_color .pcr-result', function() {
                $(this).select();
            });

            // Prevent Enter inside the colour picker input from implicitly
            // submitting the surrounding form (which navigates away / exits the customizer)
            $(document).on('keydown', '.pcr-app .pcr-result', function(e) {
                if (e.key === 'Enter' || e.which === 13) {
                    e.preventDefault();
                }
            });

            $(document).on('focus click', '.patternDesign-sp-input-container .patternDesign-sp-input', function() {
                $(this).select();
            });

            // Select pattern
            $(document).on('click', '.js-select-pattern', function () {

                console.log('Design data: ', _patternDesignWidget.selectedDesign);

                $('#pattern_design_modal').modal('hide');

                // $('#sw_product_config_modal_pattern_flip').modal('show');

                $('.action-container').addClass('d-none');
                $('#add_bg_pattern').removeClass('d-none');
                App.toggleCustomizerButtons(1);
                self.addPatternDesignImage();
            });

            $(document).on('click', '.js-sw-dropzone-flip-pattern', function () {

                $('.action-container').addClass('d-none');
                $('#add_bg_pattern').removeClass('d-none');

                App.toggleCustomizerButtons(1);

                let flip_input = $(this).closest('.modal').find('input[type="radio"]:checked').val();

                if (flip_input === '1') {

                    $('#bg_pattern_flip').prop('checked', true);
                } else {

                    $('#bg_pattern_flip').prop('checked', false);
                }

                self.addPatternDesignImage();
            });

            // Change any image option
            $(document).on('change', self.bg_image_form, function () {

                let img_url = null;

                if ($('#background_image img').length) {
                    img_url = $('#background_image img').attr('src');
                }

                if (typeof img_url != 'undefined' && img_url) {
                    clearTimeout(self.slider_throttle_timer);
                    let updateImage = function () {
                        self.slider_throttle_last = Date.now();
                        self.addOrUpdateBgImages('image', img_url);
                    };
                    if (Date.now() - self.slider_throttle_last >= self.SLIDER_THROTTLE_MS) {
                        updateImage();
                    } else {
                        self.slider_throttle_timer = setTimeout(updateImage, self.SLIDER_THROTTLE_MS);
                    }
                } else {
                    alert('Please select an image!')
                }
            });

            // Change any image option
            $(document).on('change', self.bg_pattern_form, function () {

                let img_url = null;

                if ($('#background_pattern img').length) {
                    img_url = $('#background_pattern img').attr('src');
                }

                if (typeof img_url != 'undefined' && img_url) {
                    clearTimeout(self.slider_throttle_timer);
                    let updatePattern = function () {
                        self.slider_throttle_last = Date.now();
                        self.addOrUpdateBgImages('pattern', img_url);
                    };
                    if (Date.now() - self.slider_throttle_last >= self.SLIDER_THROTTLE_MS) {
                        updatePattern();
                    } else {
                        self.slider_throttle_timer = setTimeout(updatePattern, self.SLIDER_THROTTLE_MS);
                    }
                } else {
                    alert('Please select a pattern!');
                }
            });

            // Select and add background image
            $(document).on('change', '#bg_image_input', function (event) {

                console.log('BG IMAGE CHANGE');

                event.stopPropagation();

                if (this.files && this.files[0]) {

                    let file_size = this.files[0].size

                    if (file_size <= App.image_bytes_limit) {

                        let file_reader = new FileReader();

                        file_reader.addEventListener('load', function (e) {

                            let img_url = e.target.result;

                            self.saveBackgroundImage(img_url);
                        });

                        file_reader.readAsDataURL(this.files[0]);
                    }
                    else {

                        $('#bg_image_input').val('');

                        $('#add_bg_image').removeClass('has-selection');

                        let size_limit = parseFloat(App.image_bytes_limit / (1024*1024)).toFixed(2);
                        alert('Image size is larger than the configured limit of ' + size_limit + 'MB');
                    }
                }
            });

            // BG IMAGE Padding slider
            $(self.bg_img_padding_slider).slider({
                min: 0,
                max: 20,
                step: 0.1,
                value: 0.00,
                create: function() {
                    $(self.bg_img_padding_handle).text($( this ).slider('value'));
                },
                slide: function(event, ui) {
                    $(self.bg_img_padding_handle).text(ui.value);
                },
                stop: function(event, ui) {
                    $('#bg_padding').val(ui.value * 0.01).trigger('change');
                }
            });

            // Show bg img tab
            $(document).on('click', '.js-sw-show-bg-img-tab', function() {

                console.log('js-sw-show-bg-img-tab clicked');

                let m_img_tab = $(this).data('tab');

                console.log('m_img_tab: ', m_img_tab);

                self.showBgImgMobileLayerTab(m_img_tab);
            });

            // Click on delete bg image layer button
            $(document).on('click', '.js-sw-delete-bg-img-layer', function () {

                let part_name = App.selected_part;
                let layer_type = 'bg';
                let bg_type = 'image';
                let index = 0;

                console.log('part_name: ', part_name);
                console.log('layer_type: ', layer_type);
                console.log('bg_type: ', bg_type);
                console.log('index: ' + index);

                $('#bg_image_input').val('');
                $('#add_bg_image').removeClass('has-selection');

                App.deleteLayer(part_name, layer_type, bg_type, index);
            });

            // Click on delete bg pattern layer button
            $(document).on('click', '.js-sw-delete-bg-pattern-layer', function () {

                let part_name = App.selected_part;
                let layer_type = 'bg';
                let bg_type = 'pattern';
                let index = 0;

                console.log('part_name: ', part_name);
                console.log('layer_type: ', layer_type);
                console.log('bg_type: ', bg_type);
                console.log('index: ' + index);

                $('#bg_pattern_input').val('');
                $('#add_bg_pattern').removeClass('has-selection');

                //self.updateBgPatternCanvas(null);

                App.deleteLayer(part_name, layer_type, bg_type, index);
            });

            $(document).on('input', '.sw-bg-img-slider', function () {

                let type = $(this).data('type');
                let val  = parseFloat($(this).val());

                switch (type) {
                    case 'rotation':
                        var radians = parseFloat((val * Math.PI / 180).toFixed(6));
                        $('#bg_rotation').val(radians);
                        break;
                    case 'scale':
                        var ratio = App.backgroundLayer.bg_img_ratio || 1;
                        $('#scale_bg_x').val(val);
                        $('#scale_bg_y').val(parseFloat((val * ratio).toFixed(6)));
                        $('#bg_img_scale_display').text(Math.round(val * 100) + '%');
                        break;
                    case 'position_x':
                        $('#center_bg_x').val(val);
                        break;
                    case 'position_y':
                        $('#center_bg_y').val(val);
                        break;
                }

                $('#bg_img_form').trigger('change');
            });

            $(document).on('input', '.sw-bg-pat-slider', function () {

                let type = $(this).data('type');
                let val  = parseFloat($(this).val());

                switch (type) {
                    case 'rotation':
                        var radians = parseFloat((val * Math.PI / 180).toFixed(6));
                        $('#bg_pattern_rotation').val(radians);
                        break;
                    case 'scale':
                        var ratio = App.backgroundLayer.bg_pattern_ratio || 1;
                        $('#scale_bg_pattern_x').val(val);
                        $('#scale_bg_pattern_y').val(parseFloat((val * ratio).toFixed(6)));
                        $('#bg_pat_scale_display').text(Math.round(val * 100) + '%');
                        break;
                    case 'position_x':
                        $('#center_bg_pattern_x').val(val);
                        break;
                    case 'position_y':
                        $('#center_bg_pattern_y').val(val);
                        break;
                }

                $('#bg_pattern_form').trigger('change');
            });

            $(document).on('change', '.js-bg-all-over', function () {
                const checked = $(this).is(':checked');

                // Синхронизирай останалите чекбокси
                $('.js-bg-all-over').prop('checked', checked);

                if (checked) {
                    const part = App.selected_part;
                    const bg = App.layers[part] && App.layers[part].bg;
                    if (!bg) return;

                    if (bg.type === 'color') {
                        App.backgroundLayer.changeBgColor(bg.data);
                    } else {
                        App.backgroundLayer.addOrUpdateBgImages(bg.type, bg.data.imageUrl || null);
                    }
                }
                else {
                    // Un-check: оставяме фона само на текущата част
                    const part = App.selected_part;

                    App.backgroundLayer.removeAllOverBackground(part);

                    const bg = App.layers[part] && App.layers[part].bg;
                    if (bg) {
                        bg.all_over = false;
                        App.updateProductConfig(App.layers);
                    }
                }
            });
        },

        saveBackgroundImage: function(blob) {

            let self = this;

            console.log('App.backgroundLayer.saveBackgroundImage called');

            let ajax_url = '/a/spirit-bo/designs/image/create';

            $.ajax({
                url: ajax_url,
                method: "POST",
                headers: { "Content-Type": "application/json", "Accept": "application/json" },
                data: JSON.stringify({ "image": blob }),
                success: function (response) {

                    console.log('App.backgroundLayer.saveBackgroundImage RESPONSE: ', response);

                    if (response.errors) {

                        console.log('ERRORS: ', response.errors);

                        if ($.isArray(response.errors)) {
                            let errors_text = 'Errors in request \n' + response.errors.join('\n');
                            alert(errors_text);
                        }
                    }
                    else {

                        let img_url = response.image.url;

                        $('#background_image img').attr('src', img_url);

                        $('#add_bg_image').addClass('has-selection');

                        $('#background_image img').one('load', function() {
                            let ratio = $(this).height() / $(this).width();
                            App.backgroundLayer.bg_img_ratio = ratio;

                            console.log('BG Img Ratio calculated: ', ratio);

                            $('#scale_bg_y').val($('#scale_bg_x').val()*ratio);

                            App.backgroundLayer.addOrUpdateBgImages('image', img_url);
                        });

                        self.showBgImgMobileLayerTab('position');
                    }

                }
            }).fail(function(data) {

                console.log('ERROR: App.backgroundLayer.saveBackgroundImage AJAX failed with errors: ', data);

                if (typeof data.responseJSON != 'undefined' && typeof data.responseJSON.message) {
                    let errors_text = 'Errors in request: \n' + data.responseJSON.message;
                    alert(errors_text);
                }
            });

        },

        // Update background color form
        updateBgColorForm: function (color, all_over) {

            let self = this;

            console.log('App.backgroundLayer.updateBgColorForm with color: ', color, ' all_over: ', all_over);

            App.updateColorSwatches('bg');

            self.bg_color_picker.on('show', function() {
                self.bg_color_picker.setColor(color);
            });

            $('#bg_color').val(color);
            $('.js-bg-all-over').prop('checked', !!all_over);
        },

        // Update background image form
        updateBgImgForm: function (data, all_over) {

            let self = this;

            console.log('App.backgroundLayer.updateBgImgForm with data: ', data, ' all_over: ', all_over);

            $(self.bg_image_form).trigger('reset');
            $(App.backgroundLayer.bg_image_form + ' .js-dz-error').text('').addClass('d-none');
            $('.js-bg-all-over').prop('checked', !!all_over);

            if (data) {

                let tiling = data.tiling || true;
                let flip_on_left = data.flip_on_left || false;

                $('#center_bg_x').val(data.center[0]);
                $('#center_bg_y').val(data.center[1]);
                $('#scale_bg_x').val(data.scale[0]);
                $('#scale_bg_y').val(data.scale[1]);
                $('#bg_padding').val(data.padding || 0.00);
                $('#bg_rotation').val(data.rotation || 0.00);

                // Set padding slider values
                $(self.bg_img_padding_handle).text(data.padding || 0.00);
                $(self.bg_img_padding_slider).slider('value', data.padding || 0.00);

                $('#bg_tiling').prop('checked', tiling);
                $('#bg_flip').prop('checked', flip_on_left);

                var rot_deg = App.radiansToNormalizedDeg(data.rotation);
                var sc_val  = parseFloat(data.scale[0]) || 0.5;
                $('#bg_img_rotation_slider').val(rot_deg);
                $('#bg_img_scale_slider').val(sc_val);
                $('#bg_img_scale_display').text(Math.round(sc_val * 100) + '%');
            }
            else {

                $('#add_bg_image').removeClass('has-selection');

                self.showBgImgMobileLayerTab('file');
            }

            App.backgroundLayer.bgImageDropzone.showDropzoneImageLayer(data);
        },

        // Update background pattern form
        updateBgPatternForm: function (data, all_over) {

            let self = this;

            console.log('App.backgroundLayer.updateBgPatternForm with data: ', data, ' all_over: ', all_over);

            $(self.bg_pattern_form).trigger('reset');
            $('#background_pattern img').attr('src', '');
            $('#bg_pat_preview').attr('src', '');
            $('.js-bg-all-over').prop('checked', !!all_over);

            if (data) {

                let flip_on_left = data.flip_on_left || false;
                let tiling = data.tiling || true;

                $('#center_bg_pattern_x').val(data.center[0]);
                $('#center_bg_pattern_y').val(data.center[1]);
                $('#scale_bg_pattern_x').val(data.scale[0]);
                $('#scale_bg_pattern_y').val(data.scale[1]);
                $('#bg_pattern_padding').val(data.padding || 0.00);
                $('#bg_pattern_rotation').val(data.rotation || 0.00);

                $('#bg_pattern_tiling').prop('checked', tiling);
                $('#bg_pattern_flip').prop('checked', flip_on_left);

                var rot_deg = App.radiansToNormalizedDeg(data.rotation);
                var sc_val  = parseFloat(data.scale[0]) || 0.5;
                var cx_val  = parseFloat(data.center[0]) || 0;
                var cy_val  = parseFloat(data.center[1]) || 0;
                $('#bg_pat_rotation_slider').val(rot_deg);
                $('#bg_pat_scale_slider').val(sc_val);
                $('#bg_pat_scale_display').text(Math.round(sc_val * 100) + '%');

                if (typeof data.imageUrl != 'undefined') {

                    if (/patterndesigns/i.test(data.imageUrl)) {

                        $('#background_pattern img').attr('src', data.imageUrl);
                        $('#bg_pat_preview').attr('src', data.imageUrl);

                        $('#add_bg_pattern').addClass('has-selection');

                        $('#background_pattern img').one('load', function() {
                            let ratio = ($(this).height() / $(this).width()).toFixed(6);
                            App.backgroundLayer.bg_pattern_ratio = ratio;

                            console.log('BG Pattern Ratio calculated: ', ratio);

                            $('#scale_bg_pattern_y').val(($('#scale_bg_pattern_x').val()*ratio).toFixed(6));
                        });

                    }
                    else {

                        $('#add_bg_pattern').removeClass('has-selection');
                    }
                }
                else {
                    $('#add_bg_pattern').removeClass('has-selection');
                }
            }
            else {
                $('#add_bg_pattern').removeClass('has-selection');
            }
        },

        // Change background color
        changeBgColor: function (color) {

            console.log(' --- HAS ALL OVER LOGIC');
            console.log('App.backgroundLayer.changeBgColor with color: ', color);

            let self = this;
            let part_name = App.selected_part;
            const all_over = $('.js-bg-all-over').is(':checked');

            if (all_over) {
                $.each(App.available_parts, function (i, part_name) {
                    App.backgroundLayer.deleteBgImageFrom3d(part_name);
                });
            } else {
                App.backgroundLayer.deleteBgImageFrom3d(part_name);
            }

            const bg_data = {
                type: 'color',
                data: color,
                all_over: all_over
            };

            if (all_over) {
                $.each(App.available_parts, function (i, part_name) {

                    const part_data = App.product_schema[part_name];
                    if (!part_data) return;

                    App.saveLayer(part_name, 'bg_color', bg_data);
                    App.updateColorSwatches('bg');

                    if (part_data.materials && part_data.materials.length) {
                        $.each(part_data.materials, function (key, material) {
                            console.log('material: ' + material + '  color: ' + color);



                            Unlimited3D.changeMaterialColor({
                                material: material,
                                color: color
                            }, function (error) {
                                console.log('Unlimited3D.changeMaterialColor ', error ? error : 'SUCCESS');

                            });
                        });

                    }
                });
            } else {
                if (part_name && App.product_schema[part_name].materials.length) {

                    App.saveLayer(part_name, 'bg_color', bg_data);
                    App.updateColorSwatches('bg');

                    $.each(App.product_schema[part_name].materials, function (key, material) {
                        console.log('material: ' + material + '  color: ' + color);
                        Unlimited3D.changeMaterialColor({
                            material: material,
                            color: color
                        }, function (error) {
                            console.log('Unlimited3D.changeMaterialColor ', error ? error : 'SUCCESS');

                        });
                    });
                } else {
                    alert('Select material first');
                }
            }
        },

        updateBgColorIn3d: function (color) {

            let part_name = App.selected_part;
            const all_over = $('.js-bg-all-over').is(':checked');

            if (all_over) {
                $.each(App.available_parts, function (i, pname) {

                    const part_data = App.product_schema[pname];
                    if (!part_data) return;

                    if (part_data.materials && part_data.materials.length) {
                        $.each(part_data.materials, function (key, material) {
                            Unlimited3D.changeMaterialColor({ material: material, color: color }, function () {});
                        });
                    }
                });
            } else {
                if (part_name && App.product_schema[part_name] && App.product_schema[part_name].materials.length) {
                    $.each(App.product_schema[part_name].materials, function (key, material) {
                        Unlimited3D.changeMaterialColor({ material: material, color: color }, function () {});
                    });
                }
            }
        },

        // Delete background color
        deleteBgColorFrom3d: function (part_name, remove_all_over = false) {

            let self = this;

            console.log(' --- HAS ALL OVER LOGIC: ', remove_all_over);
            console.log('App.backgroundLayer.deleteBgColorFrom3d called');

            if (typeof App.product_schema[part_name] != 'undefined') {

                if (typeof App.layers[part_name] != 'undefined' &&
                    typeof App.layers[part_name]['bg'] != 'undefined' &&
                    App.layers[part_name]['bg']['type'] === 'color') {

                    console.log('deleteBgColorFrom3d part: ', part_name);

                    let part_data = App.product_schema[part_name];
                    let materials = part_data.materials;

                    if (materials.length) {

                        $.each(materials, function (key, material_name) {
                            Unlimited3D.changeMaterialColor({
                                    material: material_name,
                                    color: App.product_material_color
                                },
                                function (error) {
                                    if (error) {
                                        console.log('changeMaterialOptions ERROR: ', error);
                                    } else {
                                        console.log('DELETE BG COLOR SUCCESS');

                                        //App.backgroundLayer.updateAllOverPart();
                                        if (remove_all_over) {
                                            self.removeAllOverBackground(part_name);
                                        }
                                    }
                                }
                            );
                        });
                    }
                }
            }
        },

        // Get background image/pattern form data
        getBgImgOrPatternFormData: function (background_type) {

            let self = this;

            console.log('App.backgroundLayer.getBgImageFormData called for background_type: ', background_type);

            let form = background_type === 'pattern' ? $(self.bg_pattern_form) : $(self.bg_image_form);
            let form_data = form.serializeArray();
            let center = [0.0, 0.0];
            let scale = [0.0, 0.0];
            let img_options = {};

            console.log('FORM DATA: ', form_data);

            if (form_data.length) {

                $.each(form_data, function (i, field) {

                    switch (field.name) {
                        case 'center_x':
                            center[0] = parseFloat(field.value);
                            break;
                        case 'center_y':
                            center[1] = parseFloat(field.value);
                            break;
                        case 'scale_x':
                            scale[0] = parseFloat(field.value);
                            break;
                        case 'scale_y':
                            scale[1] = parseFloat(field.value);
                            break;
                        case 'tiling':
                            img_options['tiling'] = field.value === 'on';
                            break;
                        case 'flip_on_left':
                            img_options['flip_on_left'] = field.value === 'on';
                            break;
                        case 'imageFileName':
                            img_options[field.name] = field.value;
                            break;

                        default:
                            if (field.value && field.value.length) {
                                img_options[field.name] = parseFloat(field.value);
                            }
                    }
                });

                img_options['tiling'] = img_options['tiling'] || false;
                img_options['flip_on_left'] = img_options['flip_on_left'] || false;
                img_options['center'] = center;
                img_options['scale'] = scale;
            }

            console.log('getBgImgOrPatternFormData img_options: ', img_options);

            return img_options;
        },

        // Add pattern design image
        addPatternDesignImage: function () {

            console.log('App.backgroundLayer.addPatternDesignImage called');

            let self = this;
            let colors = '';
            $.each(_patternDesignWidget.selectedDesign.colors, function (key, color) {
                colors += color + ',';
            });
            colors = colors.substring(0, colors.length - 1);

            let img_url = patternDesignApiUrl + 'pattern/recolor?id=' + _patternDesignWidget.selectedDesign.id + '&resolution=1024';

            if (colors !== '') {
                img_url += '&colors=' + colors;
            }

            console.log('PATTERN URL: ', img_url);

            $('#background_pattern img').attr('src', img_url);
            $('#bg_pat_preview').attr('src', img_url);

            $('#add_bg_pattern').addClass('has-selection');

            $('#background_pattern img').one('load', function() {
                let ratio = ($(this).height() / $(this).width()).toFixed(6);
                App.backgroundLayer.bg_pattern_ratio = ratio;

                console.log('BG Pattern Ratio calculated: ', ratio);

                $('#scale_bg_pattern_y').val(($('#scale_bg_pattern_x').val()*ratio).toFixed(6));

                self.addOrUpdateBgImages('pattern', img_url);
            });
        },

        // Add background images
        addOrUpdateBgImages: function (bg_type, image_url) {

            console.log(' --- HAS ALL OVER LOGIC');
            console.log('App.backgroundLayer.addOrUpdateBgImages');

            let self = this;
            let background_type = bg_type || 'image';
            let img_url = image_url || null;
            const all_over = $('.js-bg-all-over').is(':checked');

            if (all_over) {
                $.each(App.available_parts, function (i, part_name) {
                    self.addOrUpdateBgImage(part_name, background_type, img_url);
                });
            } else {
                self.addOrUpdateBgImage(App.selected_part, background_type, img_url);
            }
        },

        // Add background image
        addOrUpdateBgImage: function (part_name, background_type, image_url) {

            let self = this;
            let imageUrl = image_url || null;

            console.log('App.backgroundLayer.addOrUpdateBgImages called for part: ' + part_name + ' and type ' + background_type);

            if (typeof App.product_schema[part_name] != 'undefined') {

                App.backgroundLayer.deleteBgColorFrom3d(part_name);

                let part_data = App.product_schema[part_name];
                let img_options = self.getBgImgOrPatternFormData(background_type);

                if (imageUrl) {
                    img_options['imageUrl'] = image_url;
                }

                console.log('addOrUpdateBgImage img_options: ', img_options);
                console.log('addOrUpdateBgImage part_name: ', part_name);

                const all_over = $('.js-bg-all-over').is(':checked');

                let bg_data = {
                    type: background_type,
                    data: img_options,
                    all_over: all_over
                };

                App.saveLayer(part_name, 'bg', bg_data);

                if (imageUrl && background_type === 'pattern') {
                    App.selected_pattern = img_options;
                }

                let overlay = part_data.overlay;
                let background = part_data.bg;

                // Check if we have background config
                console.log('part_data: ', part_data);
                console.log('overlay: ', overlay);
                console.log('background: ', background);

                if (overlay && background) {

                    let overlay_data = {
                        overlay: overlay,
                        overlayEntry: background['name'],
                        options: {
                            ...img_options,
                            flipH: App.pair_side === 'left' && !!img_options.flip_on_left
                        }
                    };

                    Unlimited3D.updateOverlay(overlay_data, function (error) {
                        if (error) {
                            console.log('App.backgroundLayer.addOrUpdateBgImage ERROR: ', error);
                        }
                    });
                }
            } else {
                console.log('App.backgroundLayer.addOrUpdateBgImage ERROR: Select part first!');
            }
        },

        // Delete background image
        deleteBgImageFrom3d: function (part_name, remove_all_over = false) {

            let self = this;

            if (typeof App.product_schema[part_name] != 'undefined') {

                console.log(' --- HAS ALL OVER LOGIC: ', remove_all_over);
                console.log('App.backgroundLayer.deleteBgImageFrom3d called');

                if (typeof App.layers[part_name] != 'undefined' &&
                    typeof App.layers[part_name]['bg'] != 'undefined' &&
                    (App.layers[part_name]['bg']['type'] === 'image' || App.layers[part_name]['bg']['type'] === 'pattern')) {

                    console.log('Delete Bg Image or Pattern part: ', part_name);

                    let part_data = App.product_schema[part_name];
                    let overlay = part_data.overlay;
                    let background = part_data.bg;

                    if (overlay && background) {

                        let overlay_entry_name = background['name'];

                        let overlay_data = {
                            overlay: overlay,
                            overlayEntry: overlay_entry_name,
                            options: {
                                imageUrl: '',
                            }
                        };

                        Unlimited3D.updateOverlay(overlay_data, function (error) {
                            if (error) {
                                console.log('App.backgroundLayer.deleteBgImageFrom3d ERROR: ', error);
                            } else {
                                console.log('DELETE BG IMAGE SUCCESS');

                                //App.backgroundLayer.updateAllOverPart();

                                if (remove_all_over) {
                                    self.removeAllOverBackground(part_name);
                                }
                            }
                        });
                    }
                }
            }
        },

        resetAllOverCheckbox: function() {
            $('.js-bg-all-over').prop('checked', false);
        },

        removeAllOverBackground: function(part_name) {

            let self = this;

            console.log(' --- REMOVE ALL OVER BACKGROUND CALLED FOR PART: ', part_name);

            // combined никога не носи bg слой
            const combined_id = App.combined_part_id;
            if (combined_id && App.layers[combined_id] && typeof App.layers[combined_id].bg !== 'undefined') {
                delete App.layers[combined_id].bg;
            }

            $.each(App.available_parts, function(i, p) {
                if (p !== part_name && typeof App.layers[p] !== 'undefined' && typeof App.layers[p].bg !== 'undefined') {
                    let bg_type = App.layers[p].bg.type;
                    App.backgroundLayer.deleteBgColorFrom3d(p);
                    App.backgroundLayer.deleteBgImageFrom3d(p);
                    App.deleteLayerConfig(p, 'bg', bg_type, null);
                    App.deleteLayerFromDom(p, 'bg', null, false);
                }
            });
        },

        showBgImgMobileLayerTab: function (tab) {

            let self = this;

            console.log('App.backgroundLayer.showBgImgMobileLayerTab called with tab: ', tab);

            $('#add_bg_image .js-sw-show-bg-img-tab').removeClass('active');
            $('#add_bg_image .js-sw-show-bg-img-tab[data-tab="'+tab+'"]').addClass('active');

            $('#add_bg_image .js-m-tab').addClass('d-none');
            $('#add_bg_image .js-m-tab.tab-' + tab).removeClass('d-none');
        },

    },

    imageLayer: {
        layer_type: 'image',
        form: '#img_form',
        ratio: 1,
        slider_throttle_timer: null,
        slider_throttle_last: 0,
        SLIDER_THROTTLE_MS: 100,
        imageDropzone: {

            dropzoneId: '#dropzone_image',

            previewTemplate: '<div class="dropzone-item d-none">' +
                '               <div class="dropzone-file">' +
                '                   <div class="part-image bg-secondary">' +
                '                       <img src="" />' +
                '                   </div>' +
                '                   <div class="dropzone-filename" title="file name">' +
                '                       <span class="js-dz-name"></span>' +
                '                       <strong>(<span class="js-dz-size"></span>)</strong>' +
                '                   </div>' +
                '               </div>' +
                '               <div class="dropzone-toolbar">' +
                '                    <span class="dropzone-delete js-dz-remove" >' +
                '                       <i class="fa fa-trash text-danger"></i>' +
                '                    </span>' +
                '               </div>' +
                '           </div>',

            init: function() {

                let self = this;

                console.log('App.imageLayer.imageDropzone.init called');

                let dropzone_id = self.dropzoneId;

                let dz_el = document.querySelector(dropzone_id);

                if (!dz_el || dz_el.dropzone) {
                    console.log('Dropzone already attached to ' + dropzone_id + ' - skipping');
                    return;
                }

                let size_limit = parseFloat(App.image_bytes_limit / (1024*1024)).toFixed(2);
                $(dropzone_id + ' .js-max-file-size').text(size_limit + 'MB');

                let dropzone_ajax_url = '/a/spirit-bo/designs/image/chunk';

                let img_dropzone_options = {
                    url: dropzone_ajax_url,
                    headers: { "Accept": "application/json" },
                    maxFilesize: size_limit,
                    method: 'post',
                    chunking: true,
                    chunkSize: 1 * 1000 * 1000,
                    retryChunks: true,
                    retryChunksLimit: 3,
                    autoProcessQueue: false,
                    parallelUploads: 1,
                    paramName: 'image',
                    acceptedFiles: 'image/jpeg,image/jpg,image/png,image/gif,image/webp',
                    previewTemplate: self.previewTemplate,
                    previewsContainer: dropzone_id + ' .dropzone-items',
                    //clickable: dropzone_id + ' .dropzone-select',
                    addedfiles: function () {
                        // $('#sw_product_config_modal_image_flip').attr('data-mode', 'dropzone').modal('show');
                        this.processQueue();
                    },
                    uploadprogress: function(file, progress, bytesSent) {
                        let progress_int = parseInt(progress);
                        $(dropzone_id + ' .dropzone-progress .progress-bar').css('width', progress_int + '%').text(progress_int + '%');
                    },
                    success: function (file, response) {

                        console.log(' --- DROPZONE S3 URL: ', response.image.url);

                        $(dropzone_id + ' .dropzone-progress').addClass('d-none');

                        img_dropzone.removeFile(file);

                        if (response.errors) {

                            console.log('ERRORS: ', response.errors);

                            if ($.isArray(response.errors)) {
                                let errors_text = 'Errors in request \n' + response.errors.join('\n');
                                alert(errors_text);
                            }
                        }
                        else {

                            let file_url = response.image.url;

                            $('#add_image').addClass('has-selection');

                            $('#part_image img').attr('src', file_url);
                            $('#img_preview').attr('src', file_url);

                            $('#part_image img').one('load', function() {

                                console.log('Image has loaded');

                                self.updateDzItem(file_url);

                                let index = $('#img_form').data('index');

                                App.imageLayer.addOrUpdateImage('add', index, file_url);
                            });
                        }
                    },
                    error: function(file, message) {

                        console.log('  ---  DROPZONE error message: ', message);

                        let error_container = $(App.imageLayer.form + ' .js-dz-error');

                        if (typeof message === 'string') {
                            error_container.text(message).removeClass('d-none');
                        }

                        if (typeof message.message != 'undefined') {
                            error_container.text(message.message).removeClass('d-none');
                        }

                        if (typeof message.error != 'undefined') {
                            error_container.text(message.error).removeClass('d-none');
                        }

                        if (typeof message.errors != 'undefined' && $.isArray(message.errors)) {
                            let errors_text = 'Errors in request <br>' + message.errors.join('<br>');
                            error_container.html(errors_text).removeClass('d-none');
                        }
                    }
                };

                let img_dropzone = new Dropzone(dropzone_id, img_dropzone_options);

                img_dropzone.on('addedfiles', function (file, xhr, formData) {
                    $(dropzone_id + ' .dropzone-progress .progress-bar').css('width', 0);
                });

                img_dropzone.on('sending', function (file, xhr, formData) {
                    $(App.imageLayer.form + ' .js-dz-error').text('').addClass('d-none');
                    $(dropzone_id + ' .dropzone-progress').removeClass('d-none');
                });

                $(document).on('click', '.js-sw-dropzone-flip-image', function () {

                    let flip_input = $(this).closest('.modal').find('input[type="radio"]:checked').val();

                    if (flip_input === '1') {

                        $('#img_flip').prop('checked', true);
                    } else {

                        $('#img_flip').prop('checked', false);
                    }

                    img_dropzone.processQueue();
                });
            },

            updateDzItem: function(file_url) {

                let self = this;

                console.log('App.imageLayer.imageDropzone.removeFile called');

                let dropzone_id = self.dropzoneId;
                let image_container = $('#part_image img')

                image_container.attr('src', file_url);

                let ratio = image_container.height() / image_container.width();
                App.imageLayer.ratio = ratio;

                //console.log('Ratio calculated: ', ratio);

                $('#scale_img_y').val(($('#scale_img_x').val())*ratio);
            },

            showDropzoneImageLayer: function(data) {

                let self = this;

                console.log('App.imageLayer.imageDropzone.showDropzoneImageLayer called');

                let dropzone_id = self.dropzoneId;

                $(dropzone_id + ' .dropzone-item').remove();

                if (data && typeof data.imageUrl != 'undefined') {

                    $('#add_image').addClass('has-selection');
                    let file_url = data.imageUrl || '';

                    $('#part_image img').attr('src', file_url);
                    $('#img_preview').attr('src', file_url);

                    $('#part_image img').one('load', function() {

                        console.log('Image has loaded');

                        self.updateDzItem(file_url);

                        let index = $('#img_form').data('index');

                        App.imageLayer.addOrUpdateImage('update', index, file_url);
                    });
                }
                else {

                    $('#add_image').removeClass('has-selection');

                    //App.imageLayer.showMobileLayerTab('file');
                }
            }
        },

        init: function () {

            let self = this;

            self.imageDropzone.init();

            self.vectEezy.init();

            self.AI.init();

            // Change any image option
            $(document).on('change', '#img_form', function () {
                let index = $(this).data('index') || 0;
                let img_url = null;
                let image_src = $('#part_image img').attr('src');
                if (image_src !== '') {
                    img_url = image_src;
                }

                clearTimeout(self.slider_throttle_timer);
                var fire = function() {
                    self.slider_throttle_last = Date.now();
                    self.addOrUpdateImage('update', index, img_url);
                };
                if (Date.now() - self.slider_throttle_last >= self.SLIDER_THROTTLE_MS) {
                    fire();
                } else {
                    self.slider_throttle_timer = setTimeout(fire, self.SLIDER_THROTTLE_MS);
                }
            });

            // $(document).on('click', '.js-sw-show-img-tab', function() {
            //
            //     console.log('js-sw-show-img-tab clicked');
            //
            //     let m_img_tab = $(this).data('tab');
            //
            //     console.log('m_img_tab: ', m_img_tab);
            //
            //     App.imageLayer.showMobileLayerTab(m_img_tab);
            // });

            // Click on delete layer button
            $(document).on('click', '.js-sw-delete-img-layer', function () {
                const index = $('#img_form').data('index') || 0;
                App.toggleCustomizerButtons(0);
                $('#add_image').removeClass('has-selection');
                App.deleteLayer(App.selected_part, 'img', null, index);
            });

            $(document).on('input', '.sw-img-slider', function () {

                let type = $(this).data('type');
                let val  = parseFloat($(this).val());

                switch (type) {
                    case 'rotation':
                        var radians = parseFloat((val * Math.PI / 180).toFixed(6));
                        $('#img_rotation').val(radians);
                        break;
                    case 'scale':
                        var ratio = App.imageLayer.ratio || 1;
                        $('#scale_img_x').val(val);
                        $('#scale_img_y').val(parseFloat((val * ratio).toFixed(6)));
                        $('#img_scale_display').text(Math.round(val * 100) + '%');
                        break;
                    case 'position_x':
                        $('#center_img_x').val(val);
                        break;
                    case 'position_y':
                        $('#center_img_y').val(val);
                        break;
                }

                $('#img_form').trigger('change');
            });
        },

        updateImgForm: function (data, is_revert) {

            let self = this;

            console.log('App.imageLayer.updateImgForm with data: ', data);

            $('#img_form').trigger('reset');
            $(App.imageLayer.form + ' .js-dz-error').text('').addClass('d-none');

            console.log('form: ', $(self.form).serializeArray());

            if (data) {
                let tiling = data.tiling || false;
                let flip_on_left = data.flip_on_left || false;

                $('#center_img_x').val(data.center[0]);
                $('#center_img_y').val(data.center[1]);
                $('#scale_img_x').val(data.scale[0]);
                $('#scale_img_y').val(data.scale[1]);
                $('#img_padding').val(data.padding || 0.01);
                $('#img_rotation').val(data.rotation || 0.00);

                var rot_deg = App.radiansToNormalizedDeg(data.rotation);
                var sc_val  = parseFloat(data.scale[0]) || 1;
                var cx_val  = parseFloat(data.center[0]) || 0;
                var cy_val  = parseFloat(data.center[1]) || 0;
                $('#img_rotation_slider').val(rot_deg);
                $('#img_scale_slider').val(sc_val);
                $('#img_scale_display').text(Math.round(sc_val * 100) + '%');
                $('#img_tiling').prop('checked', tiling);
                $('#img_flip').prop('checked', flip_on_left);

                let img_url = data.imageUrl || null;

                if (!img_url) {

                    $('#add_image').removeClass('has-selection');

                    //App.imageLayer.showMobileLayerTab('file');
                }
            }
            else {

                $('#add_image').removeClass('has-selection');

                //App.imageLayer.showMobileLayerTab('file');
            }

            if (!is_revert) {

                App.imageLayer.imageDropzone.showDropzoneImageLayer(data);
            }
        },

        getImageFormData: function () {

            let self = this;

            let form_data = $(self.form).serializeArray();
            let center = [0.0, 0.0];
            let scale = [0.0, 0.0];
            let img_options = {};

            if (form_data.length) {

                $.each(form_data, function (i, field) {
                    switch (field.name) {
                        case 'center_x':
                            center[0] = parseFloat(field.value);
                            console.log('centerX: ', center[0]);
                            break;
                        case 'center_y':
                            center[1] = parseFloat(field.value);
                            console.log('centerY: ', center[1]);
                            break;
                        case 'scale_x':
                            scale[0] = parseFloat(field.value);
                            break;
                        case 'scale_y':
                            scale[1] = parseFloat(field.value);
                            break;
                        case 'tiling':
                            img_options['tiling'] = field.value === 'on';
                            break;
                        case 'flip_on_left':
                            img_options['flip_on_left'] = field.value === 'on';
                            break;
                        case 'imageFileName':
                            img_options[field.name] = field.value;
                            break;

                        default:
                            if (field.value && field.value.length) {
                                img_options[field.name] = parseFloat(field.value);
                            }
                    }
                });

                img_options['tiling'] = img_options['tiling'] || false;
                img_options['flip_on_left'] = img_options['flip_on_left'] || false;
                img_options['center'] = center;
                img_options['scale'] = scale;
            }

            console.log('getImageFormData img_options: ', img_options);

            return img_options;
        },

        addOrUpdateImage: function (action, index, image_url, extra_options) {

            let self = this;
            const combined_id  = App.combined_part_id;
            const part_schema  = App.product_schema[App.selected_part];
            const combined_schema = App.product_schema[combined_id];

            // Default опциите идват от панела, но overlay-ът е combined
            const overlay      = combined_schema.overlay;
            const image_entry  = combined_schema.img[index];
            const image_parsed_url = image_url || null;

            console.log('addOrUpdateImage action:', action, 'index:', index);

            if (part_schema && overlay && image_entry) {

                let img_options = App.imageLayer.getImageFormData();

                if (image_parsed_url) {
                    img_options['imageUrl'] = image_parsed_url;
                }

                if (extra_options) {
                    img_options = Object.assign(img_options, extra_options);
                }

                if (!$.isEmptyObject(img_options)) {

                    if (action === 'add') {
                        App.saveLayer(combined_id, 'img', img_options, index);
                    } else {
                        App.updateLayer(combined_id, 'img', img_options, index);
                    }

                    Unlimited3D.updateOverlay({
                        overlay:      overlay,
                        overlayEntry: image_entry.name,
                        options: {
                            ...img_options,
                            flipH: App.pair_side === 'left' && !!img_options.flip_on_left
                        }
                    }, function (error) {
                        if (error) {
                            console.log('addOrUpdateImage ERROR:', error);
                        }
                    });
                }

            } else {
                alert('Select part with image overlay first');
            }
        },

        deleteImageFrom3d: function (part_name, index) {
            const combined_id = App.combined_part_id || part_name;
            const combined_schema = App.product_schema[combined_id];
            if (!combined_schema) return;

            const overlay = combined_schema.overlay;
            const image   = combined_schema.img ? combined_schema.img[index] : null;

            if (overlay && image) {
                let overlay_entry_name = image['name'];

                Unlimited3D.updateOverlay({
                    overlay: overlay,
                    overlayEntry: overlay_entry_name,
                    options: {
                        imageUrl: '',
                    }
                }, function (error, response) {
                    if (error) {
                        console.log('App.imageLayer.deleteImageFrom3d ERROR: ', error);
                    } else {
                        console.log('DELETE IMAGE SUCCESS');
                    }
                });
            }
        },

        vectEezy: {
            imagesPerPage: 60,
            currentPage: 1,
            maxPages: 1,
            URL: '/a/spirit-bo/vecteezy',
            BEARER: 'Bearer ckqqJXkU3ze6PbS6eSHU7fTr',
            contentType: 'png',
            orientation: 'square',
            sortBy: 'relevance',
            aiGenerated: 1,
            initialTerm: 'tattoo',

            selectedUrl: null,
            selectedName: null,

            isLoading: false,
            currentTerm: '',
            $scrollEl: null,
            thresholdPx: 200,

            debounceMs: 100,
            debounceId: null,
            pendingXhr: null,
            queryVersion: 0,

            init: function () {

                let self = this;

                console.log('App.imageLayer.vectEezy.init called!');

                $('#vecteezy_search').attr('placeholder', self.initialTerm);

                $(document).on('input', '#vecteezy_form input[name="vecteezy_search"]', function () {
                    // Kill any in-flight request immediately on new input
                    if (self.pendingXhr && self.pendingXhr.readyState !== 4) {
                        try { self.pendingXhr.abort(); } catch(_) {}
                        self.pendingXhr = null;
                        self.isLoading = false;
                    }
                    // Debounce
                    clearTimeout(self.debounceId);
                    self.debounceId = setTimeout(function () {
                        let nextTerm = $('#vecteezy_form').find('input[name="vecteezy_search"]').val().trim();

                        // If term changed, reset paging & list
                        if (nextTerm !== self.currentTerm) {
                            self.currentTerm = nextTerm;
                            self.currentPage = 1;
                            self.maxPages = 1;
                            $('#vecteezy_images').empty();
                        }

                        // Only search when there is a term
                        if (self.currentTerm) {
                            self.queryVersion += 1; // bump version to invalidate older responses
                            self.searchImages(self.currentTerm, self.queryVersion);
                        } else {
                            // No term: clear UI state
                            $('#vecteezy_no_images_found').addClass('d-none');
                            $('#vecteezy_all_results_loaded').addClass('d-none');
                            $('#vecteezy_images_loading').addClass('d-none');
                        }
                    }, self.debounceMs);
                });

                // Prevent form submit
                $(document).on('submit', '#vecteezy_form', function(e) {
                    e.preventDefault();
                });

                $(document).on('click', '.js-vecteezy-img', function() {
                    let selected_id = $(this).attr('id');
                    console.log('vectEezy image clicked: ', selected_id);
                    self.setSelectedImage(selected_id);
                });

                $(document).on('click', '.js-select-vecteezy-image', function() {
                    $('#sw_vecteezy_modal').modal('hide');
                    // $('#sw_product_config_modal_image_flip').attr('data-mode', 'vecteezy').modal('show');
                    self.selectImage();
                });

                $(document).on('click', '.js-sw-vecteezy-flip-image', function() {

                    let flip_input = $(this).closest('.modal').find('input[type="radio"]:checked').val();

                    if (flip_input === '1') {

                        $('#img_flip').prop('checked', true);
                    } else {

                        $('#img_flip').prop('checked', false);
                    }

                    self.selectImage();
                });

                // Modal container
                let $modal = $('#sw_vecteezy_modal');

                // Load next page on scroll
                $modal.on('shown.bs.modal', function () {

                    if (self.initialTerm) {
                        self.searchImages(self.initialTerm);
                    }

                    self.$scrollEl = $(this).find('.modal-body');
                    // avoid duplicate handlers
                    self.$scrollEl.off('scroll.vz').on('scroll.vz', function () {
                        self.loadMore();
                    });
                });

                // reset pages on scroll
                $modal.on('hidden.bs.modal', function () {
                    if (self.$scrollEl) self.$scrollEl.off('scroll.vz');
                    clearTimeout(self.debounceId);
                    if (self.pendingXhr && self.pendingXhr.readyState !== 4) {
                        try { self.pendingXhr.abort(); } catch(_) {}
                    }
                    self.reset();
                    $('#vecteezy_images').empty();
                });
            },

            reset: function () {
                this.isLoading = false;
                this.currentPage = 1;
                this.maxPages = 1;
                this.currentTerm = '';
                $('#vecteezy_form').find('input[name="vecteezy_search"]').val('');
            },

            nearBottom: function () {
                var el = this.$scrollEl && this.$scrollEl[0];
                if (!el) return false;
                return (el.scrollTop + el.clientHeight) >= (el.scrollHeight - this.thresholdPx);
            },

            loadMore: function () {
                // Only attempt if: not loading, have a term, more pages exist, and near bottom
                if (this.isLoading) return;
                if (!this.currentTerm) return;
                if (this.maxPages && this.currentPage > this.maxPages) return;
                if (!this.nearBottom()) return;

                this.searchImages(this.currentTerm, this.queryVersion);
            },

            setSelectedImage: function(id) {

                let self = this;

                $('#sw_vecteezy_modal .js-vecteezy-img').removeClass('selected');
                $('#sw_vecteezy_modal .js-select-vecteezy-image').attr('disabled', true);

                let $selected = $(`#${id}`);

                console.log('Selected image: ', id);
                console.log('$selected: ', $selected);
                console.log('$selected.length: ', $selected.length);

                if (!$selected.length) return;

                self.selectedUrl = $selected.attr('data-url');
                self.selectedName = $selected.attr('data-name');
                self.selectedId = $selected.attr('data-id') || null;

                $selected.addClass('selected');
                $('#sw_vecteezy_modal .js-select-vecteezy-image').removeAttr('disabled');
            },

            selectImage: function () {

                let self = this;

                console.log('Select image: ', self.selectedUrl);
                console.log('Name: ', self.selectedName);

                if (!self.selectedUrl || !self.selectedName) return;

                $('#add_image').addClass('has-selection');

                $('#part_image img').attr('src', self.selectedUrl);
                $('#img_preview').attr('src', self.selectedUrl);

                $('#part_image img').one('load', function() {

                    console.log('Image has loaded');

                    App.imageLayer.imageDropzone.updateDzItem(self.selectedUrl, self.selectedName);

                    let index = $('#img_form').data('index');

                    App.imageLayer.addOrUpdateImage('add', index, self.selectedUrl, self.selectedId ? { vecteezy_id: self.selectedId } : null);
                });
            },

            searchImages: function (search_term = null, version = null) {

                let self = this;

                console.log('Search images');

                let $form = $('#vecteezy_form');
                let term = (search_term || $form.find('input[name="vecteezy_search"]').val() || '').trim();
                let $out = $('#vecteezy_images');

                if (!term) return;

                // If user typed a new term without submit first, reset paging
                if (self.currentTerm !== term) {
                    self.currentTerm = term;
                    self.currentPage = 1;
                    self.maxPages = 1;
                    $out.empty();
                }

                // stop if we know we’re past the end
                if (self.maxPages && self.currentPage > self.maxPages) return;

                let isFirstPage = (self.currentPage === 1);
                let $list = $('#vz-list');

                // Show loading indicators
                if (isFirstPage) {
                    $out.html('<ul class="sw-vecteezy-images-list" id="vz-list"></ul>');
                    $list = $('#vz-list');
                }

                $('#vecteezy_images_loading').removeClass('d-none');
                $('#vecteezy_all_results_loaded').addClass('d-none');
                $('#vecteezy_no_images_found').addClass('d-none');

                self.isLoading = true;

                // Abort any previous in-flight request
                if (self.pendingXhr && self.pendingXhr.readyState !== 4) {
                    try { self.pendingXhr.abort(); } catch(_) {}
                }

                // Keep the version we’re issuing this request for
                let reqVersion = (version != null ? version : ++self.queryVersion);

                console.log('AJAX REACHED, v' + reqVersion);

                self.pendingXhr = $.ajax({
                    url: self.URL,
                    method: 'GET',
                    dataType: 'json',
                    headers: { "Accept": "application/json" },
                    data: {
                        term: term,
                        content_type: self.contentType,
                        page: self.currentPage,
                        per_page: self.imagesPerPage,
                        sort_by: self.sortBy,
                        ai_generated: self.aiGenerated,
                        orientation: self.orientation
                    }
                }).done(function (resp) {
                    // Ignore stale responses (a newer queryVersion exists)
                    if (reqVersion !== self.queryVersion) {
                        console.log('Stale response ignored, v' + reqVersion + ' != current v' + self.queryVersion);
                        return;
                    }

                    let items = resp && resp.resources ? resp.resources : [];

                    if (isFirstPage && !items.length) {
                        $('#vecteezy_no_images_found').removeClass('d-none');
                        return;
                    }

                    function esc(s){
                        return String(s||'').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
                    }

                    let buf = [];
                    for (let i = 0; i < items.length; i++) {
                        let it = items[i];
                        let id = it.id;
                        let title = esc(it.title || '');
                        let thumb = it.thumbnail_url || null;
                        let url = it.preview_url || null;
                        if (thumb && url) {
                            buf.push('<li><a href="javascript:;" id="vecteezi_img_'+id+'" class="js-vecteezy-img" data-id="'+id+'" data-url="' + esc(url) + '" data-name="'+title+'"><img src="' + esc(thumb) + '" alt="' + title + '"></a></li>');
                        }
                    }
                    $('#vz-list').append(buf.join(''));

                    // update paging
                    self.currentPage += 1;
                    self.maxPages = Number(resp.last_page || resp.total_pages || self.maxPages || 1);

                    // Show “end” marker when done
                    if (self.currentPage > self.maxPages) {
                        $('#vecteezy_all_results_loaded').removeClass('d-none');
                    }
                }).fail(function (xhr) {
                    // Ignore failures from aborted old requests
                    if (xhr && xhr.statusText === 'abort') return;

                    console.error('Vecteezy error:', xhr.status, xhr.responseText);

                    if (isFirstPage) $('#vecteezy_images').html('<p>Error fetching images (' + xhr.status + ').</p>');

                }).always(function (_data, textStatus) {
                    // If this request was aborted, don't touch the loader.
                    if (textStatus === 'abort') {
                        self.pendingXhr = null;
                        return;
                    }

                    // Only hide loader if this response matches current version
                    if (reqVersion === self.queryVersion) {
                        $('#vecteezy_images_loading').addClass('d-none');
                        self.isLoading = false;
                    }
                    self.pendingXhr = null;
                });
            },
        },

        AI: {
            imagesPerPage: 60,
            currentPage: 1,
            maxPages: 1,
            URL: '/a/spirit-bo/vecteezy',
            presetsURL: '/a/spirit-bo/graffities',
            generateURL: '/a/spirit-bo/graffities/create',
            BEARER: 'Bearer ckqqJXkU3ze6PbS6eSHU7fTr',
            contentType: 'png',
            orientation: 'square',
            sortBy: 'relevance',
            aiGenerated: 1,
            initialTerm: 'tattoo',
            inputValue: '',

            selectedUrl: null,
            selectedName: null,

            isLoading: false,
            currentTerm: '',
            $scrollEl: null,
            thresholdPx: 200,

            debounceMs: 100,
            debounceId: null,
            pendingXhr: null,
            queryVersion: 0,

            init: function () {

                let self = this;

                console.log('App.imageLayer.AI.init called!');

                // Prevent form submit
                $(document).on('submit', '#ai_form', function(e) {
                    e.preventDefault();
                });

                $(document).on('input', '#ai_image_form input[name="ai_search"]', function () {

                    this.value = this.value.replace(/[^\x00-\x7F]/g, '');

                    self.term = $(this).val() || '';

                    const selectedImage = $('#ai_images_presets .js-ai-preset-img.selected').length;

                    if (selectedImage && self.term.length) {
                        $('#sw_ai_modal .js-generate-ai-image').attr('disabled', false);
                    } else {
                        $('#sw_ai_modal .js-generate-ai-image').attr('disabled', true);
                    }
                });

                $(document).on('click', '.js-ai-preset-img', function() {
                    let selected_id = $(this).attr('id');
                    console.log('AI image clicked: ', selected_id);
                    self.setSelectedImage(selected_id);
                });

                $(document).on('click', '.js-select-ai-image', function() {
                    $('#sw_ai_modal').modal('hide');
                    // $('#sw_product_config_modal_image_flip').attr('data-mode', 'ai').modal('show');
                    $('#sw_ai_modal #ai_images').addClass('d-none');
                    $('#sw_ai_modal #ai_image_form').removeClass('d-none');
                    $('#sw_ai_modal .js-select-ai-image').addClass('d-none');
                    $('#sw_ai_modal .js-generate-ai-image').removeClass('d-none').attr('disabled', true);
                    $('#ai_image_form input[name="ai_search"]').val('');
                    self.term = '';

                    $('#img_flip').prop('checked', true);
                    self.selectImage();
                });

                $(document).on('click', '.js-generate-ai-image', function () {

                    self.generateImage();
                });

                $(document).on('click', '.js-regenerate-ai-image', function () {

                    $(this).addClass('d-none');
                    $('#sw_ai_modal .js-select-ai-image').attr('disabled', true);
                    self.generateImage();
                });

                $(document).on('click', '.js-back-to-generation', function () {
                    $(this).addClass('d-none');
                    $('#sw_ai_modal #ai_image_form, #sw_ai_modal #sw_ai_form, #sw_ai_modal #ai_images_presets, #sw_ai_modal .js-generate-ai-image, #sw_ai_modal .modal-footer button[data-bs-dismiss="modal"]').removeClass('d-none');
                    $('#sw_ai_modal .js-regenerate-ai-image, #sw_ai_modal .js-select-ai-image').addClass('d-none')
                    $('#sw_ai_modal #ai_images').addClass('d-none').empty();
                    $('#sw_ai_modal .js-select-ai-image').attr('disabled', true);
                });

                $(document).on('click', '.js-sw-ai-flip-image', function() {

                    let flip_input = $(this).closest('.modal').find('input[type="radio"]:checked').val();

                    if (flip_input === '1') {

                        $('#img_flip').prop('checked', true);
                    } else {

                        $('#img_flip').prop('checked', false);
                    }

                    $('#sw_ai_modal #ai_images').addClass('d-none');
                    $('#sw_ai_modal #ai_image_form').removeClass('d-none');
                    $('#sw_ai_modal .js-select-ai-image').addClass('d-none');
                    $('#sw_ai_modal .js-generate-ai-image').removeClass('d-none').attr('disabled', true);

                    $('#ai_image_form input[name="ai_search"]').val('');
                    self.term = '';

                    self.selectImage();
                });

                // Modal container
                let $modal = $('#sw_ai_modal');

                // Load next page on scroll
                $modal.on('show.bs.modal', function () {

                    $('#sw_ai_modal .js-generate-ai-image').removeClass('d-none');
                    $('#sw_ai_modal .js-regenerate-ai-image, #sw_ai_modal .js-select-ai-image, #sw_ai_modal .js-back-to-generation').addClass('d-none');
                });

                $modal.on('shown.bs.modal', function () {

                    const aiInput = $('#ai_image_form input[name="ai_search"]');

                    self.term = aiInput.val() || '';

                    aiInput.focus();

                    self.getPresets();
                });

                $modal.on('hidden.bs.modal', function () {

                    $('#sw_ai_modal #ai_images, #sw_ai_modal #ai_images_presets').addClass('d-none');
                    $('#sw_ai_modal .modal-footer button[data-bs-dismiss="modal"]').removeClass('d-none');
                    $('#sw_ai_modal #ai_image_form').removeClass('d-none');

                    $('#sw_ai_modal .js-generate-ai-image').removeClass('d-none');
                    $('#sw_ai_modal .js-select-ai-image').addClass('d-none');

                    $('#sw_ai_modal #ai_search').val('').trigger('input');
                });
            },

            reset: function () {
                this.isLoading = false;
                $('#ai_form').find('input[name="ai_search"]').val('');
            },

            setSelectedImage: function(id) {

                let self = this;

                $('#sw_ai_modal .js-ai-preset-img').removeClass('selected');

                console.log('term: ', self.term)

                let $selected = $(`#${id}`);

                console.log('Selected image: ', id);
                console.log('$selected: ', $selected);
                console.log('$selected.length: ', $selected.length);

                if (!$selected.length) return;

                $selected.addClass('selected');
                if (self.term.length) {

                    $('#sw_ai_modal .js-generate-ai-image').attr('disabled', false);
                }
            },

            selectImage: function () {

                let self = this;

                const $selected = $('#ai_images > img');
                self.selectedUrl = $selected.attr('data-url');
                self.selectedName = $selected.attr('data-name');

                console.log('Select image: ', self.selectedUrl);
                console.log('Name: ', self.selectedName);

                if (!self.selectedUrl || !self.selectedName) return;

                $('#add_image').addClass('has-selection');

                $('#part_image img').attr('src', self.selectedUrl);
                $('#img_preview').attr('src', self.selectedUrl);

                $('#part_image img').one('load', function() {

                    console.log('Image has loaded', this);

                    App.imageLayer.imageDropzone.updateDzItem(self.selectedUrl, self.selectedName);

                    let index = $('#img_form').data('index');

                    App.imageLayer.addOrUpdateImage('add', index, self.selectedUrl);
                });
            },

            generateImage: function () {

                const self = this;

                $('#ai_images_loading').removeClass('d-none');
                $('#ai_images').addClass('d-none');
                $('#ai_image_form').addClass('d-none');
                $('#ai_images_presets').addClass('d-none');
                $('#ai_no_images_found').addClass('d-none');

                function esc(s){
                    return String(s||'').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
                }

                self.isLoading = true;

                $.ajax({
                    url: self.generateURL,
                    method: 'POST',
                    headers: { "Accept": "application/json" },
                    data: {
                        id: $('#ai_images_presets .js-ai-preset-img.selected').data('id'),
                        text: $('input[name=ai_search]').val()
                    }
                }).done(function(resp) {

                    let image = resp && resp.image ? resp.image : {};

                    $('#ai_images').empty();
                    $('#ai_images').append('<img id="ai_preset_img_' + image.uuid + '" src="' + esc(image.url) + '" alt="' + image.uuid + '" data-name="AI Image ' + image.uuid + '" data-url="' + esc(image.url) + '"/>');

                    $('#sw_ai_modal .js-generate-ai-image, #sw_ai_modal .modal-footer button[data-bs-dismiss="modal"]').addClass('d-none');
                    $('#sw_ai_modal .js-back-to-generation').removeClass('d-none');
                    $('#sw_ai_modal .js-regenerate-ai-image').attr('disabled', false).removeClass('d-none');
                    $('#sw_ai_modal .js-select-ai-image').attr('disabled', false).removeClass('d-none');
                }).always(function () {

                    $('#ai_images_loading').addClass('d-none');
                    $('#ai_images').removeClass('d-none');
                    self.isLoading = false;
                })
            },

            getPresets: function (search_term = null, version = null) {

                let self = this;

                console.log('Search presets');

                let $out = $('#ai_images_presets');

                // Show loading indicators
                $out.html('<ul class="sw-ai-images-presets-list" id="ai_presets_list"></ul>');

                $('#ai_images_loading').removeClass('d-none');
                $('#ai_all_results_loaded').addClass('d-none');
                $('#ai_no_images_found').addClass('d-none');

                self.isLoading = true;

                // Abort any previous in-flight request
                if (self.pendingXhr && self.pendingXhr.readyState !== 4) {
                    try { self.pendingXhr.abort(); } catch(_) {}
                }

                // Keep the version we’re issuing this request for
                let reqVersion = (version != null ? version : ++self.queryVersion);

                console.log('AJAX REACHED, v' + reqVersion);

                self.pendingXhr = $.ajax({
                    url: self.presetsURL,
                    method: 'GET',
                    dataType: 'json',
                    headers: { "Accept": "application/json" },
                }).done(function (resp) {
                    // Ignore stale responses (a newer queryVersion exists)
                    if (reqVersion !== self.queryVersion) {
                        console.log('Stale response ignored, v' + reqVersion + ' != current v' + self.queryVersion);
                        return;
                    }

                    let items = resp && resp.graffities ? resp.graffities : [];

                    if (!items.length) {
                        $('#ai_no_images_found').removeClass('d-none');
                        return;
                    }

                    function esc(s){
                        return String(s||'').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
                    }

                    let buf = [];
                    for (let i = 0; i < items.length; i++) {
                        let it = items[i];
                        let id = it.id;
                        let title = esc(it.name || it.title || '');
                        let thumb = it.thumbnail || null;
                        let url = it.url_suffix || null;
                        if (thumb && url) {
                            buf.push('<li><a href="javascript:;" id="ai_preset_img_'+id+'" class="js-ai-preset-img" data-id="' + esc(id) + '" data-url="' + esc(url) + '" data-name="'+title+'"><img src="' + esc(thumb) + '" alt="' + title + '"><span class="ai-preset-name">' + title + '</span></a></li>');
                        }
                    }

                    $('#ai_presets_list').append(buf.join(''));

                    $('#ai_presets_list li a').first().click();

                    $('#ai_images_presets').removeClass('d-none');
                }).fail(function (xhr) {
                    // Ignore failures from aborted old requests
                    if (xhr && xhr.statusText === 'abort') return;

                }).always(function (_data, textStatus) {
                    // If this request was aborted, don't touch the loader.
                    if (textStatus === 'abort') {
                        self.pendingXhr = null;
                        return;
                    }

                    // Only hide loader if this response matches current version
                    if (reqVersion === self.queryVersion) {
                        $('#ai_images_loading').addClass('d-none');
                        self.isLoading = false;
                    }
                    self.pendingXhr = null;
                });
            },
        }
    },

    textLayer: {
        layer_type: 'text',
        text_color_picker: null,
        typing_timer: null,
        form: '#text_form',
        ratio: 1,
        slider_throttle_timer: null,
        slider_throttle_last: 0,
        SLIDER_THROTTLE_MS: 100,
        text_font_scale_factor: 1.313,
        max_lines: 2,
        max_chars_per_line: 10,

        init: function() {

            let self = this;

            console.log('App.textLayer.init called');

            let text_input = $('#text');

            if (text_input.attr('rows')) {
                self.max_lines = Number(text_input.attr('rows'));
            }

            if (text_input.attr('cols')) {
                self.max_chars_per_line = Number(text_input.attr('cols'));
            }

            console.log('MAX LINES: ', self.max_lines);
            console.log('MAX CHARS PER LINE: ', self.max_chars_per_line);

            // Change any text option
            $(document).on('change', '#text_form', function() {

                console.log('TEXT FORM CHANGE');

                const index = $(this).data('index') || 0;

                if (App.selected_part) {
                    console.log('UPDATE TEXT');
                    clearTimeout(self.slider_throttle_timer);
                    var fire = function() {
                        self.slider_throttle_last = Date.now();
                        App.textLayer.updateText(index);
                    };
                    if (Date.now() - self.slider_throttle_last >= self.SLIDER_THROTTLE_MS) {
                        fire();
                    } else {
                        self.slider_throttle_timer = setTimeout(fire, self.SLIDER_THROTTLE_MS);
                    }
                }
            });

            $(document).on('input', '#text', function() {

                let selected_text = $(this).val();
                let text_array = selected_text.split(/\r\n|\r|\n/g);
                let new_text_array = [];
                let new_text = selected_text;

                console.log('val: ', selected_text);
                console.log('text_array: ', text_array);
                console.log('new_text_array: ', new_text_array);

                $.each(text_array, function (index, line) {

                    console.log('index: ', index);
                    console.log('line: ', line);
                    console.log('line length: ', line.length);


                    if (line.length >= self.max_chars_per_line) {
                        let offset = line;
                        while (offset.length > 0) {
                            new_text_array.push(offset.substring(0, self.max_chars_per_line));
                            offset = offset.substring(self.max_chars_per_line);
                        }

                        console.log('new text array: ', new_text_array);

                    } else {
                        new_text_array.push(line);
                    }

                    if (index === self.max_lines) return false;

                    if (new_text_array.length >= self.max_lines) {
                        new_text_array = new_text_array.slice(0, self.max_lines);
                        return false;
                    }
                });

                if (new_text_array.length) {
                    new_text = new_text_array.join("\n");
                }

                console.log('selected_text: ', selected_text);
                console.log('new_text: ', new_text);
                console.log('new_text !== selected_text: ', new_text !== selected_text);

                if (new_text !== selected_text) {
                    $('#text').val(new_text);
                }

                let text_length = new_text.replace(/\r\n|\r|\n/g, '').length;

                $(this).next().find('.js-characters-count').text(text_length);

                $('#text_form').trigger('change');

                $('#add_text').toggleClass('has-selection', new_text !== '');
            });

            $(document).on('change', '#text_flip', function() {

                let current_value = $(this).prop('checked');

                console.log('current_value: ', current_value);

                if (!current_value && $('#sw_product_config_modal_text_mirroring').length) {
                    $('#sw_product_config_modal_text_mirroring').modal('show');
                }
            });

            if (!self.text_color_picker) {

                self.text_color_picker = Pickr.create({
                    default: '#000000',
                    el: '.js-text-color-picker',
                    useAsButton: true,
                    appClass: 'sw-picker-element',
                    inline: true,
                    showAlways: true,
                    theme: 'monolith', // or 'monolith', or 'nano'
                    components: {

                        // Main components
                        preview: true,
                        hue: true,

                        // Input / output Options
                        interaction: {
                            input: true
                        }
                    }
                });
            }

            self.text_color_picker.on('changestop', (source, instance) => {
                //console.log('Event: "changestop"', source, instance);
                let selected_color = instance.getColor().toHEXA().toString();

                $('#fontColor').val(selected_color).trigger('change');
            });

            self.text_color_picker.on('swatchselect', (source, instance) => {
                //console.log('Event: "changestop"', source, instance);
                let selected_color = instance.getColor().toHEXA().toString();

                $('#fontColor').val(selected_color).trigger('change');
            });

            $(document).on('focus click', '#add_text .pcr-result', function() {
                $(this).select();
            });

            $(document).on('click', '.js-sw-show-text-tab', function() {

                console.log('js-sw-show-text-tab clicked');

                let m_text_tab = $(this).data('tab');

                console.log('m_text_tab: ', m_text_tab);

                self.showLayerTab(m_text_tab);
            });

            $(document).on('click', '.js-sw-show-desk-text-tab', function() {

                console.log('js-sw-show-text-tab clicked');

                let d_text_tab = $(this).data('tab');

                console.log('d_text_tab: ', d_text_tab);

                self.showLayerTab(d_text_tab);
            });

            $(document).on('click', '.js-sw-delete-text-layer', function () {
                const index = $('#text_form').data('index') || 0;
                App.toggleCustomizerButtons(0);
                App.deleteLayer(App.selected_part, 'text', null, index);
            });

            $(document).on('input', '.sw-text-slider', function () {

                let type = $(this).data('type');
                let val  = parseFloat($(this).val());

                switch (type) {
                    case 'rotation':
                        var radians = parseFloat((val * Math.PI / 180).toFixed(6));
                        $('#text_rotation').val(radians);
                        break;
                    case 'font_scale':
                        $('#fontScale').val(val);
                        $('#text_scale_display').text(Math.round(val * 100) + '%');
                        break;
                    case 'position_x':
                        $('#center_text_x').val(val);
                        break;
                    case 'position_y':
                        $('#center_text_y').val(val);
                        break;
                }

                $('#text_form').trigger('change');
            });
        },

        updateTextForm: function(data) {

            let self = this;

            console.log('App.textLayer.updateTextForm with data: ', data);

            // Select the default tab first, so it is always set even if something below fails
            self.showLayerTab(data.text ? 'position' : 'text');

            let font_family = typeof data.fontFamily != 'undefined' ? data.fontFamily : null;
            let font_weight = typeof data.fontWeight != 'undefined' ? data.fontWeight : null;
            let font_style = typeof data.fontStyle != 'undefined' ? data.fontStyle : null;

            console.log('Family: ', font_family);
            console.log('Weight: ', font_weight);
            console.log('Style: ', font_style);

            let flip_on_left = typeof data.flip_on_left != 'undefined' ? data.flip_on_left : true;

            App.updateColorSwatches('text');

            $('#text').val(data.text || '');
            $('#fontColor').val(data.fontColor || '#000000');
            $('#text_rotation').val(data.rotation || 0);
            $('#center_text_x').val(data.center[0]);
            $('#center_text_y').val(data.center[1]);
            $('#fontScale').val(data.fontScale || 0.08);
            $('#fontSpacing').val(data.fontSpacing || 0);
            $('#scale_text_x').val(data.scale[0]);
            $('#scale_text_y').val(data.scale[1]);
            $('#bb_scale_x').val(data.bb_scale ? data.bb_scale[0] : '');
            $('#bb_scale_y').val(data.bb_scale ? data.bb_scale[1] : '');
            $('#padding_text').val(data.padding !== undefined ? data.padding : 0.01);
            $('#text_flip').prop('checked', flip_on_left);

            let text_length = $('#text').val().replace(/\r\n|\r|\n/g, '').length || 0;
            $('.js-characters-count').text(text_length);

            self.text_color_picker.on('show', function() {
                self.text_color_picker.setColor(data.fontColor || '#000000');
            });

            self.textFonts.setFamilyPicker(data.fontFamily || null, data.fontWeight || null, data.fontStyle || null);

            var rot_deg = App.radiansToNormalizedDeg(data.rotation);
            var fs_val  = parseFloat(data.fontScale) || 0.08;
            $('#text_rotation_slider').val(rot_deg);
            $('#text_scale_slider').val(fs_val);
            $('#text_scale_display').text(Math.round(fs_val * 100) + '%');

            if (data.text) {
                $('#add_text').addClass('has-selection');

                const bb = self.measureTextBoundingBoxDiv(data);
                const uv_px = App.uv_size_px || 1024;
                data.bb_scale = [bb.width / uv_px, bb.height / uv_px];
            }
            else {
                $('#add_text').removeClass('has-selection');
            }
        },

        getTextFormData: function() {

            let form_data = $('#text_form').serializeArray();
            let center = [0.0, 0.0];
            let scale = [0.0, 0.0];
            let bb_scale = [0.0, 0.0];
            let text_options = {};

            console.log(form_data);

            if (form_data.length) {

                $.each(form_data, function (i, field) {

                    switch (field.name) {
                        case 'center_x':
                            console.log('Center X value: ', field.value);
                            center[0] = parseFloat(field.value);
                            break;
                        case 'center_y':
                            console.log('Center Y value: ', field.value);
                            center[1] = parseFloat(field.value);
                            break;
                        case 'scale_x':
                            scale[0] = parseFloat(field.value);
                            break;
                        case 'scale_y':
                            scale[1] = parseFloat(field.value);
                            break;
                        case 'bb_scale_x':
                            bb_scale[0] = parseFloat(field.value);
                            break;
                        case 'bb_scale_y':
                            bb_scale[1] = parseFloat(field.value);
                            break;
                        case 'text':
                            text_options[field.name] = field.value;
                            break;
                        case 'fontColor':
                            text_options[field.name] = field.value;
                            text_options['dFontColor'] = field.value;
                            break;
                        case 'fontUrl':
                            text_options[field.name] = field.value;
                            break;
                        case 'fontWeight':
                            text_options[field.name] = field.value;
                            break;
                        case 'fontStyle':
                            text_options[field.name] = field.value;
                            break;
                        case 'fontFamily':
                            text_options[field.name] = field.value;
                            break;
                        case 'flip_on_left':
                            text_options[field.name] = field.value === 'on';
                            break;
                        default:
                            if (field.value && field.value.length) {
                                text_options[field.name] = parseFloat(field.value);
                            }
                    }

                    text_options['center'] = center;
                    text_options['scale'] = scale;
                    text_options['bb_scale'] = bb_scale;
                    text_options['flip_on_left'] = text_options['flip_on_left'] || false;
                });
            }

            console.log('text_options: ', text_options);

            return text_options;
        },

        updateText: function(index) {
            const combined_id  = App.combined_part_id;
            const part_schema  = App.product_schema[App.selected_part];
            const combined_schema = App.product_schema[combined_id];

            // Default опциите идват от панела, но overlay-ът е combined
            const overlay      = combined_schema.overlay;
            const text_entry  = combined_schema.text[index];

            if (part_schema && overlay && text_entry) {
                let text_options = App.textLayer.getTextFormData();

                if (text_options && overlay) {

                    const bb = App.textLayer.measureTextBoundingBoxDiv(text_options);
                    const uv_px = App.uv_size_px || 1024;
                    text_options.bb_scale = [bb.width / uv_px, bb.height / uv_px];
                    $('#bb_scale_x').val(text_options.bb_scale[0]);
                    $('#bb_scale_y').val(text_options.bb_scale[1]);

                    App.saveLayer(combined_id, 'text', text_options, index);
                    App.updateColorSwatches('text');

                    Unlimited3D.updateOverlay({
                        overlay: overlay,
                        overlayEntry: text_entry.name,
                        options: {
                            ...text_options,
                            flipH: App.pair_side === 'left' && !!text_options.flip_on_left
                        }
                    }, function (error, response) {
                        if (error) {
                            console.log('App.textLayer.updateText ERROR: ', error);
                        }
                    });
                } else {
                    alert('Select part with Text overlay');
                }
            }
        },

        deleteTextFrom3d: function(part_name, index) {
            const combined_id = App.combined_part_id || part_name;
            const combined_schema = App.product_schema[combined_id];

            if (typeof combined_schema != 'undefined') {
                const text_entry = Array.isArray(combined_schema.text)
                    ? combined_schema.text[index || 0]
                    : combined_schema.text;
                const overlay = combined_schema.overlay;

                if (text_entry && overlay) {
                    let overlay_entry_name = text_entry['name'];

                    let text_options = {
                        center: text_entry['center'] || [0.00, 0.00],
                        fontColor: text_entry['fontColor'] || '#000000',
                        fontScale: text_entry['fontScale'] || 0.08,
                        fontSpacing: text_entry['fontSpacing'] || 0,
                        fontUrl: text_entry['fontUrl'] || '',
                        fontWeight: text_entry['fontWeight'] || '400',
                        rotation: text_entry['rotation'] || 0,
                        scale: text_entry['scale'] || [0.00, 0.00],
                        text: ''
                    }

                    console.log('Text options: ', text_options);

                    Unlimited3D.updateOverlay({
                        overlay: overlay,
                        overlayEntry: overlay_entry_name,
                        options: text_options
                    }, function(error, response) {
                        if (error) {
                            console.log('App.textLayer.deleteTextFrom3d ERROR: ', error);
                        }
                        else {
                            console.log('DELETE TEXT SUCCESS');
                        }
                    });
                }
                else {
                    alert('Select part with Text overlay');
                }
            }
        },

        textFonts: {

            fonts: [],
            fonts_to_load: 300,
            google_api_key: 'AIzaSyCnt7_hkbLxg20_BLrRcGqDmoTRzzy0gns',
            form: '#text_form',
            family_select: '#fontFamily',
            weight_select: '#fontWeight',
            style_select: '#fontStyle',
            url_input: '#fontUrl',
            default_family: 'Permanent Marker',

            init: function () {

                let self = this;

                let used_fonts = [self.default_family];

                Object.entries(App.layers).map(([key, data]) => {
                    if (data.text && data.text.fontFamily !== self.default_family) {
                        used_fonts.push(data.text.fontFamily);
                    }
                });

                // Get all used in config google fonts
                self.getGoogleFonts(used_fonts);

                // Get 300 google fonts by popularity
                self.getGoogleFonts();

                // Set font family on element
                $(document).on('change', self.family_select, function (e) {

                    console.log('FAMILY CHANGE');

                    // Prevent form change event
                    e.stopPropagation();

                    self.setWeightPicker();
                    self.setStylePicker();
                    self.fillGoogleUrl();
                });

                // Set font weight on element
                $(document).on('change', self.weight_select, function (e) {

                    console.log('WEIGHT CHANGE');

                    // Prevent form change event
                    e.stopPropagation();

                    // Form will change when URL changes
                    self.fillGoogleUrl();
                });

                // Set font style on element
                $(document).on('change', self.style_select, function (e) {

                    console.log('STYLE CHANGE');

                    // Prevent form change event
                    e.stopPropagation();

                    // Form will change when URL changes
                    self.fillGoogleUrl();
                });
            },

            formatState: function(state) {

                return $('<span style="font-family: ' + state.text + '">'+state.text+'</span>');
            },

            getGoogleFonts: function (font_families = []) {

                let self = this;

                console.log('App.textLayer.textFonts.getGoogleFonts called');

                let ajax_url = 'https://www.googleapis.com/webfonts/v1/webfonts?key=' + self.google_api_key + '&sort=popularity';

                if (font_families.length) {
                    font_families.map(family => {
                        ajax_url += '&family=' + family
                    });
                }

                $.ajax({
                    url: ajax_url,
                    type: "GET",
                    async: false,
                    dataType: 'json',
                    success: function (response) {

                        if (typeof response.items != 'undefined' && response.items.length) {

                            console.log('Google API SUCCESS: ', response);

                            let total_fonts_to_load = response.items.length > self.fonts_to_load ? self.fonts_to_load : response.items.length;

                            for (i=0;i<total_fonts_to_load;i++) {

                                let font = response.items[i];
                                let font_weights = [];
                                let font_styles = ['normal'];

                                if (!self.fonts.some(f => f.family === font.family)) {

                                    $.each(font.variants, function(key, variant) {

                                        let variant_cleared = variant.replace('regular', '400');
                                        let weight = variant_cleared.replace(/[^0-9]/gi, '');
                                        let style = variant_cleared.replace(/[0-9]/gi, '');

                                        if (weight.length && $.inArray(weight, font_weights) === -1) {
                                            font_weights.push(weight);
                                        }

                                        if (style.length && $.inArray(style, font_styles) === -1) {
                                            font_styles.push(style);
                                        }
                                    });

                                    self.fonts.push({
                                        family: font.family,
                                        weights: font_weights,
                                        styles: font_styles,
                                    });
                                }
                            }

                            console.log('self.fonts::: ', self.fonts);

                            if (!font_families.length) {
                                self.loadGoogleFonts();
                                self.loadWebFonts();
                            }
                        }
                        else {
                            console.log('Google API error: ', response);
                        }
                    }
                });
            },

            loadGoogleFonts: function() {

                let self = this;

                console.log('App.textLayer.textFonts.loadGoogleFonts called');

                let options_html = '';

                $.each(self.fonts, function(key, element) {
                    options_html += '<option value="' + element.family + '" style="font-family: '+element.family+'">' + element.family + '</option>';
                });

                $(self.family_select).html(options_html);

                $(self.family_select).select2({
                    selectionCssClass: 'form-select',
                    width: '100%',
                    templateResult: self.formatState,
                    templateSelection: self.formatState
                });
            },

            loadWebFonts: function () {

                let self = this;

                console.log('App.textLayer.textFonts.loadWebFonts called');

                let font_families = $.map(self.fonts, function (font) {
                    return font.family;
                });

                console.log('font_families: ', font_families);

                WebFont.load({
                    classes: false, // used to stop adding classes to HTML element
                    google: {
                        families: font_families
                    },
                    active: function() {
                        $('html').addClass('wf-active');
                    },

                });
            },

            setFamilyPicker: function (family, weight, style) {

                let self = this;
                let selected_family = family || null;
                let selected_weight = weight || null;
                let selected_style = style || null;
                let selected_family_option = $(self.family_select).find('option[value="' + selected_family + '"]');

                console.log('App.textLayer.textFonts.setFamilyPicker called');
                console.log('selected_family: ', selected_family);
                console.log('selected_weight: ', selected_weight);
                console.log('selected_style: ', selected_style);

                if (selected_family && selected_family_option.length) {
                    selected_family_option.prop('selected', true).trigger('change');
                }
                else {
                    $(self.family_select).find('option').first().prop('selected', true).trigger('change');
                }

                self.setWeightPicker(selected_weight);
                self.setStylePicker(selected_style);

                // Form will change when URL changes
                self.fillGoogleUrl();
            },

            setWeightPicker: function (weight) {

                let self = this;
                let selected_weight = weight || null;
                let selected_font = $(self.family_select).val();

                console.log('App.textLayer.textFonts.setWeightPicker called for: ', selected_weight);

                $(self.weight_select).html('');

                if (selected_font) {

                    let font_object = self.fonts.filter(e => e.family === selected_font)[0];

                    if (typeof font_object != 'undefined') {

                        $.each(font_object.weights, function (key, weight_value) {
                            $(self.weight_select).append('<option value="'+ weight_value + '">' + weight_value + '</option>');
                        });
                    }
                }

                let selected_weight_option = $(self.weight_select).find('option[value="' + selected_weight + '"]');

                if (selected_weight && selected_weight_option.length) {
                    selected_weight_option.prop('selected', true);
                }
                else {

                    let first_option = $(self.weight_select).find('option').first();

                    console.log('First weight option: ', first_option);
                    console.log('First weight option value: ', first_option.val());

                    $(self.weight_select).find('option').first().prop('selected', true);
                }
            },

            setStylePicker: function (style) {

                let self = this;

                let selected_style = style || null;
                let font_selected = $(self.family_select).val();

                console.log('App.textLayer.textFonts.setStylePicker called for: ', selected_style);

                $(self.style_select).html('');

                if (font_selected) {

                    let font_object = self.fonts.filter(e => e.family === font_selected)[0];

                    $.each(font_object.styles, function (key, style_value) {
                        $(self.style_select).append('<option value="' + style_value + '">' + style_value + '</option>');
                    });
                }

                let selected_style_option = $(self.style_select).find('option[value="' + selected_style + '"]');

                if (selected_style && selected_style_option.length) {
                    selected_style_option.prop('selected', true);
                }
                else {
                    let first_option = $(self.style_select).find('option').first();

                    console.log('First style option: ', first_option);
                    console.log('First style option value: ', first_option.val());

                    first_option.prop('selected', true);
                }
            },

            fillGoogleUrl: function () {

                let self = this;

                console.log('App.textLayer.textFonts.fillGoogleUrl called');

                let font_url = '';
                let family = $(self.family_select).val()
                let weight = $(self.style_select).val() === 'italic' ? 'wght@1,' + $(self.weight_select).val() : 'wght@' +  + $(self.weight_select).val();
                let style = $(self.style_select).val() === 'italic' ? 'ital,' : '';

                console.log('Family: ', family)

                if (typeof family != 'undefined') {
                    let family_query = family.replace(/\s/g, '+');
                    font_url = 'https://fonts.googleapis.com/css2?family=' + family_query + ':'  + style + weight;
                }

                $(self.url_input).val(font_url).trigger('change');
            }
        },

        showLayerTab: function (tab) {

            let self = this;

            let desk_tab = tab;
            let desk_additional_tab = null;

            if (tab === 'position') {
                desk_tab = 'text';
            }

            if (tab === 'color') {
                desk_tab = 'style';
            }

            if (tab === 'text') {
                desk_additional_tab = 'position';
            }

            if (tab === 'style') {
                desk_additional_tab = 'color';
            }

            console.log('App.textLayer.showLayerTab called with tab: ' + tab + ' and desk_tab: ' + desk_tab + ' and desk_additional_tab: ' + desk_additional_tab);

            $('#add_text .js-sw-show-text-tab').removeClass('active');
            $('#add_text .js-sw-show-text-tab[data-tab="'+tab+'"]').addClass('active');

            $('#add_text .js-sw-show-desk-text-tab').removeClass('active');
            $('#add_text .js-sw-show-desk-text-tab[data-tab="'+desk_tab+'"]').addClass('active');

            $('#add_text .js-layer-tab').addClass('d-none').removeClass('d-lg-block');
            $('#add_text .js-layer-tab.tab-' + tab).removeClass('d-none').addClass('d-lg-block');
            $('#add_text .js-layer-tab.tab-' + desk_tab).addClass('d-lg-block');

            if (desk_additional_tab) {
                $('#add_text .js-layer-tab.tab-' + desk_additional_tab).addClass('d-lg-block');
            }
        },

        measureTextBoundingBoxDiv: function(text_options) {
            const self       = this;
            const uv_px      = App.uv_size_px || 1024;
            const fontScale  = text_options.fontScale || 0.08;
            const scale      = text_options.scale || [1, 1];
            const font_px = fontScale * scale[0] * uv_px / self.text_font_scale_factor;

            // Letter spacing: fontScale * scale[0] * uv_px * fontSpacing
            const letter_spacing_px = fontScale * scale[0] * uv_px * (text_options.fontSpacing || 0);

            console.log('[measureTextBoundingBoxDiv] for text_options: ', text_options);

            const el = document.createElement('div');
            el.id = 'sw-text-measure-div';
            el.style.cssText = `
                position: absolute;
                top: -999999;
                left: 0;
                white-space: nowrap;
                font-family: ${text_options.fontFamily || 'sans-serif'};
                font-weight: ${text_options.fontWeight || '400'};
                font-style:  ${text_options.fontStyle  || 'normal'};
                font-size:   ${font_px}px;
                line-height: 1;
                z-index: -1;
                letter-spacing: ${letter_spacing_px}px;
                color:       ${text_options.fontColor  || '#000000'};
            `;
            el.innerHTML = (text_options.text || '').replace(/\n/g, '<br>');

            const existing = document.getElementById('sw-text-measure-div');
            if (existing) existing.remove();

            document.body.appendChild(el);
            const rect = el.getBoundingClientRect();

            const max_w = scale[0] * uv_px;
            const max_h = scale[1] * uv_px;

            console.log('RECT: ', rect);
            console.log('MAX: ', {w: max_w, h: max_h});

            return {
                width:   Math.min(rect.width, max_w),
                height:  Math.min(rect.height, max_h),
                offsetX: 0,
                offsetY: 0,
                font_px: font_px
            };
        },
    },

    radiansToNormalizedDeg: function (radians) {
        let raw = Math.round((parseFloat(radians) || 0) * 180 / Math.PI);
        return ((raw + 180) % 360 + 360) % 360 - 180;
    },

    getDesignColors: function() {

        let self = this;

        console.log('App.getDesignColors called');

        let colors = [];

        $.each(App.layers, function(part, layer) {

            if (typeof layer.bg != 'undefined' && layer.bg.type === 'color') {

                let bg_color = layer.bg.data;

                if ($.inArray(bg_color, colors) === -1) {
                    colors.push(bg_color);
                }
            }

            console.log('layer.text: ', layer.text);

            let text_color = layer.text?.fontColor || null;

            console.log('text_color: ', text_color);

            if (text_color) {
                if ($.inArray(text_color, colors) === -1) {
                    colors.push(text_color);
                }
            }
        });

        return colors;
    },

    updateColorSwatches: function(picker_type) {

        let self = this;

        console.log('App.updateColorSwatches called');

        if (typeof picker_type != 'undefined') {

            let color_picker = picker_type === 'bg' ? App.backgroundLayer.bg_color_picker : App.textLayer.text_color_picker;

            console.log('color_picker: ', color_picker);

            for (let i = 20; i >= 0; i--) {
                color_picker.removeSwatch(i);
            };

            let new_swatches = App.getDesignColors();

            console.log('new_swatches: ', new_swatches);

            if (new_swatches.length) {
                $.each(new_swatches, function(key, color) {
                    color_picker.addSwatch(color);
                });
            }
        }
    },

    design: {

        current_design_uuid: null,

        init: function() {

            let self = this;

            let lineKey = App.getUrlParams('line');
            if (lineKey && open_configurator) {
                App.loadConfigFromCartLine(lineKey);
                return;
            }

            console.log('App.design init product_id: ' + App.product_id + ' and customer.id: ', App.customer.id);

            let saved_design_id = App.getUrlParams('saved_design_id');

            if (saved_design_id && typeof App.customer.id != 'undefined') {
                self.mapDesignAndCustomer(saved_design_id);
            }

            if (typeof App.customer.id != 'undefined') {
                self.getCustomerDesigns(App.customer.id, App.product_id);
            }

            self.current_design_uuid = App.getUrlParams('design_id');

            console.log(' --- current_design_uuid: ', self.current_design_uuid);

            // Show current design in PDP
            if (self.current_design_uuid) {

                App.design.getDesignByUuid(self.current_design_uuid);
            }
            else {
                $('.product-page--left-column').removeClass('d-none');
                //$('.product-page--carousel').removeClass('d-none');

                // let pdp_swiper = new Swiper('#pdp_swiper_slider', {
                //     slidesPerView: 1,
                //     centeredSlides: true,
                //     spaceBetween: 16,
                //     pagination: {
                //         el: ".swiper-pagination",
                //         dynamicBullets: true,
                //         dynamicMainBullets: 3
                //     },
                // });

                // Configurator was opened (?edit=1) but there's no design to load —
                // open it empty instead of leaving the Loading screen up forever
                if (open_configurator) {
                    App.initConfigurator();
                }
            }

            if (self.current_design_uuid && typeof App.customer.id != 'undefined') {

                // Loading a saved design - show "Configure"
                $('.js-sw-show-config .js-customise-label').addClass('d-none');
                $('.js-sw-show-config .js-configure-label').removeClass('d-none');
            }
            else {

                // Show "Create"
                $('.js-sw-show-config .js-customise-label').removeClass('d-none');
                $('.js-sw-show-config .js-configure-label').addClass('d-none');
            }

            $('.product-page--media-loading').addClass('d-none');

            $(document).on('click', '.js-sw-save-design', function () {

                App.check_leave = false;

                App.showLoading();

                self.save(false);
            });
        },

        getDesignData: function() {

            let self = this;

            console.log('App.design.getDesignData called');

            let parse_data = {
                product_id: App.product_id,
                product_name: $('meta[itemprop="name"]').attr('content'),
                product_url: $('meta[itemprop="url"]').attr('content'),
                payload: JSON.stringify({
                    config: App.layers,
                    model_schema: model_data
                }),
                thumbnail: App.thumb,
                type: App.getUrlParams('type') || 'customer_design'
            };

            if (typeof App.customer.id != 'undefined') {

                parse_data['customer_id'] = App.customer.id;
                parse_data['email'] = App.customer.email;
                parse_data['first_name'] = App.customer.first_name;
                parse_data['last_name'] = App.customer.last_name;
            }

            if (self.current_design_uuid) {
                parse_data['uuid'] = self.current_design_uuid;
            }

            return parse_data;
        },

        create: function(parse_data, reload) {

            let self = this;
            let reload_window = reload || false;

            console.log('App.design.create PARSE DATA: ', parse_data);

            let ajax_ur = '/a/spirit-bo/designs/';

            $.ajax({
                url: ajax_ur,
                method: 'POST',
                async: false,
                dataType: 'json',
                headers: { "Accept": "application/json" },
                data: parse_data,
                success: function (response) {

                    console.log('App.design.create RESPONSE: ', response);

                    if (response.errors) {

                        console.log('ERRORS: ', response.errors);

                        if ($.isArray(response.errors)) {
                            let errors_text = 'Errors in request \n' + response.errors.join('\n');
                            alert(errors_text);
                        }
                    }
                    else {

                        if (typeof App.customer.id != 'undefined') {

                            console.log(' --- DESIGN CREATED SUCCESSFULLY --- ');

                            self.current_design_uuid = response.design.uuid;

                            if (reload_window) {
                                self.closeAfterSave();
                            }
                            else {
                                $('#sw_product_config_modal_design_saved').modal('show');
                            }
                        }
                        else {

                            self.current_design_uuid = response.design.uuid;

                            if (!App.getUrlParams('design_id')) {
                                let updated_url = location.href + (location.href.indexOf('?') > -1 ? '&' : '?') + 'design_id=' + response.design.uuid;
                                history.replaceState(history.state, '', updated_url);
                            }

                            let design_url = self.getDesignUrl(response.design.uuid);

                            self.redirecting_to_login = true;
                            window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(design_url);
                        }
                    }
                }
            }).fail(function(data) {

                console.log('ERROR: App.design.create AJAX failed with errors: ', data.responseJSON);

                if (typeof data.responseJSON != 'undefined' && typeof data.responseJSON.errors) {
                    let errors_text = 'Errors in request: \n' + data.responseJSON.errors.join('\n');
                    alert(errors_text);
                }
            }).always(function() {
                if (!self.redirecting_to_login) {
                    App.hideLoading();
                }
            });
        },

        update: function(parse_data, reload) {

            let self = this;
            let reload_window = reload || false;

            console.log('App.design.update PARSE DATA: ', parse_data);

            let ajax_ur = '/a/spirit-bo/designs/';

            $.ajax({
                url: ajax_ur,
                method: 'PUT',
                timeout: 0,
                async: false,
                headers: { "Accept": "application/json" },
                data: parse_data,
                success: function (response) {

                    console.log('App.design.update RESPONSE: ', response);

                    if (response.errors) {

                        console.log('ERRORS: ', response.errors);

                        if ($.isArray(response.errors)) {
                            let errors_text = 'Errors in request \n' + response.errors.join('\n');
                            alert(errors_text);
                        }
                    }
                    else {

                        if (typeof App.customer.id != 'undefined') {

                            console.log(' --- DESIGN UPDATED SUCCESSFULLY --- ');

                            if (reload_window) {
                                self.closeAfterSave();
                            }
                            else {
                                $('#sw_product_config_modal_design_saved').modal('show');
                            }
                        }
                        else {

                            self.current_design_uuid = response.design.uuid;

                            if (!App.getUrlParams('design_id')) {
                                let updated_url = location.href + (location.href.indexOf('?') > -1 ? '&' : '?') + 'design_id=' + response.design.uuid;
                                history.replaceState(history.state, '', updated_url);
                            }

                            let design_url = self.getDesignUrl(response.design.uuid);

                            self.redirecting_to_login = true;
                            window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(design_url);
                        }
                    }
                }
            }).fail(function(data) {

                console.log('ERROR: App.design.update AJAX failed with errors: ', data.responseJSON);

                if (typeof data.responseJSON != 'undefined' && typeof data.responseJSON.errors) {
                    let errors_text = 'Errors in request: \n' + data.responseJSON.errors.join('\n');
                    alert(errors_text);
                }
            }).always(function() {
                if (!self.redirecting_to_login) {
                    App.hideLoading();
                }
            });
        },

        // Redirect to the clean PDP URL after a logged-in "Save & exit", so the
        // page reloads and the customer's designs list picks up the just-saved design
        closeAfterSave: function() {

            App.check_leave = false;

            let clean_url = App.removeUrlParameter(location.href, ['edit', 'line', 'design_id', 'order_id', 'type']);

            window.location.href = clean_url;
        },

        // Associate a design created as guest with the customer once they log in.
        // Called on PDP load when a `saved_design_id` URL param is present, before
        // customer designs are fetched, so the newly linked design shows up right away.
        mapDesignAndCustomer: function(design_id) {

            let self = this;

            console.log('App.design.mapDesignAndCustomer design_id: ', design_id);

            if (typeof App.customer.id == 'undefined' || !design_id) {
                return;
            }

            let ajax_ur = '/a/spirit-bo/designs/customer';

            let parse_data = {
                customer_id: App.customer.id,
                designs: [design_id]
            };

            $.ajax({
                url: ajax_ur,
                method: 'PUT',
                timeout: 0,
                async: false,
                dataType: 'json',
                headers: { "Accept": "application/json" },
                data: parse_data,
                success: function (response) {

                    console.log('App.design.mapDesignAndCustomer RESPONSE: ', response);

                    if (response.errors) {
                        console.log('ERRORS: ', response.errors);
                    }
                }
            }).fail(function (data) {

                console.log('ERROR: App.design.mapDesignAndCustomer AJAX failed!');

                if (typeof data.responseJSON != 'undefined' && typeof data.responseJSON.errors) {
                    let errors_text = 'Errors in request: \n' + data.responseJSON.errors.join('\n');
                    console.log(errors_text);
                }
            }).always(function() {

                // Mapping done (or failed) - drop saved_design_id from the URL either way
                let clean_url = App.removeUrlParameter(location.href, 'saved_design_id');
                history.replaceState({}, '', clean_url);
            });
        },

        getCustomerDesigns: function(customer_id, product_id) {

            let self = this;

            console.log('App.design.getCustomerDesigns customer_id: ' + customer_id || 'null' + ' and product_id: ' + product_id || 'null');

            let ajax_ur = '/a/spirit-bo/designs/customer/' + customer_id;

            if (product_id) {
                ajax_ur += '/product/' + product_id
            }

            $.ajax({
                url: ajax_ur,
                method: 'GET',
                timeout: 0,
                async: false,
                cache: false,
                headers: { "Accept": "application/json" },
                success: function (response) {
                    console.log('App.design.getCustomerDesigns RESPONSE: ', response);

                    if (response.errors) {
                        console.log('ERRORS: ', response.errors);
                    }
                    else {

                        let designs_container = $('.js-my-designs-list');
                        let product_url = $('meta[itemprop="url"]').attr('content');

                        $.each(response.designs, function(key, design) {

                            let delete_url = '/a/spirit-bo/designs/customer/' + (design.customer_id || customer_id) + '/design/' + design.uuid;

                            let thumb = '<li data-design_id="' + design.uuid + '">' +
                                '<a href="' + product_url + '?design_id=' + design.uuid + '" class="design-thumb">' +
                                '<img src="' + design.thumbnail + '" alt="Spirit" /></a>' +
                                '<a href="javascript:;" class="design-delete" data-href="' + delete_url + '" ' +
                                'data-bs-toggle="modal" data-bs-target="#sw_my_designs_delete_modal">' +
                                '<img src="' + designs_container.data('delete_icon') + '" alt="" /></a>' +
                                '</li>';

                            designs_container.append(thumb);
                        });

                        if (response.count_designs >= response.max_designs) {
                            designs_container.find('.js-new-design').closest('li').addClass('disabled');
                        }
                    }
                }
            }).fail(function(data) {
                console.log('ERROR: App.design.getCustomerDesigns AJAX failed!');

                if (typeof data.responseJSON != 'undefined' && typeof data.responseJSON.errors) {
                    let errors_text = 'Errors in request: \n' + data.responseJSON.errors.join('\n');
                    alert(errors_text);
                }
            });
        },

        getDesignByUuid: function(uuid) {

            let self = this;

            console.log('App.design.getDesignByUuid UUID: ', uuid);

            let design_type = App.getUrlParams('type') || 'customer_design';
            let ajax_ur = '/a/spirit-bo/designs/' + uuid + '?type=' + design_type;

            $.ajax({
                url: ajax_ur,
                method: 'GET',
                timeout: 0,
                cache: false,
                headers: { "Accept": "application/json" },
                success: function (response) {
                    console.log('App.design.getDesignByUuid RESPONSE: ', response);

                    if (response.errors) {
                        console.log('ERRORS: ', response.errors);
                        $('.product-page--left-column').removeClass('d-none');
                    }
                    else {

                        let page = $('body').data('page-type');

                        if (page === 'product' && App.product_id === response.design.product_id) {

                            App.thumb = response.design.thumbnail;

                            self.showThumbInPdp();

                            // Add compatability with old saved designs
                            let design_config = response.design.payload['_config'] || response.design.payload['config'];
                            App.layers = design_config || {};

                            console.log('App.layers: ', App.layers);

                            if (open_configurator) {
                                App.initConfigurator();
                            }
                            else if (App.preview_ready && !$.isEmptyObject(App.layers)) {
                                // Preview 3D is already initialised - apply the saved design now
                                App.loadModelConfiguration();
                            }
                        }
                        else {
                            alert('Design product_id does not match current product_id');
                            $('.product-page--left-column').removeClass('d-none');
                        }
                    }
                }
            }).fail(function(data) {
                console.log('ERROR: App.design.getDesignByUuid AJAX failed!');

                if (typeof data.responseJSON != 'undefined' && typeof data.responseJSON.errors) {
                    let errors_text = 'Errors in request: \n' + data.responseJSON.errors.join('\n');
                    console.log('ERRORS: ', errors_text);
                    $('.product-page--left-column').removeClass('d-none');
                }
            });
        },

        showThumbInPdp: function() {

            let self = this;

            console.log('App.designs.showThumbInPdp called');

            let thumb = App.thumb || null;

            // The 3D preview is initialised in App.init() whenever the model
            // container and model_data are present and we are not in the
            // configurator - in that case show the model with the saved
            // configuration instead of a static thumbnail image.
            let has_preview = $('#sw_model_preview').length
                && typeof model_data != 'undefined'
                && !open_configurator
                && !App.preview_failed;

            if (has_preview) {
                $('.sw-saved-design-container').empty().addClass('d-none');
                $('.product-page--left-column').removeClass('d-none');
                $('.product-page--carousel').addClass('d-none');
                $('#sw_product_media').remove();
                return;
            }

            // Fallback - no 3D preview available
            if (thumb) {

                let img_html = '<img class="sw-saved-design-image" src="' + thumb + '" alt="Spirit" />';

                $('.sw-saved-design-container').html(img_html).removeClass('d-none');
                $('.product-page--left-column').addClass('d-none');
                $('.product-page--carousel').addClass('d-none');
                $('#sw_product_media').remove();
            }
            // No 3D and no thumbnail - keep the normal product gallery
            else {
                console.log('showThumbInPdp: no 3D preview and no thumbnail, keeping product gallery');
                $('.product-page--left-column').removeClass('d-none');
                $('.product-page--carousel').removeClass('d-none');
            }
        },

        getDesignUrl: function(uuid) {

            let self = this;
            let design_id = uuid || null;
            let saved_design_url = '';

            console.log('App.design.getDesignUrl called for uuuid: ', uuid);

            let variant_selected = App.getUrlParams('variant');
            let variant = typeof variant_selected != 'undefined' ? '&variant=' + variant_selected : '';

            if (design_id) {
                saved_design_url = $('#config_container').data('page_url') + '?saved_design_id=' + design_id + variant;
            }

            console.log('Saved design URL: ', saved_design_url);

            return saved_design_url;
        },

        save: function(reload) {

            let self = this;
            let reload_window = reload || false;

            console.log('App.design.save called with reload: ', reload_window);

            if (typeof App.default_transition && typeof App.default_transition[App.pair_side] != 'undefined') {

                let transition = App.default_transition[App.pair_side];

                console.log('Transition: ', transition);

                Unlimited3D.activateTransition({
                    transition: transition,
                    duration: 1
                }, function (error, response) {
                    if (error) {
                        console.log('SAVE Design Unlimited3D.activateTransition error: ', error);
                    } else {
                        Unlimited3D.getSnapshot({
                            width: App.thumb_width,
                            height: App.thumb_height,
                            result: "base64"
                        }, function (error, image) {
                            if (error) {
                                console.log('Unlimited3D.getSnapshot ERROR: ', error);
                            } else {
                                console.log('Unlimited3D.getSnapshot SUCCESS');
                                App.thumb = image;

                                let parse_data = self.getDesignData();

                                if (typeof parse_data['uuid'] != 'undefined') {
                                    self.update(parse_data, reload_window);
                                } else {
                                    self.create(parse_data, reload_window);
                                }
                            }
                        });
                    }
                });
            }
            else {

                Unlimited3D.getSnapshot({
                    width: App.thumb_width,
                    height: App.thumb_height,
                    result: "base64"
                }, function (error, image) {
                    if (error) {
                        console.log('Unlimited3D.getSnapshot ERROR: ', error);
                    } else {
                        console.log('Unlimited3D.getSnapshot SUCCESS');
                        App.thumb = image;

                        let parse_data = self.getDesignData();

                        if (typeof parse_data['uuid'] != 'undefined') {
                            self.update(parse_data, reload_window);
                        } else {
                            self.create(parse_data, reload_window);
                        }
                    }
                });
            }
        }
    },

    // Get available unlimited3d data
    get3dData: function () {

        let self = this;

        // getAvailableMaterials
        Unlimited3D.getAvailableMaterials(function (error, result) {

            if (!error) {
                App.data.materials = result;
                console.log('AvailableMaterials: ', App.data.materials);
            } else {
                console.log('getAvailableMaterials ERROR: ', error);
            }

        });

        // getAvailableTransitions
        Unlimited3D.getAvailableTransitions(function (error, result) {
            if (!error) {
                App.data.transitions = result;
                console.log('AvailableTransitions: ', App.data.transitions);
            } else {
                console.log('getAvailableTransitions ERROR: ', error);
            }
        });

        // getVisibleParts
        Unlimited3D.getVisibleParts(function (error, result) {
            if (!error) {
                App.data.parts = result;
                console.log('VisibleParts: ', App.data.parts);
            } else {
                console.log('getVisibleParts ERROR: ', error);
            }
        });

        // getAvailableOverlays
        Unlimited3D.getAvailableOverlays(function (error, result) {
            if (!error) {
                App.data.overlays = result;
                console.log('AvailableOverlays: ', App.data.overlays);
            } else {
                console.log('getAvailableOverlays ERROR: ', error);
            }

        });

    },

    getUrlParams: function (param) {

        let self = this;
        let param_selected = param || null;

        console.log('App.getUrlParams: ', param_selected);

        let params = {};

        location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, key, val) {
            params[key] = val;
        });

        return param_selected ? params[param_selected] : params;
    },

    // Remove URL parameter
    removeUrlParameter: function (url, parameter) {

        let parameters = Array.isArray(parameter) ? parameter : [parameter];

        let urlparts = url.split('?');

        if (urlparts.length >= 2) {

            let parts = urlparts[1].split(/[&;]/g);

            parts = parts.filter(function (part) {
                return !parameters.some(function (p) {
                    return part.lastIndexOf(p + '=', 0) !== -1;
                });
            });

            console.log(' --- URL parts: ', parts)

            url = urlparts[0] + (parts.length > 0 ? '?' + parts.join('&') : "");
            return url;
        } else {
            return url;
        }
    },

    toggleCustomizerButtons: function (disable) {

        let self = this;

        console.log('App.toggleCustomizerButtons ', disable ? 'DISABLE' : 'ENABLE');

        let buttons = $('.js-customizer-disable');

        // if (disable) {
        //     buttons.addClass('disabled');
        // } else {
        //     buttons.removeClass('disabled');
        // }

        buttons.removeClass('disabled');
    },

    storePartsBG: function () {

        App.prev_bg = null;

        if (typeof App.layers[App.selected_part] != 'undefined' && typeof App.layers[App.selected_part].bg != 'undefined') {
            let layer = App.layers[App.selected_part];
            App.prev_bg = {
                part: App.selected_part,
                type: layer.bg.type,
                data: layer.bg.data,
                all_over: layer.bg.all_over
            };
        }

        console.log('App.storePartsBG called and stored: ', App.prev_bg);
    },

    revertPart: function (type, bg_type = null) {

        console.log('App.revertPart called for part: ' + App.selected_part + ' type: ' + type + ' and bg_type: ', bg_type);
        console.log('App.prev_bg: ', App.prev_bg);

        switch (type) {
            case 'bg':
                if (App.prev_bg) {
                    App.revertLayerBackground(App.prev_bg.part, App.prev_bg.type, App.prev_bg.data);
                }
                break;
            case 'text':
                $('.tab-pane.active .sw-text-layer .delete-layer').click();
                break;
            case 'image':
                $('.tab-pane.active .delete-layer[data-type="img"]').click();

                break;
            default:
                console.log('need working background type')
        }
    },

    revertLayerBackground: function (part, type, data) {

        console.log('App.revertLayerBackground called');

        // $('.tab-pane.active .delete-layer[data-type="bg"]').click();

        if (App.prev_bg) {

            let layer = App.prev_bg;

            console.log('REVERT BG for part: ', layer.part);

            const initial_part = App.selected_part;

            App.selected_part = part;

            switch (type) {
                case 'color':
                    App.backgroundLayer.changeBgColor(data);
                    App.backgroundLayer.updateBgColorForm(data, layer.all_over);
                    $('#add_bg_color .pcr-cancel').click();
                    break;
                case 'pattern':
                    App.backgroundLayer.updateBgPatternForm(data, layer.all_over);
                    $(App.backgroundLayer.bg_pattern_form).trigger('change');
                    break;
                case 'image':
                    App.backgroundLayer.updateBgImgForm(data, layer.all_over);
                    $(App.backgroundLayer.bg_image_form).trigger('change');
                    break;
                default:
                    console.log('NO valid layer provided');
            }

            App.selected_part = initial_part;
        }
    },

    // Load design config from a cart line item by its key, then call callback
    loadConfigFromCartLine: function(lineKey) {

        lineKey = decodeURIComponent(lineKey);
        App.editingLineKey = lineKey;

        $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json',
            success: function(cart) {
                let item = (cart.items || []).find(function(i) { return i.key == lineKey; });
                if (item && item.properties && item.properties['_config']) {
                    try {
                        let config = JSON.parse(item.properties['_config']);
                        App.layers = config;
                        App.updateProductConfig(App.layers);
                        console.log('loadConfigFromCartLine: loaded config for line', lineKey);
                    } catch(e) {
                        console.error('loadConfigFromCartLine: error parsing _config', e);
                    }
                } else {
                    console.log('loadConfigFromCartLine: no _config found for line', lineKey);
                }
                App.initConfigurator();
            },
            error: function() {
                console.error('loadConfigFromCartLine: failed to fetch cart');
                App.initConfigurator();
            }
        });
    },

    initConfigurator: function() {

        // Reflect open state in the URL so Back/Forward navigation
        // and page reload correctly know the configurator was open
        if (!App.getUrlParams('edit')) {
            let clean_url = App.removeUrlParameter(location.pathname + location.search, 'design_id');
            let design_param = App.design.current_design_uuid ? '&design_id=' + App.design.current_design_uuid : '';
            let new_url = clean_url + (clean_url.indexOf('?') > -1 ? '&' : '?') + 'edit=1' + design_param;
            history.pushState({sw_configurator: true}, '', new_url);
        }

        if (App.editingLineKey) {
            $('.js-sw-save-design').addClass('d-none');
            $('.js-sw-header-add-to-cart .label').text(theme.translations.update_cart);
        } else {
            $('.js-sw-save-design').removeClass('d-none');
            $('.js-sw-header-add-to-cart .label').text(theme.translations.add_to_cart);
        }

        const initOptions = {...App.product_options, ...App.configurator_options};

        Unlimited3D.init(initOptions, {}, function(e) {
            App.initActions();

            Unlimited3D.changePickingConfig({hoverPeriod: 10}, (error) => {
                if (error) {
                    console.log('Init 3D changePickingConfig error: ', error);
                }
            });

            if (!$.isEmptyObject(App.layers)) {
                App.loadModelConfiguration();
            }

            console.log(`%c✅ Spirit Configurator v${version} initialized!`, 'color: #4CAF50; font-weight: bold; font-size: 14px;');
        });

        App.showConfigurator();
    },

    addToCartAndSaveThumbnail: function() {

        let self = this;

        console.log('App.addToCartAndSaveThumbnail called!');

        // $('.js-sw-header-add-to-cart').find('.label').addClass('d-none');
        // $('.js-sw-header-add-to-cart').find('.spinner').removeClass('d-none');

        App.showLoading();

        let ajax_ur = '/a/spirit-bo/designs/image/create';

        Unlimited3D.getSnapshot({
            width: App.thumb_width,
            height: App.thumb_height,
            result: "base64"
        }, function (error, blob) {
            if (error) {
                console.log('Unlimited3D.getSnapshot ERROR: ', error);
            } else {
                console.log('Unlimited3D.getSnapshot SUCCESS');
                //App.thumb = image;

                $.ajax({
                    url: ajax_ur,
                    method: 'POST',
                    async: false,
                    dataType: 'json',
                    headers: { "Accept": "application/json" },
                    data: {thumbnail: blob},
                    success: function (response) {

                        console.log('App.addToCartAndSaveThumbnail RESPONSE: ', response);

                        if (response.errors) {

                            console.log('ERRORS: ', response.errors);

                            if ($.isArray(response.errors)) {
                                let errors_text = 'Errors in request \n' + response.errors.join('\n');
                                alert(errors_text);
                            }
                        }
                        else {
                            $('#design_img').val(response.image.url);

                            if (App.editingLineKey) {
                                App.updateCartLineConfig(response.image.url);
                            } else {
                                $('.product-buy-buttons--form .js-sw-add-to-cart-pdp').click();
                            }
                        }
                    }
                }).fail(function(data) {

                    console.log('ERROR: App.addToCartAndSaveThumbnail thumbnail create AJAX failed with errors: ', data.responseJSON);

                    if (typeof data.responseJSON != 'undefined' && typeof data.responseJSON.errors) {
                        let errors_text = 'Errors in request: \n' + data.responseJSON.errors.join('\n');
                        alert(errors_text);
                    }
                }).always(function() {
                    App.hideLoading();
                });
            }
        });
    },

    // Update the properties of an existing cart line (used when saving edits from the cart Edit flow)
    updateCartLineConfig: function(designImageUrl) {

        let lineKey = App.editingLineKey;

        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            data: {
                id: lineKey,
                properties: {
                    _config: $('#config').val(),
                    _schema: $('#schema').val(),
                    _design: designImageUrl
                }
            },
            success: function(cart) {
                App.editingLineKey = null;
                theme.partials.Cart.updateAllHtml(function() {
                    theme.partials.OffCanvas.right_sidebar.attr('data-active', 'cart');
                    if (theme.partials.OffCanvas.state === 'closed') {
                        theme.partials.OffCanvas.right_sidebar_view = 'cart';
                        theme.partials.OffCanvas.openRight();
                    }
                });
            },
            error: function() {
                console.error('updateCartLineConfig: failed to update cart line');
            },
            complete: function() {
                App.hideLoading();
            }
        });
    },

    convertBlobToFile: function(imageBlob, filename) {

        let self = this;

        console.log('App.convertBlobToFile with filename: ' + filename + ' and blob: ', imageBlob);

        let arr = imageBlob.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[arr.length - 1]),
            n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type: mime});
    },

    extractUV(data) {
        return {u: Number(data[0]), v: Number(data[1])};
    },

    modelActions: {
        isDragging: false,
        prevUV: null,           // UV от предишния frame

        onPointerClick: function (object) {
            let self = this;

            if (!$.isEmptyObject(object) && object[0].type === 'part') {

                const combined_id   = App.combined_part_id;
                const items = object.filter(d => d.type === 'part') || [];



                const part = App.getAvailableClickedPart(object);
                const combined_items = items?.filter(i => i.shortName === combined_id) || [];
                const combined_item = combined_items.length ? combined_items.pop() : null;
                const combined_uv            = combined_item && combined_item.uv ? App.extractUV(combined_item.uv) : null;

                const part_items = items?.filter(i => i.shortName === part) || [];
                const part_item = part_items.length ? part_items.pop() : null;
                const part_uv = part_item && part_item.uv ? App.extractUV(part_item.uv) : null;


                const clickedLayer = combined_uv ? self.getLayerAtUV(combined_uv, part) : null;
                const clickedPartLayer = part_uv ? self.getLayerAtUV(part_uv, part) : null;


                console.log('[onPointerClick] items: ', items);
                console.log('[onPointerClick] part: ', part);
                console.log('[onPointerClick] combined_items: ', combined_items);
                console.log('[onPointerClick] combined_item: ', combined_item);
                console.log('[onPointerClick] part_items: ', part_items);
                console.log('[onPointerClick] part_item: ', part_item);
                console.log('[onPointerClick] clickedLayer: ', clickedLayer);
                console.log('[onPointerClick] clickedPartLayer: ', clickedPartLayer);

                if (clickedLayer) {
                    // Layer clicked — set selected_part from layer panel, open edit form
                    App.selected_part = part;
                    self.selectLayer(clickedLayer);
                    App.storePartsBG();

                } else {
                    // Part clicked — clear selected layer, open tab
                    App.setSelectedLayer(null);
                    $('.action-container').addClass('d-none');
                    $('#components').removeClass('d-none');
                    App.toggleCustomizerButtons(0);

                    if (part) {
                        let tab_id = App.product_schema[part]?.tab || null;
                        if (tab_id) {
                            let $tab = $('#' + tab_id);
                            if (!$tab.hasClass('active')) {
                                $tab.tab('show');
                            } else {
                                let tab_part = App.getPartFromTab(tab_id);
                                App.rotateToPart(tab_part, true);
                            }
                        }
                    }
                }
            }
        },

        isPointerOnLayer: function(uv, layer) {
            const px = uv.u - 0.5;
            const py = uv.v - 0.5;
            const cx = layer.data.center[0];
            const cy = layer.data.center[1];
            const sw = layer.data.bb_scale?.[0] || layer.data.scale[0];
            const sh = layer.data.bb_scale?.[1] || layer.data.scale[1];
            const rotation = layer.data.rotation || 0;

            if (!sw || !sh) return false;

            const dx     = px - cx;
            const dy     = py - cy;
            const cos    = Math.cos(rotation);
            const sin    = Math.sin(rotation);
            const localX = dx * cos - dy * sin;
            const localY = dx * sin + dy * cos;

            const hit = Math.abs(localX) <= sw / 2 && Math.abs(localY) <= sh / 2;
            if (layer.type === 'text') {
                console.log('[isPointerOnLayer] px:', px.toFixed(4), 'py:', py.toFixed(4),
                    'cx:', cx.toFixed(4), 'cy:', cy.toFixed(4),
                    'sw:', sw.toFixed(4), 'sh:', sh.toFixed(4),
                    'localX:', localX.toFixed(4), 'localY:', localY.toFixed(4),
                    'hit:', hit);
            }
            return hit;
        },

        onPointerDown: function(uv) {
            const self = this;
            console.log('[modelActions] onPointerDown App.selected_layer:', App.selected_layer);

            if (!App.selected_part || !App.selected_layer) return;

            if (App.selected_layer.type === 'bg' &&
                App.layers[App.selected_part]?.bg?.type === 'color') return;

            const isPointerOnLayer = self.isPointerOnLayer(uv, App.selected_layer);
            const isAllOverBg = App.selected_layer.type === 'bg' && $('.js-bg-all-over').is(':checked');

            console.log('[modelActions] onPointerDown isAllOverBg: ', isAllOverBg)

            if (!isPointerOnLayer && !isAllOverBg) return;

            self.isDragging = true;
            self.prevUV     = uv;
            Unlimited3D.enableCameraControls({ enable: false }, function() {});
        },

        onPointerMove: function(uv) {
            const self = this;

            if (!self.isDragging || !App.selected_layer || !self.prevUV) return;

            // Calculate delta from previous frame
            const du = uv.u - self.prevUV.u;
            const dv = uv.v - self.prevUV.v;

            // Check if there is а significant move
            if (Math.abs(du) < 0.0005 && Math.abs(dv) < 0.0005) return;

            self.prevUV = uv;

            const layer     = App.selected_layer;
            const part      = App.selected_part;
            const schema    = App.product_schema[part];
            const layerData = layer.data;

            // Get the new center
            const newCenter = [
                layerData.center[0] + du,
                layerData.center[1] + dv
            ];

            // Clamp newCenter to the union of all single panel focus areas
            const uv_size = App.uv_size_px || 1024;
            const focus_rects = Object.values(App.product_schema)
                .filter(s => s.focus_area_px)
                .map(s => {
                    const fa = s.focus_area_px;
                    return {
                        min_x: fa.left / uv_size - 0.5,
                        max_x: (fa.left + fa.width) / uv_size - 0.5,
                        min_y: 0.5 - (fa.top + fa.height) / uv_size,
                        max_y: 0.5 - fa.top / uv_size
                    };
                });

            if (focus_rects.length) {
                const x = newCenter[0];
                const y = newCenter[1];

                const inAny = focus_rects.some(r => x >= r.min_x && x <= r.max_x && y >= r.min_y && y <= r.max_y);

                if (!inAny) {
                    let bestX = x, bestY = y, bestDist = Infinity;
                    for (const r of focus_rects) {
                        const cx = Math.max(r.min_x, Math.min(r.max_x, x));
                        const cy = Math.max(r.min_y, Math.min(r.max_y, y));
                        const dist = (x - cx) ** 2 + (y - cy) ** 2;
                        if (dist < bestDist) {
                            bestDist = dist;
                            bestX = cx;
                            bestY = cy;
                        }
                    }
                    newCenter[0] = bestX;
                    newCenter[1] = bestY;
                }
            }

            layerData.center = newCenter;

            // Get overlay & overlayEntry from the schema
            let overlay = schema.overlay;
            let overlayEntry;
            const combined_id     = App.combined_part_id;
            const combined_schema = App.product_schema[combined_id];

            if (layer.type === 'img') {
                if (!combined_schema) return;

                const imgSchema = combined_schema.img[layer.index];

                if (!imgSchema) return;

                overlayEntry = imgSchema.name;
                overlay = combined_schema.overlay;

                // Check if combined layer exists before accessing its properties
                if (!App.layers[combined_id] || !App.layers[combined_id].img) return;
                App.layers[combined_id].img[layer.index] = layerData;
            }
            else if (layer.type === 'text') {
                if (!combined_schema) return;

                const textSchema = combined_schema.text[layer.index];

                if (!textSchema) return;

                overlayEntry = textSchema.name;
                overlay = combined_schema.overlay;

                if (!App.layers[combined_id] || !App.layers[combined_id].text) return;
                App.layers[combined_id].text[layer.index] = layerData;
            }
            else if (layer.type === 'bg') {
                const bgSchema = App.product_schema[part].bg;

                if (!bgSchema) return;

                overlayEntry = bgSchema.name;

                if (!App.layers[part] || !App.layers[part].bg) return;
                App.layers[part].bg.data = layerData;

                const all_over = $('.js-bg-all-over').is(':checked');

                if (all_over) {
                    $.each(App.available_parts, function(i, p) {
                        const pSchema = App.product_schema[p];
                        if (!pSchema || !pSchema.bg) return;
                        if (!App.layers[p] || !App.layers[p].bg) return;
                        App.layers[p].bg.data = layerData;
                        Unlimited3D.updateOverlay({
                            overlay:      pSchema.overlay,
                            overlayEntry: pSchema.bg.name,
                            options: { center: newCenter }
                        }, function(error) {
                            if (error) console.warn('[modelActions] updateOverlay bg all_over error:', error);
                        });
                    });
                    return;
                }
            }

            // Set the new overlayEntry position in 3D
            Unlimited3D.updateOverlay({
                overlay:      overlay,
                overlayEntry: overlayEntry,
                options: {
                    center: newCenter
                }
            }, function(error) {
                if (error) console.warn('[modelActions] updateOverlay error:', error);
            });
        },

        onPointerUp: function() {
            const self = this;

            console.log('[modelActions] onPointerUp App.selected_part: ', {'App.selected_part': App.selected_part, 'App.selected_layer: ': App.selected_layer});

            if (App.selected_part && App.selected_layer && self.isDragging) {
                // Save the final configuration
                App.updateProductConfig(App.layers);

                // Update form data
                if (App.selected_layer.type === 'img') {
                    const newCenter = App.selected_layer.data.center;

                    // Update Image form
                    $('#center_img_x').val(newCenter[0]);
                    $('#center_img_y').val(newCenter[1]);
                }
                else if (App.selected_layer.type === 'text') {
                    const newCenter = App.selected_layer.data.center;

                    // Update Text form
                    $('#center_text_x').val(newCenter[0]);
                    $('#center_text_y').val(newCenter[1]);
                }
                else if (App.selected_layer.type === 'bg') {
                    const part    = App.selected_part;
                    const newCenter = App.selected_layer.data.center;
                    const x = newCenter[0];
                    const y = newCenter[1];

                    // Update Image BG form
                    if (App.layers[part].bg.type === 'image') {
                        $('#center_bg_x').val(x);
                        $('#center_bg_y').val(y);
                    }

                    // Update Pattern BG form
                    if (App.layers[part].bg.type === 'pattern') {
                        $('#center_bg_pattern_x').val(x);
                        $('#center_bg_pattern_y').val(y);
                    }
                }

                // Set layer panel
                const new_panel = App.setLayerPanel(App.selected_layer.type, App.selected_layer.index);

                // Update selected part
                if (new_panel && new_panel !== App.selected_part) {
                    App.selected_part = new_panel;
                }
            }

            self.isDragging    = false;
            self.prevUV        = null;

            Unlimited3D.enableCameraControls({ enable: true }, function() {});
        },

        getLayerAtUV: function(uv, part) {
            const self = this;
            const combined_id = App.combined_part_id;
            const part_config = App.layers[part];
            const combined_config = combined_id ? App.layers[combined_id] : null;

            console.log('[getLayerAtUV] uv:', uv);
            console.log('[getLayerAtUV] combined_id:', combined_id);
            console.log('[getLayerAtUV] combined_config:', combined_config);
            console.log('[getLayerAtUV] px:', uv.u - 0.5, 'py:', uv.v - 0.5);

            console.log('[getLayerAtUV] part:', part);
            console.log('[getLayerAtUV] part_config:', part_config);



            let candidates = [];

            if (combined_config) {
                // Image layers
                if (Array.isArray(combined_config.img)) {
                    combined_config.img.forEach(function(layer, index) {
                        if (layer && layer.center && layer.scale) {
                            candidates.push({ type: 'img', index: index, data: layer });
                        }
                    });
                }

                // Text layer
                if (combined_config && Array.isArray(combined_config.text)) {
                    combined_config.text.forEach(function(layer, index) {
                        if (layer && layer.center && layer.scale) {
                            candidates.push({ type: 'text', index: index, data: layer });
                        }
                    });
                }

                console.log('[getLayerAtUV]  candidates: ', candidates);

                // Hit test for img & text
                for (const candidate of candidates.slice().reverse()) {
                    const isPointerOnLayer = self.isPointerOnLayer(uv, candidate);

                    console.log('[getLayerAtUV] IMG/TEXT isPointerOnLayer:', isPointerOnLayer);

                    if (isPointerOnLayer) {
                        return candidate;
                    }
                }
            }

            console.log('[getLayerAtUV] BG candidates: ', part_config?.bg?.data || null);

            if (!part_config) return null;

            // BG — tiling покрива целия панел, връща се като fallback
            if (part_config.bg && part_config.bg.data) {
                const bgData = part_config.bg.data;

                if (part_config.bg && part_config.bg.type === 'color') {
                    return { type: 'bg', index: null, data: bgData };
                }

                if (bgData.tiling) {
                    return { type: 'bg', index: null, data: bgData };
                }

                // За non-tiling bg — OBB check
                if (bgData.center && bgData.scale) {
                    const bgLayer = { type: 'bg', index: null, data: bgData };
                    const isPointerOnLayer = self.isPointerOnLayer(uv, bgLayer);

                    console.log('[getLayerAtUV] BG isPointerOnLayer:', isPointerOnLayer);

                    if (isPointerOnLayer) {
                        return bgLayer;
                    }
                }
            }

            return null;
        },

        selectLayer: function(layer) {
            if (!layer) return;

            // Провери дали е различен от текущо избрания
            const current = App.selected_layer;
            if (current && current.type === layer.type && current.index === layer.index) return;

            App.setSelectedLayer(layer);

            const combined_id = App.combined_part_id;

            if (layer.type === 'img') {
                $('#img_form').data('index', layer.index);
                App.prev_image = layer.data;
                App.imageLayer.updateImgForm(layer.data);
                $('.action-container').addClass('d-none');
                $('#add_image').removeClass('d-none');
                App.toggleCustomizerButtons(1);
            }
            else if (layer.type === 'text') {
                const text_schema = App.product_schema[combined_id]?.text?.[layer.index];
                $('#text_form').data('index', layer.index);
                App.prev_text_schema = text_schema;
                App.prev_text        = layer.data;
                App.textLayer.updateTextForm(layer.data);
                $('.action-container').addClass('d-none');
                $('#add_text').removeClass('d-none');
                App.toggleCustomizerButtons(1);

            }
            else if (layer.type === 'bg') {
                const bg_config = App.layers[App.selected_part]?.bg;
                const bg_type = bg_config?.type;

                $('.action-container').addClass('d-none');

                if (bg_type === 'color') {
                    $('#add_bg_color').removeClass('d-none');
                    App.backgroundLayer.updateBgColorForm(bg_config.data, bg_config.all_over);
                } else if (bg_type === 'pattern') {
                    $('#add_bg_pattern').removeClass('d-none');
                    App.backgroundLayer.updateBgPatternForm(bg_config.data, bg_config.all_over);
                } else {
                    $('#add_bg_image').removeClass('d-none');
                    App.backgroundLayer.updateBgImgForm(bg_config.data, bg_config.all_over);
                }

                App.toggleCustomizerButtons(1);
            }
        },
    },

    setLayerPanel: function(type, index) {

        if (type !== 'img' && type !== 'text') return null;

        const combined_id = App.combined_part_id;
        if (!combined_id) return null;

        const combined_layers = App.layers[combined_id];
        if (!combined_layers || !Array.isArray(combined_layers[type])) return null;

        const layer = combined_layers[type][index];

        if (!layer || !layer.center || !layer.scale) return null;

        const uv_size = App.uv_size_px || 1024;

        // Конвертирай layer OBB → 4 ъгъла в пикселно пространство
        const cx_px = (layer.center[0] + 0.5) * uv_size;
        const cy_px = (0.5 - layer.center[1]) * uv_size;
        const hw    = (layer.scale[0] / 2) * uv_size;
        const hh    = (layer.scale[1] / 2) * uv_size;
        const rot   = layer.rotation || 0;
        const cosr  = Math.cos(rot);
        const sinr  = Math.sin(rot);

        const corners = [
            { x: cx_px + (-hw * cosr - (-hh) * sinr),  y: cy_px - (-hw * sinr + (-hh) * cosr) },
            { x: cx_px + ( hw * cosr - (-hh) * sinr),  y: cy_px - ( hw * sinr + (-hh) * cosr) },
            { x: cx_px + ( hw * cosr - ( hh) * sinr),  y: cy_px - ( hw * sinr + ( hh) * cosr) },
            { x: cx_px + (-hw * cosr - ( hh) * sinr),  y: cy_px - (-hw * sinr + ( hh) * cosr) },
        ];

        // Sutherland-Hodgman: clip polygon срещу един axis-aligned half-plane
        function clipEdge(poly, inside, intersect) {
            if (!poly.length) return [];
            const out = [];
            const n = poly.length;
            for (let i = 0; i < n; i++) {
                const curr = poly[i];
                const prev = poly[(i - 1 + n) % n];
                const curr_in = inside(curr);
                const prev_in = inside(prev);
                if (curr_in) {
                    if (!prev_in) out.push(intersect(prev, curr));
                    out.push(curr);
                } else if (prev_in) {
                    out.push(intersect(prev, curr));
                }
            }
            return out;
        }

        // Изчисли площта на пресичане между corners и дадена focus_area_px
        function overlapArea(focus) {
            const fLeft   = focus.left;
            const fRight  = focus.left + focus.width;
            const fTop    = focus.top;
            const fBottom = focus.top + focus.height;

            let poly = corners;

            // Clip срещу 4-те страни на AABB
            poly = clipEdge(poly,
                p => p.x >= fLeft,
                (a, b) => { const t = (fLeft - a.x) / (b.x - a.x); return { x: fLeft,   y: a.y + t * (b.y - a.y) }; }
            );
            poly = clipEdge(poly,
                p => p.x <= fRight,
                (a, b) => { const t = (fRight - a.x) / (b.x - a.x); return { x: fRight,  y: a.y + t * (b.y - a.y) }; }
            );
            poly = clipEdge(poly,
                p => p.y >= fTop,
                (a, b) => { const t = (fTop - a.y) / (b.y - a.y); return { x: a.x + t * (b.x - a.x), y: fTop    }; }
            );
            poly = clipEdge(poly,
                p => p.y <= fBottom,
                (a, b) => { const t = (fBottom - a.y) / (b.y - a.y); return { x: a.x + t * (b.x - a.x), y: fBottom }; }
            );

            if (poly.length < 3) return 0;

            // Shoelace formula за площ на полигон
            let area = 0;
            for (let i = 0; i < poly.length; i++) {
                const j = (i + 1) % poly.length;
                area += poly[i].x * poly[j].y - poly[j].x * poly[i].y;
            }
            return Math.abs(area) / 2;
        }

        // Изчисли площта за всеки панел
        const panel_scores = {};
        Object.entries(App.product_schema).forEach(function([part_key, part_schema]) {
            if (!part_schema.focus_area_px) return;
            panel_scores[part_key] = overlapArea(part_schema.focus_area_px);
        });

        // Вземи панела с най-голяма пресечна площ
        const sorted = Object.entries(panel_scores).sort((a, b) => b[1] - a[1]);
        if (!sorted.length || sorted[0][1] === 0) return null;

        const best_panel = sorted[0][0];
        layer.panel = best_panel;

        App.setSelectedLayer({ type: type, index: index, data: layer });

        console.log('[setLayerPanel] type:', type, 'index:', index, 'areas (px²):', panel_scores, '→', best_panel);
        return best_panel;
    },
}

let open_configurator = App.getUrlParams('edit') || false;

console.log('--- OPEN CONFIGURATOR: ', open_configurator);

if (open_configurator) {
    App.showLoading();
}

$(document).ready(function () {
    App.loadUnlimited3D(() => {
        App.init();
    });
});
